<template>
  <section class="workflow-view !bg-[#F8F8F8]">
    <div v-loading="loading">
      <div class="pageTopBar !bg-white relative" v-if="!fromEntityData">
        <el-row type="flex" align="middle">
          <el-col :span="6">
            <div class="d-flex align-center">
              <el-popconfirm
                title="Are you sure to Exit?"
                @confirm="backToAllFormBuilders()"
                confirm-button-text="Yes"
                cancel-button-text="No"
              >
                <el-button
                  slot="reference"
                  class="bg-transparent !border border-black/20 hover:!border-brand-300 active:!border-brand-500 !py-[6px] !px-2 !rounded-sm hover:!bg-gray-100"
                  :style="
                    getIsMobile ? 'margin-bottom:50px' : 'margin-left: 4px; border-radius: 4px'
                  "
                >
                  <img src="@/assets/img/icons/new/left-back-icon.svg" alt="" class="!size-3" />
                </el-button>
              </el-popconfirm>
              <div class="icon-text">
                <div class="text-sm pl-15 captilize !mb-0 form-heading">
                  {{ action }} Form builder
                </div>
              </div>
            </div>
          </el-col>
          <el-col class="text-sm" v-if="!formBuilderId && !fromEntityData" :span="12">
            <el-steps
              :active="activeStep"
              finish-status="success"
              align-center
              class=""
              id="entityStepper"
            >
              <el-step title="Form Builder Details" @click.native="backToStepOne()"></el-step>
              <el-step title="Build Form Builder" @click.native="backToStepTwo()"></el-step>
              <el-step title="Form Builder Settings" @click.native="backToStepThree()"></el-step>
            </el-steps>
          </el-col>
          <el-col v-else :span="12">
            <!-- <div class="steps-radio-group text-center">
            <div class="el-radio-group">-->
            <el-steps
              :active="activeStep"
              finish-status="success"
              align-center
              class=""
              id="entityStepper"
            >
              <el-step title="Form Builder Details" @click.native="backToStepOne()"></el-step>
              <el-step
                title="Build Form Builder"
                :disabled="!formBuilder.name"
                @click.native="backToStepTwo()"
              ></el-step>
              <el-step title="Form Builder Settings" @click.native="backToStepThree()"></el-step>
            </el-steps>
            <!-- </div>
            </div>-->
          </el-col>
          <el-col :span="6" class="flex justify-end">
            <el-button
              class="!py-1.5 !px-4 text-white !bg-brand-500 text-xs !border-none rounded-md overflow-hidden save-btn"
              :disabled="disableSaveAndNextButton()"
              @click="goToNextStep"
              v-if="activeStep == 1"
              icon="el-icon-circle-check"
              :style="
                getIsMobile
                  ? 'white-space: normal;padding: 6px 12px'
                  : 'white-space: normal;padding: 6px 12px'
              "
            >
              Save Steps
            </el-button>

            <el-button
              style="background: var(--brand-500) !important"
              class="!py-1.5 !px-4 text-white text-xs !border rounded-md overflow-hidden"
              :disabled="disableSaveAndNextButton()"
              @click="goToNextStep"
              v-if="activeStep == 2"
            >
              {{ getIsMobile ? 'Save' : 'Save Form builder' }}
            </el-button>
          </el-col>
        </el-row>
      </div>

      <div class="rounded-[12px]">
        <el-form label-position="right">
          <div class="!bg-[#f8f8f8] !border-[#E9EBEC] !rounded-[12px]">
            <el-row
              v-if="activeStep == 0"
              type="flex"
              justify="center"
              class="h-[calc(100vh-75px)] !overflow-y-auto"
            >
              <el-col :span="10">
                <!-- <el-scrollbar wrap-style="max-height: 80vh; padding: 20px;"> -->
                <div
                  class="workflow-details !bg-white p-3 rounded-xl border borde-[#0000000F] flex flex-col gap-1.5 w-full h-full"
                >
                  <div class="title">
                    <el-form-item label="Name">
                      <el-input
                        class="!rounded-[6px] shadow-none"
                        placeholder="Form builder name"
                        type="text"
                        maxlength="70"
                        v-model="formBuilder.name"
                      >
                        <template slot="prepend">
                          <div class="icon-dropdown-selection shadow-none">
                            <el-button @click="iconPickerdialogVisible = true">
                              <div class="flex items-center gap-1 !bg-white">
                                <span>
                                  <div class="card-icon">
                                    <icons
                                      class="!text-brand-500"
                                      :iconName="formbuilderIconPath"
                                    ></icons>
                                  </div>
                                </span>
                                <i class="el-icon-circle-plus w-[30px] !text-brand-500"></i>
                              </div>
                            </el-button>
                          </div>
                        </template>
                      </el-input>
                    </el-form-item>
                  </div>

                  <p class="error" v-if="errors && errors.name">
                    {{ errors.name }}
                  </p>
                  <el-form-item>
                    <div
                      v-if="formBuilder.logo"
                      class="logo-edit !flex items-center !gap-4 !py-1 !px-4"
                      id="logoBody"
                    >
                      <icons :iconName="'FormTemplates'"></icons>
                      <div class="edit-box flex-1 flex items-center justify-between">
                        <img
                          v-if="formBuilder.logo"
                          :src="formBuilder.logo"
                          alt="Form builder Logo"
                          style="height: 40px; width: auto"
                        />
                        <div class="flex items-center !gap-1.5">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="Edit logo"
                            placement="top-start"
                          >
                            <el-link
                              icon="el-icon-edit"
                              :underline="false"
                              type="warning"
                              @click="openLogoModal"
                            ></el-link>
                          </el-tooltip>
                          <el-tooltip
                            class="item"
                            effect="dark"
                            content="Delete logo"
                            placement="top-start"
                          >
                            <el-link
                              icon="el-icon-delete"
                              class="ml-1 mr-1"
                              :underline="false"
                              type="danger"
                              @click="formBuilder.logo = ''"
                            ></el-link>
                          </el-tooltip>
                        </div>
                      </div>
                    </div>
                    <el-button
                      class="!h-fit !m-0 !py-1.5 !px-4 !bg-brand-100 !border !border-dashed !border-brand-500 rounded-md overflow-hidden"
                      @click="openLogoModal"
                      v-else
                    >
                      <div class="text-sm flex items-center justify-center gap-2">
                        <span>
                          <img
                            class="svgthemecolor"
                            src="../../assets/img/icons/new/uploadblue-icon.svg"
                          />
                        </span>
                        <span class="text-xs text-brand-500">Upload logo</span>
                      </div>
                    </el-button>
                  </el-form-item>
                  <p class="error" v-if="errors && errors.logo">
                    {{ errors.logo }}
                  </p>
                  <el-form-item label="Which type of user can fill out the form?" class="w-full">
                    <div>
                      <el-tooltip placement="top" effect="light">
                        <div slot="content">
                          <p>
                            <strong>Company Users:</strong>
                            Company users are individuals with administrative permissions within the
                            system (e.g., Admins).
                          </p>
                          <p>
                            <strong>Application Users:</strong>
                            Application users are individuals who can log in to the user side of the
                            application (e.g., Employees).
                          </p>
                          <p>
                            <strong>Anyone:</strong>
                            Anyone refers to any person or individual, without specifying a
                            particular person, whose data is collected using their email address.
                          </p>
                          <p>
                            <strong>Anonymous:</strong>
                            Anonymous refers to someone whose identity is not known or disclosed.
                          </p>
                        </div>
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </div>

                    <el-select
                      placeholder="Select user type"
                      v-model="formBuilder.form_builders_owner"
                      :filterable="true"
                      class="w-100"
                      @change="setFormbuilderData"
                    >
                      <el-option
                        v-for="(ownerType, index) of allOwnerTypes"
                        :key="index"
                        :label="ownerType.label"
                        :value="ownerType.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <p class="error" v-if="errors && errors.form_builders_owner">
                    {{ errors.form_builders_owner }}
                  </p>

                  <el-form-item
                    class="w-full flex flex-col gap-1"
                    v-if="formBuilder.form_builders_owner == 'USER'"
                  >
                    <label class="!pb-2" for="">Who can fill out the form?</label>
                    <div class="flex items-center gap-2 w-full">
                      <el-select
                        class="w-full"
                        placeholder="Select Users"
                        v-model="formBuilder.user_type"
                        :filterable="true"
                        :clearable="true"
                        multiple
                        collapse-tags
                      >
                        <el-option
                          v-for="item in getUserTypeList"
                          :key="item._id"
                          :label="getLabel(item)"
                          :value="item._id"
                        ></el-option>
                      </el-select>
                      <el-tooltip
                        content="Add Field Level Permissions"
                        placement="top"
                        v-if="
                          formBuilderId &&
                          formBuilder.user_type &&
                          formBuilder.user_type.length &&
                          formBuilder.allow_field_level_permissions
                        "
                      >
                        <i
                          class="el-icon-setting icon-class text-gray-600 hover:text-brand-500 cursor-pointer text-lg"
                          @click="
                            openFormBuilderSettings(
                              formBuilder.form_builders_owner,
                              formBuilder.user_type
                            )
                          "
                        ></i>
                      </el-tooltip>
                    </div>
                  </el-form-item>
                  <p class="error" v-if="errors && errors.user_type">
                    {{ errors.user_type }}
                  </p>
                  <el-form-item class="w-full" v-if="formBuilder.form_builders_owner == 'ENTITY'">
                    <label class="!pb-2" for="">Who can fill out the form?</label>
                    <div class="flex items-center gap-2 w-full">
                      <el-select
                        class="w-full"
                        placeholder="Select Entity"
                        v-model="formBuilder.entity_id"
                        :filterable="true"
                        :clearable="true"
                        @change="setSettingsEntity"
                      >
                        <el-option
                          v-for="(entity, index) of entitiesData.filter(
                            (e) =>
                              (e.entity_type == 'INDIVIDUAL' || e.entity_type == 'BUSINESS') &&
                              e.type !== 'STANDARD'
                          ) || []"
                          :key="index"
                          :label="entity.name"
                          :value="entity._id"
                        ></el-option>
                      </el-select>
                      <el-tooltip
                        content="Add Field Level Permissions"
                        placement="top"
                        v-if="
                          formBuilderId &&
                          formBuilder.entity_id &&
                          formBuilder.allow_field_level_permissions
                        "
                      >
                        <i
                          class="el-icon-setting icon-class text-gray-600 hover:text-brand-500 cursor-pointer text-lg"
                          @click="
                            openFormBuilderSettings(
                              formBuilder.form_builders_owner,
                              formBuilder.entity_id
                            )
                          "
                        ></i>
                      </el-tooltip>
                    </div>
                  </el-form-item>

                  <p class="error" v-if="errors && errors.entity_id">
                    {{ errors.entity_id }}
                  </p>

                  <el-form-item
                    label=""
                    v-if="
                      formBuilder.form_builders_owner == 'ENTITY' &&
                      formBuilder.entity_id &&
                      formBuilder.settings &&
                      !formBuilder.settings.access_to_all
                    "
                  >
                    <label for="">Filter selected users by?</label>
                    <el-select
                      class="pt-1.5"
                      placeholder="Select filter"
                      v-model="formBuilder.form_builder_filter"
                      :filterable="true"
                      :clearable="true"
                      style="width: 300px"
                    >
                      <el-option
                        v-for="(filter, index) of entityFilters"
                        :key="index + '_filter'"
                        :label="filter.filter_name"
                        :value="filter._id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <p class="error" v-if="errors && errors.form_builder_filter">
                    {{ errors.form_builder_filter }}
                  </p>
                  <el-form-item class="w-full">
                    <label class="!pb-2" for="">Who are the owners of this form?</label>
                    <el-select
                      class="w-full"
                      multiple
                      collapse-tags
                      v-model="formBuilder.form_builder_owners"
                      placeholder="Select Users"
                    >
                      <el-option
                        v-for="user in company_users"
                        :key="user.email"
                        :label="user.email"
                        :value="user._id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item class="!w-full">
                    <label class="pb-1" for="">Who will get Notifications from user?</label>
                    <el-select
                      class="!w-full !pt-1"
                      v-model="formBuilder.contact_email"
                      placeholder="Select User Email"
                    >
                      <el-option
                        v-for="user in company_users"
                        :key="user.email"
                        :label="user.email"
                        :value="user._id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <div>
                    <el-form-item class="w-full">
                      <div class="flex items-center w-full justify-start gap-2">
                        <label for="">Groups</label>
                        <el-tooltip
                          class="flex items-center"
                          content="Add New Group"
                          placement="top"
                          effect="light"
                        >
                          <i class="el-icon-circle-plus" @click="addGroupPopUP"></i>
                        </el-tooltip>
                      </div>
                      <el-col>
                        <el-select
                          class="w-full !pt-1.5"
                          v-model="formBuilder.groups"
                          placeholder="Select Group"
                          multiple
                          filterable
                          collapse-tags
                        >
                          <el-option
                            v-for="(item, index) of getAllEntityGroupsData"
                            v-bind:key="index"
                            :label="item.name"
                            :value="item._id"
                          ></el-option>
                        </el-select>
                      </el-col>
                    </el-form-item>
                    <div class="!pt-0 !mt-0 text-editor" id="des-editor">
                      <label class="label">Description</label>
                      <TextEditor
                        v-if="!loading"
                        :editorData.sync="formBuilder.description"
                      ></TextEditor>
                      <p class="error" v-if="errors && errors.description">
                        {{ errors.description }}
                      </p>

                      <p class="error" v-if="errors && errors.critical_error">
                        {{ errors.critical_error }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="sticky bottom-[-16px] !py-2 !bg-container-background z-[1] border-t border-black/10"
                  >
                    <el-button
                      style="background: var(--brand-500) !important"
                      class="!text-white !px-4 !py-1.5 !rounded-md !text-xs 2xl:text-smd"
                      type="button"
                      :disabled="disableSaveAndNextButton()"
                      @click="goToNextStep"
                    >
                      Save and Next
                      <i class="el-icon-right"></i>
                    </el-button>
                  </div>
                </div>
                <!-- </el-scrollbar> -->
              </el-col>
            </el-row>
            <el-row v-if="activeStep == 1">
              <el-col :span="7">
                <div class="select-steps-form">
                  <el-button
                    class="outlined-icon-button try-with-ai hover:!bg-brand-500 hover:!text-white !flex !items-center !justify-center"
                    @click="openDialog"
                    v-if="getAccessToIncludeAi('include_ai_in_formbuilders')"
                  >
                    <div style="display: flex; align-items: center; justify-content: center">
                      <icons :iconName="'TryUsingAI'"></icons>
                      <div style="margin-left: 8px">Create with AI</div>
                    </div>
                  </el-button>
                  <div class="each-widget">
                    <div class="sticky top-[-8px] !py-2 bg-white">
                      <h4 class="sub-heading">Templates</h4>
                      <el-divider class="!my-2 !bg-gray-100"></el-divider>

                      <div class="!mb-2">
                        <el-input
                          placeholder="Search  by Template name "
                          size="mini"
                          prefix-icon="el-icon-search"
                          v-model="templateSearchString"
                          @input="searchTemplates"
                          clearable
                        ></el-input>
                      </div>
                    </div>

                    <div class="scrollable">
                      <div
                        wrap-style="max-height: 250px;"
                        style="padding-right: 7px"
                        v-if="templatesData && templatesData.length"
                      >
                        <el-button
                          class="list-item !m-[0_0_0.5rem_0]"
                          @click="clickTemplate(template, 'TEMPLATE')"
                          v-for="(template, index) of templatesData"
                          :key="index + '_template'"
                          :disabled="templateAlreadySeleted(template)"
                          style="font-family: var(--font-family)"
                        >
                          <div style="display: flex; align-items: center; gap: 0.5rem">
                            <icons
                              :iconName="template.icon ? template.icon : 'Block-Portfolio'"
                            ></icons>
                            <div class="!text-xs 2xl:text-smd">
                              {{ template.name }}
                            </div>
                            <span v-if="template.type == 'STANDARD'">
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="This is standard template. It can be used to create contacts."
                                placement="right"
                              >
                                <i class="el-icon-info"></i>
                              </el-tooltip>
                            </span>
                          </div>
                        </el-button>
                      </div>
                      <span v-else>
                        {{
                          'No ' +
                          `${templateSearchString.length ? 'results' : 'templates'}` +
                          ' found'
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="each-widget">
                    <div class="sticky top-[-8px] !py-2 bg-white">
                      <h4 class="sub-heading">Entities</h4>
                      <el-divider class="!my-2 !bg-gray-100"></el-divider>
                      <div class="!mb-2">
                        <el-input
                          placeholder="Search by Entity name"
                          size="mini"
                          prefix-icon="el-icon-search"
                          v-model="entitySearchString"
                          @input="searchEntities"
                          clearable
                        ></el-input>
                      </div>
                    </div>

                    <div class="scrollable">
                      <div
                        wrap-style="max-height: 250px;"
                        style="padding-right: 7px"
                        v-if="entitiesData && entitiesData.length"
                      >
                        <el-button
                          class="list-item !m-[0_0_0.5rem_0]"
                          v-for="(entity, index) of entitiesData"
                          @click="clickEntity(entity, 'ENTITY')"
                          :key="index + '_entity'"
                          :disabled="entityAlreadySelected(entity)"
                          style="font-family: var(--font-family)"
                        >
                          <div style="display: flex; align-items: center; gap: 0.5rem">
                            <icons
                              :iconName="entity.icon ? entity.icon : 'Block-Portfolio'"
                            ></icons>
                            <div class="!text-xs 2xl:text-smd">
                              {{ entity.name }}
                            </div>
                          </div>
                        </el-button>
                      </div>
                      <span v-else>
                        {{
                          'No ' +
                          `${entitySearchString.length ? 'results' : 'templates'}` +
                          ' found'
                        }}
                      </span>
                    </div>
                  </div>
                  <div class="each-widget">
                    <div class="sticky top-[-8px] !py-2 bg-white">
                      <h4 class="sub-heading">Components</h4>
                      <el-divider class="!my-2 !bg-gray-100"></el-divider>
                      <div class="scrollable">
                        <div wrap-style="max-height: 250px;" style="padding-right: 7px">
                          <el-button
                            class="list-item !m-[0_0_0.5rem_0]"
                            v-for="(asset, index) of assets"
                            :key="index + '_asset'"
                            @click="clickAssets(asset)"
                            :disabled="assetAlreadySeleted(asset)"
                            style="font-family: var(--font-family)"
                          >
                            <div style="display: flex; align-items: center; gap: 0.5rem">
                              <icons :iconName="'Templates'"></icons>
                              <div class="!text-xs 2xl:text-smd">
                                {{ asset.title || asset.name }}
                              </div>
                            </div>
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="17">
                <div class="workflow-steps">
                  <div class="inner-box" v-if="!formBuilder.steps || !formBuilder.steps.length">
                    <h4 class="text-center">Start Building Form Builder!</h4>
                    <p style="margin-left: 95px">
                      Select existing templates from the left panel or create new ones using AI by
                      clicking the '
                      <b>Create with AI</b>
                      'button
                    </p>
                  </div>
                  <draggable
                    v-model="formBuilder.steps"
                    v-if="formBuilder.steps && formBuilder.steps.length && refresh"
                    :move="checkPosition"
                  >
                    <transition-group tag="div" name="flip-list" id="field-group">
                      <div
                        class
                        v-for="(step, index) of formBuilder.steps"
                        :key="JSON.stringify(step)"
                      >
                        <div class="each-step">
                          <span class="arrow-down"></span>

                          <div>
                            <div
                              class="flex items-center justify-between !py-1.5 !px-2 bg-[#F8F8F8] rounded-[8px_8px_0_0]"
                            >
                              <span class="text-xs 2xl:text-sm text-black-950">
                                Step {{ index + 1 }}
                              </span>
                              <div class="flex items-center !gap-2">
                                <div class="documents-box" v-if="step.type == 'COMPANY_DOCUMENTS'">
                                  <el-tag>
                                    <i class="el-icon-document"></i>
                                    {{
                                      step.company_documents
                                        ? getTotalDocuments(step.company_documents)
                                        : ''
                                    }}
                                  </el-tag>
                                </div>
                                <div class="template-box">
                                  <el-button
                                    v-if="step.type == 'COMPANY_DOCUMENTS'"
                                    icon="el-icon-document"
                                    type="info"
                                    circle
                                    @click="updateStepDocumentData(step, index)"
                                    title="Documents"
                                    plain
                                  ></el-button>
                                  <el-button
                                    icon="el-icon-view"
                                    type="info"
                                    circle
                                    @click="showDetailedViewOfStep(step)"
                                    title="View"
                                    plain
                                  ></el-button>
                                  <el-button
                                    type="danger"
                                    class="delete-icon"
                                    icon="el-icon-delete"
                                    circle
                                    @click="removeExistedField(index)"
                                    title="Remove Field"
                                    plain
                                  ></el-button>
                                  <el-button
                                    icon="el-icon-setting"
                                    type="info"
                                    circle
                                    @click="updateStepData(step, index)"
                                    title="Settings"
                                    plain
                                  ></el-button>
                                </div>
                              </div>
                            </div>
                            <div class="inner-wrap" v-if="step.type == 'TEMPLATE'">
                              <div
                                class="flex items-center !gap-2 !py-1.5 !px-2 rounded-[0_0_8px_8px]"
                              >
                                <div>
                                  <icons
                                    v-if="
                                      step.type == 'TEMPLATE' &&
                                      step.template &&
                                      templateIcons[step.template]
                                    "
                                    :iconName="templateIcons[step.template]"
                                  ></icons>
                                  <icons
                                    v-else-if="step.type == 'TEMPLATE'"
                                    :iconName="'Block-Portfolio'"
                                  ></icons>
                                  <icons v-else :iconName="templateIcons[step.template]"></icons>
                                </div>

                                <span class="text-xs 2xl:text-sm text-black-950">
                                  {{
                                    step.settings && step.settings.sender_title
                                      ? step.settings.sender_title
                                      : configureTitles.sender_title
                                        ? configureTitles.sender_title
                                        : step.type === 'TEMPLATE'
                                          ? templateNames[step.template]
                                          : benefitNames[step.type]
                                  }}
                                </span>
                              </div>
                            </div>

                            <div class="inner-wrap" v-else-if="step.type == 'ENTITY'">
                              <div
                                class="flex items-center !gap-2 !py-1.5 !px-2 rounded-[0_0_8px_8px]"
                              >
                                <div>
                                  <icons
                                    v-if="
                                      step.type == 'ENTITY' &&
                                      step.entity &&
                                      entityIcons[step.entity]
                                    "
                                    :iconName="entityIcons[step.entity]"
                                  ></icons>
                                  <icons
                                    v-else-if="step.type == 'ENTITY'"
                                    :iconName="'Block-Portfolio'"
                                  ></icons>
                                  <icons v-else :iconName="benefitIcons[step.type]"></icons>
                                </div>

                                <span class="text-xs 2xl:text-sm text-black-950">
                                  {{
                                    step.settings && step.settings.sender_title
                                      ? step.settings.sender_title
                                      : configureTitles.sender_title
                                        ? configureTitles.sender_title
                                        : step.type === 'ENTITY'
                                          ? entityNames[step.entity]
                                          : benefitNames[step.type]
                                  }}
                                </span>
                              </div>
                            </div>
                            <div class="inner-wrap" v-else>
                              <div class="icon-template">
                                <img
                                  :src="
                                    require(
                                      '@/assets/img/template-icons/' + benefitIcons[step.type]
                                    )
                                  "
                                  alt="component"
                                  class="image"
                                />
                              </div>
                              <div class="content">
                                <span class="main-title">Step {{ index + 1 }}</span>
                                <span class="sub-title">{{ benefitNames[step.type] }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                  <p class="error" v-if="errors && errors.steps">
                    {{ errors.steps }}
                  </p>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="activeStep == 2">
              <div class="h-[calc(100vh-60px)] bg-white px-3 pb-3 !overflow-y-auto !pt-1">
                <el-col class="!border border-[#E9EBEC] h-full !bg-[#F8F8F8] rounded-xl pr-3">
                  <el-tabs
                    id="FormBuilderSettingsTabs"
                    class="shadow-none h-full bg-[#F8F8F8] rounded-s-xl !overflow-y-auto left_tabs"
                    v-model="activeMainTab"
                    :tab-position="fromEntityData ? 'top' : 'left'"
                    @tab-click="onApprovalTabChange"
                    v-if="!getIsMobile"
                  >
                    <el-tab-pane name="primary_settings" v-if="!fromEntityData" class="">
                      <span slot="label">
                        <i class="el-icon-alarm-clock"></i>
                        Primary Settings
                      </span>
                      <div
                        class="border border-[#E9EBEC] py-3 px-3 my-3 w-full rounded-lg !bg-white !space-y-4 mr-3"
                      >
                        <div class="flex justify-between w-full !mb-0">
                          <div>
                            <div class="text-sm pb-1.5">Form builder availability</div>
                            <el-radio-group v-model="formBuilder.settings.is_time_bond" size="mini">
                              <el-radio :label="false">All Time</el-radio>
                              <el-radio :label="true">Limited Period</el-radio>
                            </el-radio-group>
                          </div>
                          <div>
                            <span class="" v-if="formBuilder.settings.is_time_bond">
                              Select Date & Time Range
                            </span>
                            <el-form
                              :inline="true"
                              class="demo-form-inline"
                              v-if="formBuilder.settings.is_time_bond"
                            >
                              <el-date-picker
                                :format="'MM-dd-yyyy HH:mm:ss'"
                                v-model="formBuilder.settings.formbuilder_date_range"
                                align="right"
                                placement="bottom-start"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                range-separator="To"
                                start-placeholder="Start date"
                                end-placeholder="End date"
                                popper-class="my-popover"
                                size="mini"
                              ></el-date-picker>
                            </el-form>
                          </div>
                        </div>
                        <div class="">
                          <el-checkbox
                            v-if="formBuilder.form_builders_owner !== 'ANONYMOUS'"
                            v-model="formBuilder.settings.secure_access"
                          >
                            Secure access
                          </el-checkbox>
                          <el-checkbox
                            v-if="
                              formBuilder.form_builders_owner !== 'USER' &&
                              formBuilder.form_builders_owner !== 'ANONYMOUS'
                            "
                            v-model="formBuilder.settings.access_to_all"
                          >
                            Allow new users to fill
                          </el-checkbox>
                          <el-checkbox
                            v-if="
                              selectedUserEntity &&
                              selectedUserEntity.name &&
                              formBuilder.settings.access_to_all &&
                              selectedUserEntity.entity_type === 'BUSINESS'
                            "
                            v-model="formBuilder.settings.select_from_existing"
                          >
                            Allow user to Select from existing
                            {{ selectedUserEntity.name }} data
                          </el-checkbox>
                        </div>
                      </div>
                    </el-tab-pane>
                    <!-- Only entity form builder has schedules -->
                    <el-tab-pane
                      v-if="formBuilder.form_builders_owner == 'ENTITY'"
                      name="schedule_settings"
                      class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                    >
                      <span slot="label">
                        <i class="el-icon-alarm-clock"></i>
                        Schedule Settings
                      </span>
                      <el-form ref="form" label-width="200px">
                        <el-form ref="form" label-width="120px" label-position="top">
                          <el-form-item label="User will Submit Form builder data">
                            <el-radio-group v-model="formBuilder.settings.frequency">
                              <el-radio :label="false">Only One Time</el-radio>
                              <el-radio :label="true">Allow Multiple Submissions</el-radio>
                            </el-radio-group>
                          </el-form-item>

                          <el-checkbox
                            v-if="formBuilder.settings.frequency"
                            v-model="formBuilder.settings.schedules.status"
                          >
                            Add Schedules for User
                          </el-checkbox>
                          <el-checkbox
                            v-if="
                              formBuilder.settings &&
                              formBuilder.settings.frequency &&
                              formBuilder.settings.schedules.status
                            "
                            v-model="formBuilder.settings.is_allowed_to_all_users"
                            class="ml-3"
                          >
                            Add Schedules for all User
                          </el-checkbox>
                          <div style="display: flex">
                            <el-form-item
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status
                              "
                              label="Select Time Zone"
                            >
                              <el-select
                                v-model="formBuilder.settings.schedules.time_zone"
                                placeholder="Select Timezone"
                                :filterable="true"
                                :clearable="true"
                                size="mini"
                              >
                                <el-option
                                  v-for="(timezone, index) of time_zone"
                                  :key="index"
                                  :label="timezone"
                                  :value="timezone"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status &&
                                !formBuilder.settings.is_allowed_to_all_users
                              "
                              label="Select users to add schedules"
                              class="ml-2"
                            >
                              <el-select
                                v-model="formBuilder.settings.allowed_entity_users"
                                placeholder="Select user"
                                :filterable="true"
                                :clearable="true"
                                multiple
                                size="mini"
                                collapse-tags
                              >
                                <el-option
                                  v-for="(user, index) of entityUsers"
                                  :key="index + user._id"
                                  :label="user.email"
                                  :value="user._id + '#' + user.email"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="Expires after schedule sent"
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status
                              "
                              class="ml-1"
                            >
                              <el-input-number
                                :controls="false"
                                v-model="formBuilder.settings.schedules.expired_time_interval_value"
                                size="mini"
                              ></el-input-number>

                              <el-select
                                v-model="formBuilder.settings.schedules.expired_time_interval_type"
                                placeholder="Select Type"
                                class="ml-1"
                                size="mini"
                              >
                                <el-option label="DAYS" value="DAYS"></el-option>
                                <el-option label="WEEKS" value="WEEKS"></el-option>
                                <el-option label="MONTHS" value="MONTHS"></el-option>
                                <el-option label="YEARS" value="YEARS"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <el-form-item
                            v-if="
                              formBuilder.settings &&
                              formBuilder.settings.frequency &&
                              formBuilder.settings.schedules.status
                            "
                          >
                            <el-row>
                              <el-col :span="7">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutes="isminutesIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllminutes"
                                        @change="handleCheckMinutesChange"
                                      >
                                        Minutes
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.minutes"
                                      @change="handleCheckedMinuteChange"
                                    >
                                      <el-checkbox
                                        v-for="minute in minutes"
                                        :label="minute"
                                        :key="minute"
                                      >
                                        {{ minute }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="4">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminuteshours="ishoursIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllhours"
                                        @change="handleCheckHoursChange"
                                      >
                                        Hours
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.hours"
                                      @change="handleCheckedHourChange"
                                    >
                                      <el-checkbox v-for="hour in hours" :label="hour" :key="hour">
                                        {{ hour }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="5">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesdays="isdaysIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAlldays"
                                        @change="handleCheckDaysChange"
                                      >
                                        Days
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.days"
                                      @change="handleCheckedDayChange"
                                    >
                                      <el-checkbox v-for="day in days" :label="day" :key="day">
                                        {{ day }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="3">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesweeks="isweeksIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllweeks"
                                        @change="handleCheckWeeksChange"
                                      >
                                        Days of Week
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.days_of_week"
                                      @change="handleCheckedWeekChange"
                                    >
                                      <el-checkbox v-for="week in weeks" :label="week" :key="week">
                                        {{ week }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="3">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesmonths="ismonthsIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllmonths"
                                        @change="handleCheckMonthsChange"
                                      >
                                        Months
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.months"
                                      @change="handleCheckedMonthChange"
                                    >
                                      <el-checkbox
                                        v-for="month in months"
                                        :label="month"
                                        :key="month"
                                      >
                                        {{ month }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="2">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesyears="isyearsIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllyears"
                                        @change="handleCheckYearsChange"
                                      >
                                        Years
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.years"
                                      @change="handleCheckedYearChange"
                                    >
                                      <el-checkbox v-for="year in years" :label="year" :key="year">
                                        {{ year }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                            </el-row>
                          </el-form-item>
                        </el-form>
                      </el-form>
                    </el-tab-pane>

                    <el-tab-pane
                      v-if="formBuilder.form_builders_owner && !fromEntityData"
                      name="user_submission_settings"
                    >
                      <span slot="label">
                        <i class="el-icon-tickets"></i>
                        User Submission Settings
                      </span>

                      <el-form ref="form" label-width="120px" label-position="top">
                        <el-form-item
                          class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                          label="User will Submit Form builder data"
                        >
                          <el-radio-group v-model="formBuilder.settings.frequency">
                            <el-radio :label="false">Only One Time</el-radio>
                            <el-radio :label="true">Allow Multiple Submissions</el-radio>
                          </el-radio-group>
                        </el-form-item>

                        <el-form-item
                          class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                          label="User will submit multiple Form builder data"
                          v-if="formBuilder.settings.frequency"
                        >
                          <el-radio-group
                            v-model="formBuilder.settings.limit_responses"
                            :disable="formBuilder.settings.frequency"
                          >
                            <el-radio :label="false">No Limit</el-radio>
                            <el-radio :label="true">Max Submissions for Single User</el-radio>
                          </el-radio-group>
                          <el-input-number
                            class="!ml-2"
                            v-if="
                              formBuilder.settings.limit_responses && formBuilder.settings.frequency
                            "
                            type="number"
                            v-model="formBuilder.settings.no_responses_limited"
                          />
                        </el-form-item>

                        <el-form-item
                          class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                          label="User will view or edit his/her submitted responses"
                        >
                          <el-checkbox v-model="formBuilder.settings.view_responses">
                            Allow user to View
                          </el-checkbox>
                          <el-checkbox
                            v-model="formBuilder.settings.edit_responses"
                            v-if="formBuilder.settings.view_responses"
                          >
                            Allow user to edit
                          </el-checkbox>
                        </el-form-item>

                        <el-form-item
                          class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                          label="Form builder Total Submissions"
                        >
                          <el-radio-group v-model="formBuilder.settings.limit_total_submissions">
                            <el-radio :label="false">No Limit</el-radio>
                            <el-radio :label="true">
                              Max Submissions allowed for Form builder
                            </el-radio>
                          </el-radio-group>
                          <el-input-number
                            class="!ml-2"
                            v-if="formBuilder.settings.limit_total_submissions"
                            type="number"
                            v-model="formBuilder.settings.no_total_submissions_limited"
                          />
                        </el-form-item>
                      </el-form>
                    </el-tab-pane>

                    <el-tab-pane name="success_pages_redirects" v-if="!fromEntityData">
                      <span slot="label">
                        <i class="el-icon-finished"></i>
                        Success Pages & Redirects
                      </span>

                      <el-form
                        class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                        ref="form"
                        label-width="120px"
                        label-position="top"
                      >
                        <el-form-item class="" label="Success Page">
                          <el-checkbox
                            class="!pb-2"
                            v-model="formBuilder.settings.success_and_redirect_page.notify_reciever"
                          >
                            Notify Reciever
                          </el-checkbox>
                          <el-checkbox
                            v-model="formBuilder.settings.success_and_redirect_page.notify_sender"
                          >
                            Notify Owners
                          </el-checkbox>
                          <div>
                            <el-select
                              class="!mb-2"
                              v-if="formBuilder.settings.success_and_redirect_page.notify_sender"
                              multiple
                              collapse-tags
                              v-model="
                                formBuilder.settings.success_and_redirect_page.mail_recievers
                              "
                              style="width: 350px"
                              placeholder="Select E-mail Recievers"
                            >
                              <el-option
                                v-for="user of company_users.filter((e) =>
                                  formBuilder.form_builder_owners.includes(e._id)
                                )"
                                :key="user.email"
                                :label="user.email"
                                :value="user._id"
                              ></el-option>
                            </el-select>
                          </div>
                          <el-switch
                            class="!bg-none pt-1 px-2"
                            v-model="formBuilder.settings.success_and_redirect_page.redirect_to"
                            inactive-text="Thankyou Page"
                            active-text="Redirects to Page"
                            active-color="var(--brand-500)"
                            inactive-color="var(--black-200)"
                          ></el-switch>
                        </el-form-item>

                        <el-form-item
                          label="Redirect URL"
                          v-if="formBuilder.settings.success_and_redirect_page.redirect_to"
                        >
                          <el-input
                            v-model="formBuilder.settings.success_and_redirect_page.redirect_to_url"
                          />
                        </el-form-item>

                        <div
                          class="text-editor"
                          v-if="!formBuilder.settings.success_and_redirect_page.redirect_to"
                        >
                          <label class="label !pb-1.5">Thank you page text</label>
                          <CkEditorOffline
                            v-model="formBuilder.settings.success_and_redirect_page.thankyou_page"
                            :config="editorConfig2"
                          ></CkEditorOffline>
                          <!-- <TextEditor
                          :editorData.sync="
                            formBuilder.settings.success_and_redirect_page
                              .thankyou_page
                          "
                        ></TextEditor>-->
                        </div>
                      </el-form>
                    </el-tab-pane>

                    <el-tab-pane
                      v-if="this.formBuilder.settings.reminder_settings"
                      name="reminder_settings"
                    >
                      <span slot="label">
                        <i class="el-icon-bell"></i>
                        Reminder Settings
                      </span>

                      <el-form
                        class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                      >
                        <el-form-item>
                          <div class="flex items-center gap-2">
                            <label for="">Send Reminders</label>
                            <el-checkbox
                              v-model="formBuilder.settings.reminder_settings.status"
                            ></el-checkbox>
                          </div>
                        </el-form-item>

                        <el-form-item v-if="formBuilder.settings.reminder_settings.status">
                          <div class="flex items-start justify-center flex-col gap-4 pt-1">
                            <label class="" for="">Send first reminder</label>
                            <div>
                              <span>after schedule sent</span>
                              <el-input-number
                                :controls="false"
                                v-model="
                                  formBuilder.settings.reminder_settings
                                    .first_reminder_interval_value
                                "
                                size="mini"
                              ></el-input-number>

                              <el-select
                                v-model="
                                  formBuilder.settings.reminder_settings
                                    .first_reminder_interval_type
                                "
                                placeholder="Select Type"
                                class="ml-1"
                                size="mini"
                              >
                                <el-option label="MINUTES" value="MINUTES"></el-option>
                                <el-option label="HOURS" value="HOURS"></el-option>
                                <el-option label="DAYS" value="DAYS"></el-option>
                                <el-option label="WEEKS" value="WEEKS"></el-option>
                                <el-option label="MONTHS" value="MONTHS"></el-option>
                                <el-option label="YEARS" value="YEARS"></el-option>
                              </el-select>
                            </div>
                          </div>
                        </el-form-item>
                        <el-form-item v-if="formBuilder.settings.reminder_settings.status">
                          <div class="flex items-start justify-center flex-col gap-4 pt-1">
                            <label for="">Repeat Reminder</label>
                            <div>
                              <span class="pr-1">for every</span>
                              <el-input-number
                                :controls="false"
                                v-model="
                                  formBuilder.settings.reminder_settings.reminder_interval_value
                                "
                                size="mini"
                              ></el-input-number>
                            </div>
                          </div>

                          <el-select
                            v-model="formBuilder.settings.reminder_settings.reminder_interval_type"
                            placeholder="Select Type"
                            class="mr-1 mt-1"
                            size="mini"
                          >
                            <el-option label="MINUTES" value="MINUTES"></el-option>
                            <el-option label="HOURS" value="HOURS"></el-option>
                            <el-option label="DAYS" value="DAYS"></el-option>
                            <el-option label="WEEKS" value="WEEKS"></el-option>
                            <el-option label="MONTHS" value="MONTHS"></el-option>
                            <el-option label="YEARS" value="YEARS"></el-option>
                          </el-select>
                          until completed or expires
                        </el-form-item>
                      </el-form>
                    </el-tab-pane>
                    <el-tab-pane
                      class="!border !border-[#E9EBEC] py-3 px-3 my-3 w-full rounded-lg !bg-white !space-y-4 mr-3"
                      name="receiver_email_customization"
                      v-if="formBuilder.form_builders_owner !== 'ANONYMOUS' && !fromEntityData"
                    >
                      <span slot="label">
                        <i class="el-icon-chat-line-square"></i>
                        Receiver email customization
                      </span>
                      Subject
                      <el-input
                        v-model="formBuilder.receiver_mail_template.subject"
                        placeholder="Enter subject"
                        class="mb-1"
                      ></el-input>
                      Custom message
                      <CkEditorOffline
                        v-model="formBuilder.receiver_mail_template.body"
                        :config="editorConfig"
                      ></CkEditorOffline>
                      <div
                        @click="chooseFromParentEmailTemplatesReceiver"
                        style="
                          cursor: pointer;
                          color: #409eff;
                          margin-left: 200px;
                          margin-top: 10px;
                        "
                      >
                        <span v-if="!formBuilder.receiver_mail_template.name">
                          Choose Parent Template(Header & Footer)
                        </span>
                        <span v-else>Change Parent Template (Header & Footer)</span>
                      </div>
                      <div
                        v-if="formBuilder.receiver_mail_template.name"
                        class="mb-2"
                        style="margin-left: 200px"
                      >
                        Selected Parent :
                        <span>{{ formBuilder.receiver_mail_template.name }}</span>
                        <span>
                          <i
                            style="cursor: pointer"
                            @click="resetParentReceiver"
                            class="el-icon-error"
                          ></i>
                        </span>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane
                      name="approval_settings"
                      class="!border !border-[#E9EBEC] py-3 px-3 my-3 w-full rounded-lg !bg-white !space-y-4 mr-3"
                    >
                      <span slot="label">
                        <i class="el-icon-circle-check"></i>
                        Approval Settings
                      </span>
                      <el-row class="mb-1">
                        <el-checkbox
                          @change="addInitialUsers"
                          v-model="formBuilder.is_approval_form"
                        >
                          Is approval form?
                        </el-checkbox>
                        <el-checkbox
                          v-if="
                            formBuilder.is_approval_form &&
                            formBuilder.approval_configuration_type == 'STANDARD' &&
                            formBuilder.approval_users &&
                            formBuilder.approval_users.length > 1 &&
                            !formBuilder.approve_all_user
                          "
                          v-model="formBuilder.priority_based"
                        >
                          Approvals by priority
                          <el-popover
                            placement="top-start"
                            trigger="hover"
                            content="Last user has high priority"
                          >
                            <i class="el-icon-info" slot="reference"></i>
                          </el-popover>
                        </el-checkbox>
                        <el-checkbox
                          v-if="formBuilder.is_approval_form"
                          v-model="formBuilder.show_approval_reason_dialog"
                        >
                          Show reason dialog for approval
                        </el-checkbox>
                        <el-checkbox
                          v-if="formBuilder.is_approval_form"
                          v-model="formBuilder.show_approval_rating"
                        >
                          Show rating dialog for approval
                        </el-checkbox>
                      </el-row>
                      <div v-if="formBuilder.is_approval_form" class="all-template-container">
                        <el-tabs
                          id="companyProfileTabs"
                          v-model="activeApprovalTab"
                          @tab-click="onApprovalTabChange"
                        >
                          <el-tab-pane label="Users" name="users" class="pt-1">
                            <el-radio-group v-model="formBuilder.approval_configuration_type">
                              <el-radio label="STANDARD">Standard Approval</el-radio>
                              <el-radio label="ADVANCED">Advanced Approval</el-radio>
                            </el-radio-group>

                            <div v-if="formBuilder.approval_configuration_type == 'ADVANCED'">
                              <AdvancedApprovalSettings
                                :getUserTypeList="getUserTypeList"
                                :formBuilder="formBuilder"
                                :allEntitiesData="allEntitiesData"
                                :getAllContactTypes="getAllContactTypes"
                                :relationshipsData="relationshipsData"
                                :allContacts="allContacts"
                                :getAllFields="getAllFields"
                                :company_users="company_users"
                                :allFormbuilderFields="getFormBuilderAllFields()"
                                :allFormBuilderOriginalFields="allFormBuilderOriginalFields"
                              ></AdvancedApprovalSettings>
                            </div>
                            <div v-else>
                              <el-row
                                v-for="(user, i) in formBuilder.approval_users"
                                :key="'user_' + i"
                                class="mt-1"
                              >
                                <el-col :span="2" v-if="formBuilder.enforce_order">
                                  <div class="level-pill">Level- {{ i + 1 }}</div>
                                </el-col>
                                <el-col v-if="user.apply_condition" :span="3">
                                  <div style="display: flex; align-items: center; gap: 3px">
                                    <span>If</span>
                                    <el-select
                                      v-model="user.selected_filter_id"
                                      clearable
                                      size="mini"
                                      placeholder="Select saved filter"
                                      filterable
                                      style="flex: 1"
                                    >
                                      <el-option
                                        v-for="filter in formbuilderAllFilters"
                                        :key="filter._id"
                                        :label="filter.filter_name"
                                        :value="filter._id"
                                      >
                                        {{ filter.filter_name }}
                                      </el-option>
                                    </el-select>
                                    <span>then</span>
                                  </div>
                                </el-col>
                                <el-col :span="3">
                                  <el-select
                                    v-model="user.user_type"
                                    size="mini"
                                    clearable
                                    placeholder="Select user type"
                                    @change="updateUserType(i)"
                                  >
                                    <el-option
                                      v-for="userType in userTypes"
                                      :key="userType.value"
                                      :label="userType.label"
                                      :value="userType.value"
                                    ></el-option>
                                  </el-select>
                                </el-col>
                                <template v-if="user.user_type == 'COMPANY'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.company_user_type"
                                      clearable
                                      size="mini"
                                      @change="(value) => updateCompanyUsers(value, user)"
                                      placeholder="Select company user type"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="item in getUserTypeList"
                                        :key="item._id"
                                        :label="getLabel(item)"
                                        :value="item._id"
                                      ></el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col :span="5">
                                    <el-select
                                      v-if="user.company_user_type"
                                      v-model="user.preferred_company_users"
                                      clearable
                                      size="mini"
                                      collapse-tags
                                      multiple
                                      placeholder="Select preferred user"
                                      class="ml-1 !w-full"
                                      default-first-option
                                    >
                                      <el-option
                                        v-for="item in getCompanyUsersByType(
                                          user.company_user_type
                                        )"
                                        :key="item._id + '_company_user'"
                                        :label="item.email"
                                        :value="item._id"
                                      >
                                        {{ item.email }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col
                                    :span="2"
                                    v-if="formBuilder.allow_field_level_permissions"
                                  >
                                    <div>
                                      <el-tooltip
                                        content="Add Field Level Permissions"
                                        placement="top"
                                      >
                                        <i
                                          class="el-icon-setting icon-class ml-1"
                                          @click="openFormBuilderSettings(user, i)"
                                        ></i>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="4" class="mr-1">
                                    <el-checkbox
                                      class="ml-3"
                                      v-if="
                                        getCompanyUsersByType(user.company_user_type).length > 1
                                      "
                                      v-model="user.any_user_can_approve"
                                    >
                                      Any user can approve
                                    </el-checkbox>
                                  </el-col>
                                  <el-col :span="4" v-if="formBuilderId">
                                    <el-checkbox
                                      class="ml-3"
                                      v-model="user.apply_condition"
                                      @change="onApplyConditionChanged(user)"
                                    >
                                      Apply condition
                                    </el-checkbox>
                                  </el-col>
                                </template>
                                <template v-else-if="user.user_type == 'APPLICATION'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.application_user_type"
                                      clearable
                                      size="mini"
                                      @change="updateApplicationUserType(user)"
                                      placeholder="Select application user type"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="(type, index) in getAllContactTypes.data ||
                                        getAllContactTypes"
                                        :key="index + 1"
                                        :value="type._id"
                                        :label="type.name"
                                      >
                                        {{ type.name }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col :span="4">
                                    <div
                                      v-if="
                                        checkIsIndividualEntityUserType(user.application_user_type)
                                      "
                                    >
                                      <el-select
                                        v-model="user.individual_entity_resource"
                                        clearable
                                        size="mini"
                                        placeholder="Select resource"
                                        class="ml-1"
                                        @change="getFiltersByEntityId(user.application_user_type)"
                                      >
                                        <el-option
                                          v-for="(type, index) in resourceTypes"
                                          :key="index + 1"
                                          :value="type.value"
                                          :label="type.label"
                                        >
                                          {{ type.label }}
                                        </el-option>
                                      </el-select>
                                    </div>
                                  </el-col>
                                  <el-col :span="4">
                                    <div v-if="user.individual_entity_resource == 'FILTER'">
                                      <el-select
                                        v-model="user.filter_type"
                                        clearable
                                        size="mini"
                                        placeholder="Select filter type"
                                        class="ml-1"
                                      >
                                        <el-option
                                          v-for="(type, index) in filterTypes"
                                          :key="index + 1"
                                          :value="type.value"
                                          :label="type.label"
                                        >
                                          {{ type.label }}
                                        </el-option>
                                      </el-select>
                                    </div>
                                  </el-col>
                                  <el-col :span="3">
                                    <div
                                      v-if="
                                        user.application_user_type &&
                                        user.individual_entity_resource == 'FILTER' &&
                                        user.filter_type == 'SAVED_FILTER'
                                      "
                                    >
                                      <el-select
                                        v-model="user.selected_entity_filter"
                                        filterable
                                        clearable
                                        placeholder="Select filter"
                                        size="mini"
                                        class="ml-1"
                                        @change="
                                          updateFilterName(
                                            user.selected_entity_filter,
                                            user.application_user_type,
                                            i
                                          )
                                        "
                                      >
                                        <el-option
                                          v-for="(filter, index) in filtersByEntityIdObj[
                                            user.application_user_type
                                          ]"
                                          :key="index"
                                          :label="filter.filter_name"
                                          :value="filter._id"
                                        />
                                      </el-select>
                                    </div>
                                  </el-col>
                                  <el-col :span="1">
                                    <div
                                      v-if="
                                        user.application_user_type &&
                                        user.individual_entity_resource == 'FILTER' &&
                                        user.filter_type == 'CONFIGURE_FILTER'
                                      "
                                    >
                                      <el-tooltip content="Add Filters" placement="top">
                                        <el-button
                                          :style="'margin-left: 5px; margin-right: 5px;'"
                                          size="mini"
                                          type="plain"
                                          icon="el-icon-plus"
                                          @click="addFiltersForApprovers(i)"
                                        ></el-button>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="4">
                                    <div v-if="checkIsBusinessUserType(user.application_user_type)">
                                      <el-select
                                        v-model="user.business_account_type"
                                        clearable
                                        size="mini"
                                        placeholder="Select business application user type"
                                        class="ml-1"
                                        @change="
                                          getBusinessAccountNames(user.application_user_type)
                                        "
                                      >
                                        <el-option
                                          v-for="(type, index) in accountTypes"
                                          :key="index + 1"
                                          :value="type.value"
                                          :label="type.label"
                                        >
                                          {{ type.label }}
                                        </el-option>
                                      </el-select>
                                    </div>
                                  </el-col>
                                  <el-col :span="4">
                                    <div
                                      class="ml-1"
                                      v-if="
                                        user.application_user_type &&
                                        user.business_account_type == 'GROUP'
                                      "
                                    >
                                      <el-select
                                        v-model="user.application_user_business_account_id"
                                        clearable
                                        size="mini"
                                        placeholder="Select business account"
                                        @change="updatePreferredApplicationUsers(user)"
                                      >
                                        <el-option
                                          v-for="(account, i) in accountNamesObj[
                                            user.application_user_type
                                          ]"
                                          :key="i"
                                          :value="account._id"
                                          :label="getLabelForBusinessAccount(account)"
                                        >
                                          {{ getLabelForBusinessAccount(account) }}
                                        </el-option>
                                      </el-select>
                                    </div>
                                  </el-col>
                                  <el-col :span="4">
                                    <div
                                      class="ml-1"
                                      v-if="
                                        user.application_user_type &&
                                        user.business_account_type !== 'GROUP' &&
                                        user.individual_entity_resource !== 'FILTER'
                                      "
                                    >
                                      <el-select
                                        v-model="user.preferred_application_users"
                                        clearable
                                        multiple
                                        collapse-tags
                                        size="mini"
                                        class="!w-full"
                                        placeholder="Select preferred user"
                                        :disabled="user.relational_user"
                                      >
                                        <el-option
                                          v-for="(contact, index) in getUserTypeContacts(
                                            user.application_user_type
                                          )"
                                          :key="index + '_application_user_mail'"
                                          :value="contact.email"
                                          :label="contact.email"
                                        >
                                          {{ contact.email }}
                                        </el-option>
                                      </el-select>
                                      <el-checkbox
                                        v-if="checkIsRelational(user.application_user_type)"
                                        :disabled="
                                          user.preferred_application_users &&
                                          user.preferred_application_users.length
                                            ? true
                                            : false
                                        "
                                        v-model="user.relational_user"
                                      >
                                        User relational data
                                      </el-checkbox>
                                    </div>
                                  </el-col>
                                  <el-col
                                    :span="4"
                                    v-if="formBuilder.allow_field_level_permissions"
                                  >
                                    <div>
                                      <el-tooltip
                                        content="Add Field Level Permissions"
                                        placement="top"
                                      >
                                        <i
                                          class="el-icon-setting icon-class ml-1"
                                          @click="openFormBuilderSettings(user, i)"
                                        ></i>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="4" class="mr-1">
                                    <el-checkbox
                                      class="ml-1"
                                      v-if="
                                        getUserTypeContacts(user.application_user_type).length >
                                          1 && !user.relational_user
                                      "
                                      v-model="user.any_user_can_approve"
                                    >
                                      Any user can approve
                                    </el-checkbox>
                                  </el-col>
                                  <el-col :span="3" v-if="formBuilderId">
                                    <el-checkbox
                                      class="ml-1"
                                      v-model="user.apply_condition"
                                      @change="onApplyConditionChanged(user)"
                                    >
                                      Apply condition
                                    </el-checkbox>
                                  </el-col>
                                </template>
                                <template v-else-if="user.user_type == 'LINKEDFIELD'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.approval_linked_field"
                                      clearable
                                      size="mini"
                                      placeholder="Select user data field"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="(option, index) of getAllFields"
                                        :key="index"
                                        :value="option.key"
                                        :label="option.label"
                                        :disabled="
                                          checkDuplicate(i, option.key, 'approval_linked_field')
                                        "
                                      >
                                        {{ option.label }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col
                                    :span="2"
                                    v-if="formBuilder.allow_field_level_permissions"
                                  >
                                    <div>
                                      <el-tooltip
                                        content="Add Field Level Permissions"
                                        placement="top"
                                      >
                                        <i
                                          class="el-icon-setting icon-class ml-1"
                                          @click="openFormBuilderSettings(user, i)"
                                        ></i>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-col :span="3" v-if="formBuilderId">
                                    <el-checkbox
                                      v-model="user.apply_condition"
                                      @change="onApplyConditionChanged(user)"
                                    >
                                      Apply condition
                                    </el-checkbox>
                                  </el-col>
                                </template>
                                <template>
                                  <el-col :span="2" style="margin-left: 40px !important">
                                    <el-link
                                      icon="el-icon-delete"
                                      :underline="false"
                                      type="danger"
                                      @click="removeUser(i)"
                                    ></el-link>
                                  </el-col>
                                </template>
                              </el-row>
                              <el-row class="mt-1">
                                <el-button
                                  class="mt-1"
                                  type="primary"
                                  plain
                                  size="mini"
                                  icon="el-icon-plus"
                                  @click="addApprovers"
                                >
                                  Add Approvers
                                </el-button>
                                <el-checkbox
                                  class="ml-2"
                                  v-if="
                                    formBuilder.approval_users.length > 1 &&
                                    !formBuilder.priority_based
                                  "
                                  v-model="formBuilder.approve_all_user"
                                >
                                  All users needs to approve
                                </el-checkbox>
                                <el-checkbox
                                  class="ml-1"
                                  v-if="
                                    formBuilder.approval_users.length > 1 &&
                                    !formBuilder.priority_based &&
                                    formBuilder.approve_all_user
                                  "
                                  v-model="formBuilder.enforce_order"
                                >
                                  Enforce order
                                </el-checkbox>
                              </el-row>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane label="Approval Mail Template" name="mail">
                            <span class="my-1 pt-1 d-block">Subject</span>
                            <CkEditorOffline
                              v-model="formBuilder.approval_mail_template.subject"
                              :config="editorConfig4"
                            ></CkEditorOffline>
                            <span class="my-1 pt-1 d-block">Custom message</span>
                            <CkEditorOffline
                              v-model="formBuilder.approval_mail_template.body"
                              :config="editorConfig1"
                            ></CkEditorOffline>
                            <div
                              @click="chooseFromParentEmailTemplates"
                              style="
                                cursor: pointer;
                                color: #409eff;
                                margin-left: 200px;
                                margin-top: 10px;
                              "
                            >
                              <span v-if="!formBuilder.approval_mail_template.name">
                                Choose Parent Template(Header & Footer)
                              </span>
                              <span v-else>Change Parent Template (Header & Footer)</span>
                            </div>
                            <div
                              v-if="formBuilder.approval_mail_template.name"
                              class="mb-2"
                              style="margin-left: 200px"
                            >
                              Selected Parent :
                              <span>{{ formBuilder.approval_mail_template.name }}</span>
                              <span>
                                <i
                                  style="cursor: pointer"
                                  @click="resetParent"
                                  class="el-icon-error"
                                ></i>
                              </span>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane
                            label="Revoke & other permissions"
                            name="permissions"
                            v-if="formBuilder.is_approval_form"
                            @click="openApprovalRedirect"
                          >
                            <div>
                              <span
                                style="
                                  font-weight: 500;
                                  font-size: 16px;
                                  margin: 10px 0 0;
                                  display: block;
                                "
                              >
                                Revoke Approval Permissions:
                              </span>

                              <el-checkbox
                                v-model="formBuilder.allow_revoke_approval"
                                class="mt-1 ml-2"
                              >
                                Allow Revoke Approval
                              </el-checkbox>
                            </div>

                            <!-- Revoke approval-Approver Permissions -->
                            <div
                              v-if="formBuilder.allow_revoke_approval"
                              class="ml-2 mt-1"
                              style="margin-bottom: 20px"
                            >
                              <div
                                style="
                                  font-size: 15px;
                                  font-weight: 500;
                                  color: #555;
                                  margin-bottom: 8px;
                                "
                              >
                                Approver revoke permissions:
                              </div>

                              <div style="margin-bottom: 8px" class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_approved"
                                  :disabled="isAnyOtherChecked('approved')"
                                  @change="handleCheckboxChange"
                                >
                                  Only for Approved Submissions
                                </el-checkbox>
                              </div>
                              <div style="margin-bottom: 8px" class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_rejected"
                                  :disabled="isAnyOtherChecked('rejected')"
                                  @change="handleCheckboxChange"
                                >
                                  Only for Rejected Submissions
                                </el-checkbox>
                              </div>
                              <div class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_both"
                                  :disabled="isAnyOtherChecked('both')"
                                  @change="handleCheckboxChange"
                                >
                                  For BOTH
                                </el-checkbox>
                              </div>
                            </div>

                            <!-- Revoke approval-Filler Permissions -->
                            <div v-if="formBuilder.allow_revoke_approval" class="ml-2">
                              <div
                                style="
                                  font-size: 15px;
                                  font-weight: 500;
                                  color: #555;
                                  margin-bottom: 8px;
                                "
                              >
                                Filler revoke permissions:
                              </div>

                              <div style="margin-bottom: 8px" class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_approved_for_filler"
                                  :disabled="isAnyOtherCheckedForFiller('approved')"
                                  @change="handleCheckboxChangeForFiller"
                                >
                                  Only for Approved Submissions
                                </el-checkbox>
                              </div>
                              <div style="margin-bottom: 8px" class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_rejected_for_filler"
                                  :disabled="isAnyOtherCheckedForFiller('rejected')"
                                  @change="handleCheckboxChangeForFiller"
                                >
                                  Only for Rejected Submissions
                                </el-checkbox>
                              </div>
                              <div class="ml-1">
                                <el-checkbox
                                  v-model="formBuilder.allow_revoke_for_both_for_filler"
                                  :disabled="isAnyOtherCheckedForFiller('both')"
                                  @change="handleCheckboxChangeForFiller"
                                >
                                  For BOTH
                                </el-checkbox>
                              </div>
                            </div>
                            <div v-if="formBuilder.allow_revoke_approval">
                              <el-checkbox v-model="formBuilder.show_revoke_reason_dialog">
                                Show Revoke Reason Dialog
                              </el-checkbox>
                            </div>
                            <div v-if="formBuilder.allow_revoke_approval">
                              <el-button
                                type="text"
                                icon="el-icon-s-tools"
                                @click="openRevokeApprovalActions"
                              >
                                Configure revoke approval data actions
                              </el-button>
                            </div>
                            <br />
                            <!-- <div> -->
                            <span style="font-weight: 500; font-size: 16px">Export Settings:</span>
                            <br />
                            <el-checkbox
                              v-model="formBuilder.allow_export_as_excel"
                              class="mb-1 mt-1"
                            >
                              Allow export as Excel
                            </el-checkbox>
                            <el-checkbox v-model="formBuilder.allow_export_as_pdf" class="mb-1">
                              Allow export as Pdf
                            </el-checkbox>
                            <br />
                            <div class="mt-1">
                              <span style="font-weight: 500; font-size: 16px">
                                Approver permissions:
                              </span>
                              <br />
                              <el-checkbox
                                v-model="formBuilder.allow_edit_for_approver"
                                class="mt-1 mb-1"
                              >
                                Allow Edit for approver
                              </el-checkbox>
                            </div>
                            <div class="mt-1">
                              <span style="font-weight: 500; font-size: 16px">
                                Field Level Permissions:
                              </span>
                              <br />
                              <el-tooltip
                                class="item"
                                effect="dark"
                                content="If enabled, you can set field-level permissions for approvers and fillers. You can make fields required, read-only, or hidden when the form is being filled out or approved."
                                placement="top"
                              >
                                <el-checkbox
                                  v-model="formBuilder.allow_field_level_permissions"
                                  class="mt-1 mb-1"
                                  :disabled="!formBuilder || !formBuilder.steps?.length"
                                  @change="onFieldLevelPermissionChange"
                                >
                                  Allow Field Level Permissions
                                </el-checkbox>
                              </el-tooltip>
                            </div>
                            <br />
                            <div class="permissions-wrapper">
                              <span class="permissions-title">Filler permissions:</span>

                              <div class="permissions-section">
                                <span class="permissions-subtitle">After Approved:</span>
                                <div class="checkbox-group-per">
                                  <el-checkbox
                                    v-model="formBuilder.approval_receiver_permissions.view"
                                  >
                                    VIEW
                                  </el-checkbox>
                                  <el-checkbox
                                    v-model="formBuilder.approval_receiver_permissions.edit"
                                  >
                                    EDIT
                                  </el-checkbox>
                                  <el-checkbox
                                    v-model="formBuilder.approval_receiver_permissions.delete"
                                  >
                                    DELETE
                                  </el-checkbox>
                                </div>
                              </div>

                              <div class="permissions-section">
                                <span class="permissions-subtitle">After Rejected:</span>
                                <div class="checkbox-group-per">
                                  <el-checkbox
                                    v-model="formBuilder.rejection_receiver_permissions.view"
                                  >
                                    VIEW
                                  </el-checkbox>
                                  <el-checkbox
                                    v-model="formBuilder.rejection_receiver_permissions.edit"
                                  >
                                    EDIT
                                  </el-checkbox>
                                  <el-checkbox
                                    v-model="formBuilder.rejection_receiver_permissions.delete"
                                  >
                                    DELETE
                                  </el-checkbox>
                                </div>
                              </div>
                            </div>
                            <br />
                            <div class="mt-1">
                              Allow approve and reject for child entity tables:
                              <el-select
                                v-model="formBuilder.approval_child_entity_tables"
                                placeholder="Select the child entity tables"
                                multiple
                                collapse-tags
                                clearable
                                size="mini"
                              >
                                <el-option
                                  v-for="table in getChildEntityTables"
                                  :key="table.key"
                                  :label="table.label"
                                  :value="table.entity_id + '#' + table.key"
                                ></el-option>
                              </el-select>
                            </div>
                            <div class="mt-1">
                              Redirection when click on approve:
                              <el-select
                                v-model="formBuilder.approval_redirection"
                                placeholder="Select the redirection to which entity"
                                clearable
                                size="mini"
                                @change="(value) => setRedirectEntityFields(value)"
                              >
                                <el-option
                                  v-for="table in entitiesData"
                                  :key="table._id"
                                  :label="table.name"
                                  :value="table._id"
                                ></el-option>
                              </el-select>
                            </div>
                            <div
                              v-if="
                                formBuilder.approval_redirection &&
                                refreshEntityFilterDialog &&
                                redirectEntity
                              "
                              class="mt-1"
                            >
                              <EntityFilter
                                v-if="refreshEntityFilterDialog"
                                :currentEntity="redirectEntity"
                                :entityFiltersData="formBuilder.approval_redirection_filter"
                                :selectedEntityFields="redirectEntityFields"
                                :entityUserFiltersData="{}"
                                :sourceFields="formbuilderFields"
                                :hideSave="true"
                              ></EntityFilter>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane
                            label="Receiver's Approval Update Mail Template"
                            name="receiver_approval_mail"
                          >
                            <div class="mt-1">
                              <span class="warning">
                                <i class="el-icon-info"></i>
                                By default, approval updates are sent to the form submitter. To
                                notify specific users instead, click 'Add' to select them:
                              </span>
                              <el-button
                                type="primary"
                                plain
                                size="mini"
                                icon="el-icon-plus"
                                @click="addApprovalReceivers"
                              >
                                Add
                              </el-button>
                              <el-row
                                v-for="(user, i) in formBuilder.approval_update_receivers"
                                :key="'user_' + i"
                                class="mt-1"
                              >
                                <el-col :span="3">
                                  <el-select
                                    v-model="user.user_type"
                                    size="mini"
                                    clearable
                                    placeholder="Select user type"
                                  >
                                    <el-option
                                      v-for="userType in userTypes"
                                      :key="userType.value"
                                      :label="userType.label"
                                      :value="userType.value"
                                    ></el-option>
                                  </el-select>
                                </el-col>
                                <template v-if="user.user_type == 'COMPANY'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.company_user_type"
                                      clearable
                                      size="mini"
                                      @change="(value) => updateCompanyUsers(value, user)"
                                      placeholder="Select company user type"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="item in getUserTypeList"
                                        :key="item._id"
                                        :label="getLabel(item)"
                                        :value="item._id"
                                      ></el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col :span="3">
                                    <el-select
                                      v-if="user.company_user_type"
                                      v-model="user.preferred_company_users"
                                      clearable
                                      size="mini"
                                      multiple
                                      collapse-tags
                                      placeholder="Select preferred user"
                                      class="ml-1"
                                      default-first-option
                                    >
                                      <el-option
                                        v-for="item in getCompanyUsersByType(
                                          user.company_user_type
                                        )"
                                        :key="item._id + '_company_user'"
                                        :label="item.email"
                                        :value="item.email"
                                      >
                                        {{ item.email }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                </template>
                                <template v-else-if="user.user_type == 'APPLICATION'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.application_user_type"
                                      clearable
                                      size="mini"
                                      @change="updateApplicationUserType(user)"
                                      placeholder="Select application user type"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="(type, index) in (getAllContactTypes &&
                                          getAllContactTypes.data) ||
                                        getAllContactTypes"
                                        :key="index + 1"
                                        :value="type._id"
                                        :label="type.name"
                                      >
                                        {{ type.name }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                  <el-col :span="4">
                                    <div class="ml-1" v-if="user.application_user_type">
                                      <el-select
                                        v-model="user.preferred_application_users"
                                        clearable
                                        multiple
                                        collapse-tags
                                        size="mini"
                                        placeholder="Select preferred user"
                                        :disabled="user.relational_user"
                                      >
                                        <el-option
                                          v-for="(contact, index) in getUserTypeContacts(
                                            user.application_user_type
                                          )"
                                          :key="index + '_application_user_mail'"
                                          :value="contact.email"
                                          :label="contact.email"
                                        >
                                          {{ contact.email }}
                                        </el-option>
                                      </el-select>
                                    </div>
                                  </el-col>
                                </template>
                                <template v-else-if="user.user_type == 'LINKEDFIELD'">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="user.approval_linked_field"
                                      clearable
                                      size="mini"
                                      placeholder="Select user data field"
                                      class="ml-1"
                                    >
                                      <el-option
                                        v-for="(option, index) of getAllFields"
                                        :key="index"
                                        :value="option.key"
                                        :label="option.label"
                                        :disabled="
                                          checkDuplicate(i, option.key, 'approval_linked_field')
                                        "
                                      >
                                        {{ option.label }}
                                      </el-option>
                                    </el-select>
                                  </el-col>
                                </template>
                                <template>
                                  <el-col :span="2" style="margin-left: 40px !important">
                                    <el-link
                                      icon="el-icon-delete"
                                      :underline="false"
                                      type="danger"
                                      @click="removeUserReceiver(i)"
                                    ></el-link>
                                  </el-col>
                                </template>
                              </el-row>
                              <br />
                              <div class="mt-1">
                                <el-checkbox v-model="checkApprovalUpdateMailCC">CC</el-checkbox>
                                <el-checkbox v-model="checkApprovalUpdateMailBCC">BCC</el-checkbox>
                              </div>
                              <div v-if="checkApprovalUpdateMailCC">
                                <span style="font-weight: 400; margin: 20px 0">CC</span>
                                <el-row class="mb-1">
                                  <el-col :span="3">
                                    <el-select
                                      v-model="
                                        formBuilder.receiver_approval_update_mail_template
                                          .cc_user_type
                                      "
                                      size="mini"
                                      clearable
                                      placeholder="Select user type"
                                    >
                                      <el-option
                                        v-for="userType in ccuserTypes"
                                        :key="userType.value"
                                        :label="userType.label"
                                        :value="userType.value"
                                      ></el-option>
                                    </el-select>
                                  </el-col>
                                  <template
                                    v-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .cc_user_type == 'COMPANY'
                                    "
                                  >
                                    <el-col :span="3">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .cc_company_user_type
                                        "
                                        clearable
                                        size="mini"
                                        placeholder="Select company user type"
                                        class="ml-1"
                                      >
                                        <el-option
                                          v-for="item in getUserTypeList"
                                          :key="item._id"
                                          :label="getLabel(item)"
                                          :value="item._id"
                                        ></el-option>
                                      </el-select>
                                    </el-col>
                                    <el-col :span="6">
                                      <el-select
                                        v-if="
                                          formBuilder.receiver_approval_update_mail_template
                                            .cc_company_user_type
                                        "
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template.cc_user
                                        "
                                        clearable
                                        size="mini"
                                        multiple
                                        placeholder="Select mail"
                                        class="ml-1"
                                        default-first-option
                                      >
                                        <el-option
                                          v-for="item in getCompanyUsersByType(
                                            formBuilder.receiver_approval_update_mail_template
                                              .cc_company_user_type
                                          )"
                                          :key="item._id + '_company_user'"
                                          :label="item.email"
                                          :value="item.email"
                                        >
                                          {{ item.email }}
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .cc_user_type == 'APPLICATION'
                                    "
                                  >
                                    <el-col :span="3">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .cc_application_user_type
                                        "
                                        clearable
                                        size="mini"
                                        placeholder="Select application user type"
                                        class="ml-1"
                                      >
                                        <el-option
                                          v-for="(type, index) in (getAllContactTypes &&
                                            getAllContactTypes.data) ||
                                          getAllContactTypes"
                                          :key="index + 1"
                                          :value="type._id"
                                          :label="type.name"
                                        >
                                          {{ type.name }}
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                    <el-col :span="6">
                                      <div
                                        class="ml-1"
                                        v-if="
                                          formBuilder.receiver_approval_update_mail_template
                                            .cc_application_user_type
                                        "
                                      >
                                        <el-select
                                          v-model="
                                            formBuilder.receiver_approval_update_mail_template
                                              .cc_user
                                          "
                                          clearable
                                          multiple
                                          size="mini"
                                          placeholder="Select mail"
                                        >
                                          <el-option
                                            v-for="(contact, index) in getUserTypeContacts(
                                              formBuilder.receiver_approval_update_mail_template
                                                .cc_application_user_type
                                            )"
                                            :key="index + '_application_user_mail'"
                                            :value="contact.email"
                                            :label="contact.email"
                                          >
                                            {{ contact.email }}
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </el-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .cc_user_type == 'CUSTOM'
                                    "
                                  >
                                    <el-col :span="6" class="ml-1">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template.cc_user
                                        "
                                        placeholder="Custom Cc Emails"
                                        size="mini"
                                        class="email-field"
                                        multiple
                                        clearable
                                        filterable
                                        collapse-tags
                                        allow-create
                                        default-first-option
                                      >
                                        <el-option
                                          v-for="item in formBuilder.receiver_approval_update_mail_template &&
                                          formBuilder.receiver_approval_update_mail_template
                                            .cc_user"
                                          :key="item"
                                          :label="item"
                                          :value="item"
                                        ></el-option>
                                      </el-select>
                                    </el-col>
                                  </template>
                                </el-row>
                              </div>
                              <div v-if="checkApprovalUpdateMailBCC">
                                <span style="font-weight: 400; margin-top: 20px">BCC</span>
                                <el-row>
                                  <el-col :span="3">
                                    <el-select
                                      v-model="
                                        formBuilder.receiver_approval_update_mail_template
                                          .bcc_user_type
                                      "
                                      size="mini"
                                      clearable
                                      placeholder="Select user type"
                                    >
                                      <el-option
                                        v-for="userType in ccuserTypes"
                                        :key="userType.value"
                                        :label="userType.label"
                                        :value="userType.value"
                                      ></el-option>
                                    </el-select>
                                  </el-col>
                                  <template
                                    v-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .bcc_user_type == 'COMPANY'
                                    "
                                  >
                                    <el-col :span="3">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_company_user_type
                                        "
                                        clearable
                                        size="mini"
                                        placeholder="Select company user type"
                                        class="ml-1"
                                      >
                                        <el-option
                                          v-for="item in getUserTypeList"
                                          :key="item._id"
                                          :label="getLabel(item)"
                                          :value="item._id"
                                        ></el-option>
                                      </el-select>
                                    </el-col>
                                    <el-col :span="6">
                                      <el-select
                                        v-if="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_company_user_type
                                        "
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_user
                                        "
                                        clearable
                                        size="mini"
                                        multiple
                                        placeholder="Select mail"
                                        class="ml-1"
                                        default-first-option
                                      >
                                        <el-option
                                          v-for="item in getCompanyUsersByType(
                                            formBuilder.receiver_approval_update_mail_template
                                              .bcc_company_user_type
                                          )"
                                          :key="item._id + '_company_user'"
                                          :label="item.email"
                                          :value="item.email"
                                        >
                                          {{ item.email }}
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .bcc_user_type == 'APPLICATION'
                                    "
                                  >
                                    <el-col :span="4">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_application_user_type
                                        "
                                        clearable
                                        size="mini"
                                        placeholder="Select application user type"
                                        class="ml-1"
                                      >
                                        <el-option
                                          v-for="(type, index) in (getAllContactTypes &&
                                            getAllContactTypes.data) ||
                                          getAllContactTypes"
                                          :key="index + 1"
                                          :value="type._id"
                                          :label="type.name"
                                        >
                                          {{ type.name }}
                                        </el-option>
                                      </el-select>
                                    </el-col>
                                    <el-col :span="6">
                                      <div
                                        class="ml-1"
                                        v-if="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_application_user_type
                                        "
                                      >
                                        <el-select
                                          v-model="
                                            formBuilder.receiver_approval_update_mail_template
                                              .bcc_user
                                          "
                                          clearable
                                          multiple
                                          size="mini"
                                          placeholder="Select mail"
                                        >
                                          <el-option
                                            v-for="(contact, index) in getUserTypeContacts(
                                              formBuilder.receiver_approval_update_mail_template
                                                .bcc_application_user_type
                                            )"
                                            :key="index + '_application_user_mail'"
                                            :value="contact.email"
                                            :label="contact.email"
                                          >
                                            {{ contact.email }}
                                          </el-option>
                                        </el-select>
                                      </div>
                                    </el-col>
                                  </template>
                                  <template
                                    v-else-if="
                                      formBuilder.receiver_approval_update_mail_template
                                        .bcc_user_type == 'CUSTOM'
                                    "
                                  >
                                    <el-col :span="6" class="ml-1">
                                      <el-select
                                        v-model="
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_user
                                        "
                                        placeholder="Custom Bcc Emails"
                                        size="mini"
                                        class="email-field"
                                        multiple
                                        clearable
                                        filterable
                                        collapse-tags
                                        allow-create
                                        default-first-option
                                      >
                                        <el-option
                                          v-for="item in formBuilder.receiver_approval_update_mail_template &&
                                          formBuilder.receiver_approval_update_mail_template
                                            .bcc_user"
                                          :key="item"
                                          :label="item"
                                          :value="item"
                                        ></el-option>
                                      </el-select>
                                    </el-col>
                                  </template>
                                </el-row>
                              </div>
                              <br />
                              <span style="font-weight: 400">Subject</span>
                              <el-input
                                v-model="formBuilder.receiver_approval_update_mail_template.subject"
                                placeholder="Enter Subject"
                                class="mb-1"
                              ></el-input>
                              <span style="font-weight: 400">Custom Message</span>
                              <CkEditorOffline
                                v-model="formBuilder.receiver_approval_update_mail_template.body"
                                :config="editorConfig3"
                              ></CkEditorOffline>
                              <div
                                @click="chooseFromRecieverApprovalMailTemps"
                                style="
                                  cursor: pointer;
                                  color: #409eff;
                                  margin-left: 200px;
                                  margin-top: 10px;
                                "
                              >
                                <span
                                  v-if="!formBuilder.receiver_approval_update_mail_template.name"
                                >
                                  Choose Parent Template(Header & Footer)
                                </span>
                                <span v-else>Change Parent Template (Header & Footer)</span>
                              </div>
                              <div
                                v-if="formBuilder.receiver_approval_update_mail_template.name"
                                class="mb-2"
                                style="margin-left: 200px"
                              >
                                Selected Parent :
                                <span>
                                  {{ formBuilder.receiver_approval_update_mail_template.name }}
                                </span>
                                <span>
                                  <i
                                    style="cursor: pointer"
                                    @click="resetParentReceiverApprovalMail"
                                    class="el-icon-error"
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane
                            label="Receiver's Rejection Update Mail Template"
                            name="receiver_rejection_mail"
                          >
                            <div>
                              <span class="my-1 pt-1 d-block" style="font-weight: 400">
                                Subject
                              </span>
                              <el-input
                                v-model="
                                  formBuilder.receiver_rejection_update_mail_template.subject
                                "
                                placeholder="Enter Subject"
                                class="mb-1"
                              ></el-input>
                              <span class="my-1 pt-1 d-block" style="font-weight: 400">
                                Custom Message
                              </span>
                              <CkEditorOffline
                                v-model="formBuilder.receiver_rejection_update_mail_template.body"
                                :config="editorConfig5"
                              ></CkEditorOffline>
                              <div
                                @click="chooseFromRecieverRejectionMailTemps"
                                style="
                                  cursor: pointer;
                                  color: #409eff;
                                  margin-left: 200px;
                                  margin-top: 10px;
                                "
                              >
                                <span
                                  v-if="!formBuilder.receiver_rejection_update_mail_template.name"
                                >
                                  Choose Parent Template(Header & Footer)
                                </span>
                                <span v-else>Change Parent Template (Header & Footer)</span>
                              </div>
                              <div
                                v-if="formBuilder.receiver_rejection_update_mail_template.name"
                                class="mb-2"
                                style="margin-left: 200px"
                              >
                                Selected Parent :
                                <span>
                                  {{ formBuilder.receiver_rejection_update_mail_template.name }}
                                </span>
                                <span>
                                  <i
                                    style="cursor: pointer"
                                    @click="resetParentReceiverRejectionMail"
                                    class="el-icon-error"
                                  ></i>
                                </span>
                              </div>
                            </div>
                          </el-tab-pane>
                          <el-tab-pane
                            label="Fields to be shown for anonymous form"
                            v-if="formBuilder && formBuilder.form_builders_owner == 'ANONYMOUS'"
                          >
                            <el-select
                              placeholder="Primary fields"
                              v-model="formBuilder.primary_fields"
                              multiple
                              collapse-tags
                              class="mt-1 w-[280px]"
                            >
                              <el-option
                                v-for="field in allFormbuilderFields"
                                :key="field.key"
                                :value="field.key"
                                :label="field.label"
                              ></el-option>
                            </el-select>
                          </el-tab-pane>
                        </el-tabs>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane
                      name="approval_data_actions"
                      class="!border !border-[#E9EBEC] py-3 px-3 my-3 w-full rounded-lg !bg-white !space-y-4 mr-3"
                    >
                      <span slot="label">
                        <i class="el-icon-circle-check"></i>
                        Approval Data Actions
                      </span>
                      <div v-if="formBuilder.is_approval_form">
                        <div>
                          <el-radio-group v-model="formBuilder.approval_data_actions_type">
                            <el-radio label="SIMPLE">Direct Actions</el-radio>
                            <el-radio
                              v-if="formBuilder.approval_configuration_type == 'STANDARD'"
                              label="CONDITIONAL"
                            >
                              Conditional Actions
                            </el-radio>
                          </el-radio-group>
                        </div>
                        <br />
                        <div v-if="formBuilder.approval_data_actions_type == 'SIMPLE'">
                          <el-radio-group v-model="selectedActionType" class="mb-2">
                            <el-radio label="approved">When Approved</el-radio>
                            <el-radio label="rejected">When Rejected</el-radio>
                          </el-radio-group>
                        </div>
                        <table
                          v-if="formBuilder.approval_data_actions_type == 'SIMPLE'"
                          style="
                            width: 72%;
                            border-collapse: collapse;
                            margin-top: 20px;
                            border: 1px solid lightgrey;
                          "
                        >
                          <thead>
                            <tr style="text-align: left">
                              <th
                                style="width: 150px; padding: 8px; border: 1px solid lightgrey"
                                v-if="formBuilder.enforce_order"
                              >
                                Level
                              </th>
                              <th
                                style="
                                  width: 200px;
                                  padding: 8px;
                                  border: 1px solid lightgrey;
                                  font-weight: 500;
                                "
                              >
                                Field
                              </th>
                              <th
                                style="
                                  width: 200px;
                                  padding: 8px;
                                  border: 1px solid lightgrey;
                                  font-weight: 500;
                                "
                              >
                                Update with
                              </th>
                              <th
                                style="
                                  width: 150px;
                                  padding: 8px;
                                  border: 1px solid lightgrey;
                                  font-weight: 500;
                                "
                              >
                                Send Form
                              </th>
                              <th style="width: 60px; padding: 8px; border: 1px solid lightgrey">
                                <el-button
                                  @click="addApprovalAction(selectedActionType)"
                                  type="success"
                                  size="mini"
                                >
                                  <i class="el-icon-plus"></i>
                                  Add
                                </el-button>
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <!-- Approved Actions -->
                            <template v-if="selectedActionType === 'approved'">
                              <tr
                                v-for="(action, index) in formBuilder.approval_data_actions"
                                :key="action.field_key + index"
                              >
                                <td
                                  style="padding: 8px; border: 1px solid lightgrey"
                                  v-if="formBuilder.enforce_order"
                                >
                                  <el-select
                                    v-model="action.level"
                                    placeholder="Select the level"
                                    clearable
                                    size="mini"
                                  >
                                    <el-option
                                      v-for="(level, i) in formBuilder.approval_users"
                                      :key="'level_' + i"
                                      :label="'Level - ' + (i + 1)"
                                      :value="i"
                                    />
                                  </el-select>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <el-select
                                    v-model="action.field_key"
                                    placeholder="Select the field"
                                    clearable
                                    filterable
                                    size="mini"
                                    @change="updateApprovalActionsObject"
                                  >
                                    <el-option
                                      v-for="field in getMappedFormbuilderFields()"
                                      :key="field.key"
                                      :label="field.label"
                                      :value="field.key"
                                    />
                                  </el-select>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <AnyFieldsExecute
                                    v-if="action.field_key"
                                    :fieldsData="getMappedFormbuilderFields()"
                                    :field="getSelectedField(action.field_key)"
                                    :form="approvalActionsMapObject[index]"
                                  />
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <div style="display: flex; align-items: center; gap: 4px">
                                    <el-select
                                      placeholder="Select form builder"
                                      v-model="action.formbuilder_id"
                                      clearable
                                      filterable
                                      size="mini"
                                    >
                                      <el-option
                                        v-for="(op, i) in allFormbuilders.filter(
                                          (e) =>
                                            e.form_builders_owner !== 'ANONYMOUS' &&
                                            e._id !== formBuilder._id
                                        )"
                                        :key="op._id + i"
                                        :value="op._id"
                                        :label="op.name"
                                      >
                                        {{ op.name }}
                                      </el-option>
                                    </el-select>

                                    <el-button
                                      v-if="action.formbuilder_id"
                                      @click="
                                        openActionsFormbuilderMailTemplate(
                                          index,
                                          selectedActionType
                                        )
                                      "
                                      type="text"
                                      icon="el-icon-s-tools"
                                    ></el-button>
                                  </div>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <el-button
                                    type="primary"
                                    icon="el-icon-delete"
                                    size="mini"
                                    @click="removeApprovalAction('approved', index)"
                                  />
                                </td>
                              </tr>
                            </template>

                            <!-- Rejected Actions -->
                            <template v-if="selectedActionType === 'rejected'">
                              <tr
                                v-for="(action, index) in formBuilder.reject_data_actions"
                                :key="action.field_key"
                              >
                                <td
                                  style="padding: 8px; border: 1px solid lightgrey"
                                  v-if="formBuilder.enforce_order"
                                >
                                  <el-select
                                    v-model="action.level"
                                    placeholder="Select the level"
                                    clearable
                                    size="mini"
                                  >
                                    <el-option
                                      v-for="(level, i) in formBuilder.approval_users"
                                      :key="'level_' + i"
                                      :label="'Level - ' + (i + 1)"
                                      :value="i"
                                    />
                                  </el-select>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <el-select
                                    v-model="action.field_key"
                                    placeholder="Select the field"
                                    clearable
                                    filterable
                                    size="mini"
                                    @change="updateRejectActionsObject"
                                  >
                                    <el-option
                                      v-for="field in getMappedFormbuilderFields()"
                                      :key="field.key"
                                      :label="field.label"
                                      :value="field.key"
                                    />
                                  </el-select>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <AnyFieldsExecute
                                    v-if="action.field_key"
                                    :fieldsData="getMappedFormbuilderFields()"
                                    :field="getSelectedField(action.field_key)"
                                    :form="rejectActionsMapObject[index]"
                                  />
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <div style="display: flex; align-items: center; gap: 4px">
                                    <el-select
                                      placeholder="Select form builder"
                                      v-model="action.formbuilder_id"
                                      clearable
                                      filterable
                                      size="mini"
                                    >
                                      <el-option
                                        v-for="(op, i) in allFormbuilders.filter(
                                          (e) =>
                                            e.form_builders_owner !== 'ANONYMOUS' &&
                                            e._id !== formBuilder._id
                                        )"
                                        :key="op._id + i"
                                        :value="op._id"
                                        :label="op.name"
                                      >
                                        {{ op.name }}
                                      </el-option>
                                    </el-select>

                                    <el-button
                                      v-if="action.formbuilder_id"
                                      @click="
                                        openActionsFormbuilderMailTemplate(
                                          index,
                                          selectedActionType
                                        )
                                      "
                                      type="text"
                                      icon="el-icon-s-tools"
                                    ></el-button>
                                  </div>
                                </td>
                                <td style="padding: 8px; border: 1px solid lightgrey">
                                  <el-button
                                    type="primary"
                                    icon="el-icon-delete"
                                    size="mini"
                                    @click="removeApprovalAction('rejected', index)"
                                  />
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                        <div v-if="formBuilder.approval_data_actions_type == 'CONDITIONAL'">
                          <AdvancedApprovalDataActions
                            :formBuilder="formBuilder"
                            :allFormbuilderFields="getFormBuilderAllFields()"
                            :allFormbuilders="allFormbuilders"
                          ></AdvancedApprovalDataActions>
                        </div>
                      </div>
                      <div v-else>
                        <span class="warning">
                          <i class="el-icon-info"></i>
                          This form is not an approval form.
                        </span>
                      </div>
                      <!-- </div> -->
                    </el-tab-pane>
                    <el-tab-pane name="rework_settings">
                      <span slot="label">
                        <i class="el-icon-refresh"></i>
                        Rework Settings
                      </span>
                      <div
                        class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                      >
                        <el-checkbox v-model="formBuilder.allow_rework_on_form" class="mb-1">
                          Allow rework on form
                        </el-checkbox>
                        <br />
                        <div v-if="formBuilder.allow_rework_on_form">
                          <div class="!mb-1 !mt-1.5">Button name</div>
                          <el-input
                            v-model="formBuilder.customization.rework_button_name"
                            placeholder="Enter button name"
                            class="mb-1"
                          ></el-input>
                          <div class="!mb-1 !mt-1.5">Subject</div>
                          <el-input
                            v-model="formBuilder.rework_user_mail_template.subject"
                            placeholder="Enter Subject"
                            class="mb-1"
                          ></el-input>
                          <div class="!mb-1 !mt-1.5">Custom Message</div>
                          <CkEditorOffline
                            v-model="formBuilder.rework_user_mail_template.body"
                            :config="editorConfig6"
                          ></CkEditorOffline>
                          <div
                            @click="chooseFromReworkMailTemps"
                            style="cursor: pointer; color: #409eff; margin-left: 200px"
                          >
                            <span v-if="!formBuilder.rework_user_mail_template.name">
                              Choose Parent Template(Header & Footer)
                            </span>
                            <span v-else>Change Parent Template (Header & Footer)</span>
                          </div>
                          <div
                            v-if="formBuilder.rework_user_mail_template.name"
                            class="mb-2"
                            style="margin-left: 200px"
                          >
                            Selected Parent :
                            <span>{{ formBuilder.rework_user_mail_template.name }}</span>
                            <span>
                              <i
                                style="cursor: pointer"
                                @click="resetReworkMailTemplate"
                                class="el-icon-error"
                              ></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane name="expiration_settings">
                      <span slot="label">
                        <i class="el-icon-time"></i>
                        Expiration Settings
                      </span>
                      <div
                        class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                      >
                        <span>
                          When form response is in pending status, in how many days/months/years
                          will it be expired?
                        </span>
                        <el-row class="mt-1">
                          <el-select
                            placeholder="Expiry type"
                            v-model="formBuilder.expiration_settings.expiry_type"
                          >
                            <el-option value="YEARS" label="Year(s)"></el-option>
                            <el-option value="MONTHS" label="Month(s)"></el-option>
                            <el-option value="DAYS" label="Day(s)"></el-option>
                          </el-select>
                          <el-input-number
                            placeholder="Expiry Duration"
                            v-model="formBuilder.expiration_settings.expiry_duration"
                            :min="0"
                            class="ml-1"
                          ></el-input-number>
                        </el-row>
                      </div>
                    </el-tab-pane>
                    <el-tab-pane
                      name="customization"
                      class="border border-[#E9EBEC] p-3 my-3 w-full rounded-lg !bg-white !space-y-4"
                      v-if="!fromEntityData"
                    >
                      <span slot="label">
                        <i class="el-icon-finished"></i>
                        Customization
                      </span>
                      <div>
                        <el-row>
                          <el-col :span="12" style="display: flex">
                            <span style="white-space: nowrap; margin-right: 8px">
                              Add button label:
                            </span>
                            <el-input
                              style="margin-right: 8px"
                              v-model="formBuilder.customization.add_button_label"
                              placeholder="Enter label"
                            ></el-input>
                            <el-select
                              placeholder="Select button size"
                              v-model="formBuilder.customization.add_button_size"
                              style="width: 100%; margin-right: 8px"
                              clearable
                            >
                              <el-option value="small" label="Small"></el-option>
                              <el-option value="medium" label="Medium"></el-option>
                              <el-option value="large" label="Large"></el-option>
                            </el-select>
                            <el-color-picker
                              style="margin-right: 8px"
                              v-model="formBuilder.customization.add_button_color"
                              show-alpha
                            ></el-color-picker>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="12" style="display: flex">
                            <span style="white-space: nowrap; margin-right: 8px">
                              Finish button label:
                            </span>
                            <el-input
                              style="width: 98%; margin-right: 8px"
                              v-model="formBuilder.customization.finish_button_label"
                              placeholder="Enter label"
                            ></el-input>
                            <el-select
                              placeholder="Select button size"
                              v-model="formBuilder.customization.finish_button_size"
                              style="width: 98%; margin-right: 8px"
                              clearable
                            >
                              <el-option value="small" label="Small"></el-option>
                              <el-option value="medium" label="Medium"></el-option>
                              <el-option value="large" label="Large"></el-option>
                            </el-select>
                            <el-color-picker
                              v-model="formBuilder.customization.finish_button_color"
                              show-alpha
                            ></el-color-picker>
                          </el-col>
                        </el-row>
                        <el-row>
                          <el-col class="flex items-center !pt-1.5" :span="12">
                            <span style="white-space: nowrap; margin-right: 8px">
                              Buttons Background color:
                            </span>
                            <el-color-picker
                              v-model="formBuilder.customization.button_background_color"
                              show-alpha
                            ></el-color-picker>
                          </el-col>
                        </el-row>
                        <el-row>
                          <div
                            class="color-box mt-1 mb-1"
                            style="flex-basis: 33.33%; box-sizing: border-box"
                          >
                            <span>Default Font type</span>
                            <el-select
                              placeholder="Select default Font"
                              v-model="formBuilder.customization.default_font_type"
                              style="width: 100%"
                              clearable
                            >
                              <el-option
                                v-for="(option, index) of getAvailableFontTypes"
                                :value="option.value"
                                :label="option.name"
                                :key="index"
                              >
                                <p :style="'font-family:' + option.value">
                                  {{ option.name }}
                                </p>
                              </el-option>
                            </el-select>
                          </div>
                        </el-row>
                        <el-row>
                          <el-col :span="6">
                            <el-checkbox v-model="formBuilder.customization.show_link_to_be_copy">
                              Show link to copy
                            </el-checkbox>
                            <el-checkbox v-model="formBuilder.customization.show_detailed_link">
                              Show detailed view
                            </el-checkbox>
                            <el-checkbox
                              v-model="formBuilder.customization.show_initial_confirmation"
                            >
                              Show initial confirmation to continue
                            </el-checkbox>
                            <el-checkbox
                              v-model="formBuilder.customization.show_try_esigns_and_content"
                            >
                              Show try Our Application button and content
                            </el-checkbox>
                            <el-checkbox v-model="formBuilder.customization.show_title_bar">
                              Show top bar and company logo
                            </el-checkbox>
                            <div class="alignment-buttons mt-1">
                              Select position of update, Next & Finish button
                              <span>
                                <el-select
                                  v-model="formBuilder.customization.button_position"
                                  placeholder="Select"
                                >
                                  <el-option
                                    v-for="(item, index) in positionOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                  ></el-option>
                                </el-select>
                              </span>
                              <span>
                                <el-select
                                  v-model="formBuilder.customization.button_horizontal_position"
                                  placeholder="Select"
                                >
                                  <el-option
                                    v-for="(item, index) in horizontalPositionOptions"
                                    :key="index"
                                    :label="item.label"
                                    :value="item.value"
                                  ></el-option>
                                </el-select>
                              </span>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                      <el-row>
                        <el-col :span="24">
                          <el-checkbox v-model="formBuilder.customization.isFormLabel">
                            Add customized form label for approver
                          </el-checkbox>
                          <el-checkbox v-model="formBuilder.customization.save_as_draft">
                            Save as draft
                          </el-checkbox>
                        </el-col>
                      </el-row>
                      <div v-if="formBuilder.customization.isFormLabel">
                        <el-row type="flex" style="margin-top: 15px">
                          <el-col :span="6">
                            <span class="pb-1 d-block">Select Fields</span>
                            <el-select
                              v-model="ConcatenateFields"
                              placeholder="Select the field"
                              clearable
                              filterable
                              size="mini"
                            >
                              <el-option
                                v-for="field in getAvailableFields()"
                                :key="field.key"
                                :label="field.label"
                                :value="field.key"
                              />
                            </el-select>
                            <el-button
                              size="mini"
                              type="primary"
                              @click="addOptionToList"
                              style="margin-left: 8px"
                              class="mb-1"
                            >
                              Add
                            </el-button>
                          </el-col>

                          <!-- Second Column -->
                          <el-col :span="6">
                            <span>Add Separator</span>
                            <el-input
                              maxlength="50"
                              v-model="formBuilder.customization.separator"
                              placeholder="Add any separator"
                            />
                          </el-col>
                        </el-row>
                        <!-- Draggable Field Order -->
                        <el-row type="flex" :gutter="30">
                          <el-col :span="12">
                            <u>Drag Fields to Change Order</u>
                            <el-button
                              type="danger"
                              @click="popField()"
                              class="btn-operation"
                              size="mini"
                              :disabled="formBuilder.customization?.selected_fields?.length < 1"
                              style="margin-left: 8px"
                            >
                              <i class="el-icon-delete"></i>
                            </el-button>
                            <draggable v-model="formBuilder.customization.selected_fields">
                              <th
                                v-for="(column, index) in formBuilder.customization.selected_fields"
                                :key="index"
                              >
                                <el-tag effect="dark">
                                  {{ getFieldLabel(column) }}
                                </el-tag>
                              </th>
                            </draggable>
                          </el-col>
                        </el-row>
                      </div>
                      <div v-if="!fromEntityData" class="mt-1">
                        <div class="field-label">
                          <span>Based on filled data</span>
                          <el-tooltip
                            content="Form setting will be based on filled data,If that data reocrd contains setting for this form builder."
                            placement="top"
                          >
                            <i class="el-icon-question ml-1 text-gray-500 cursor-pointer"></i>
                          </el-tooltip>
                        </div>
                        <el-select
                          v-model="formBuilder.customization.settingField"
                          placeholder="Select the field"
                          clearable
                          filterable
                          size="mini"
                          @change="handleSettingFieldChange"
                        >
                          <el-option
                            v-for="field in getAvailableFields().filter(
                              (f) => f.inputType === 'ENTITY'
                            )"
                            :key="field.key"
                            :label="field.label"
                            :value="field.key"
                          />
                        </el-select>
                        <div
                          v-if="formBuilder.customization.settingField"
                          style="margin-top: 6px; color: #909399; font-size: 12px"
                        >
                          you can create this form builder setting at
                          <b>{{ settingEntityName }}</b>
                          entity
                        </div>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                  <!-- For mobile view -->
                  <el-collapse v-if="getIsMobile" v-model="activeMainTab">
                    <el-collapse-item name="primary_settings">
                      <template #title>
                        <span>
                          <i class="el-icon-alarm-clock"></i>
                          Primary Settings
                        </span>
                      </template>
                      <el-row>
                        <el-col :span="8">
                          <h4>Form builder availability</h4>
                          <el-radio-group
                            v-model="formBuilder.settings.is_time_bond"
                            size="mini"
                            style="display: flex"
                          >
                            <el-radio :label="false" border>All Time</el-radio>
                            <el-radio :label="true" border>Limited Period</el-radio>
                          </el-radio-group>
                        </el-col>
                      </el-row>
                      <el-row>
                        <h4 v-if="formBuilder.settings.is_time_bond" style="padding: 5px">
                          Select Date & Time Range
                        </h4>
                        <el-form
                          :inline="true"
                          class="demo-form-inline"
                          v-if="formBuilder.settings.is_time_bond"
                        >
                          <el-date-picker
                            :format="'MM-dd-yyyy HH:mm:ss'"
                            v-model="formBuilder.settings.formbuilder_date_range"
                            type="datetimerange"
                            :picker-options="pickerOptions"
                            range-separator="To"
                            start-placeholder="Start date"
                            end-placeholder="End date"
                            popper-class="my-popover"
                            size="mini"
                          ></el-date-picker>
                        </el-form>
                      </el-row>
                      <el-row class="mt-3">
                        <el-checkbox
                          v-if="formBuilder.form_builders_owner !== 'ANONYMOUS'"
                          v-model="formBuilder.settings.secure_access"
                        >
                          Secure access
                        </el-checkbox>
                        <el-checkbox
                          v-if="
                            formBuilder.form_builders_owner !== 'USER' &&
                            formBuilder.form_builders_owner !== 'ANONYMOUS'
                          "
                          v-model="formBuilder.settings.access_to_all"
                        >
                          Allow new users to fill
                        </el-checkbox>
                        <el-checkbox
                          v-if="
                            selectedUserEntity &&
                            selectedUserEntity.name &&
                            formBuilder.settings.access_to_all &&
                            selectedUserEntity.entity_type === 'BUSINESS'
                          "
                          v-model="formBuilder.settings.select_from_existing"
                        >
                          Allow user to Select from existing
                          {{ selectedUserEntity.name }} data
                        </el-checkbox>
                      </el-row>
                    </el-collapse-item>

                    <el-collapse-item
                      v-if="formBuilder.form_builders_owner == 'ENTITY'"
                      title="schedule_settings"
                      name="schedule_settings"
                    >
                      <span slot="label">
                        <i class="el-icon-alarm-clock"></i>
                        Schedule Settings
                      </span>
                      <el-form ref="form" label-width="200px">
                        <el-form ref="form" label-width="120px" label-position="top">
                          <el-form-item label="User will Submit Form builder data">
                            <el-radio-group v-model="formBuilder.settings.frequency">
                              <el-radio :label="false">Only One Time</el-radio>
                              <el-radio :label="true">Allow Multiple Submissions</el-radio>
                            </el-radio-group>
                          </el-form-item>

                          <el-checkbox
                            v-if="formBuilder.settings.frequency"
                            v-model="formBuilder.settings.schedules.status"
                          >
                            Add Schedules for User
                          </el-checkbox>
                          <el-checkbox
                            v-if="
                              formBuilder.settings &&
                              formBuilder.settings.frequency &&
                              formBuilder.settings.schedules.status
                            "
                            v-model="formBuilder.settings.is_allowed_to_all_users"
                            class="ml-3"
                          >
                            Add Schedules for all User
                          </el-checkbox>
                          <div style="display: flex">
                            <el-form-item
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status
                              "
                              label="Select Time Zone"
                            >
                              <el-select
                                v-model="formBuilder.settings.schedules.time_zone"
                                placeholder="Select Timezone"
                                :filterable="true"
                                :clearable="true"
                                size="mini"
                              >
                                <el-option
                                  v-for="(timezone, index) of time_zone"
                                  :key="index"
                                  :label="timezone"
                                  :value="timezone"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status &&
                                !formBuilder.settings.is_allowed_to_all_users
                              "
                              label="Select users to add schedules"
                              class="ml-2"
                            >
                              <el-select
                                v-model="formBuilder.settings.allowed_entity_users"
                                placeholder="Select user"
                                :filterable="true"
                                :clearable="true"
                                multiple
                                size="mini"
                                collapse-tags
                              >
                                <el-option
                                  v-for="(user, index) of entityUsers"
                                  :key="index + user._id"
                                  :label="user.email"
                                  :value="user._id + '#' + user.email"
                                ></el-option>
                              </el-select>
                            </el-form-item>
                            <el-form-item
                              label="Expires after schedule sent"
                              v-if="
                                formBuilder.settings &&
                                formBuilder.settings.frequency &&
                                formBuilder.settings.schedules.status
                              "
                              class="ml-1"
                            >
                              <el-input-number
                                :controls="false"
                                v-model="formBuilder.settings.schedules.expired_time_interval_value"
                                size="mini"
                              ></el-input-number>

                              <el-select
                                v-model="formBuilder.settings.schedules.expired_time_interval_type"
                                placeholder="Select Type"
                                class="ml-1"
                                size="mini"
                              >
                                <el-option label="DAYS" value="DAYS"></el-option>
                                <el-option label="WEEKS" value="WEEKS"></el-option>
                                <el-option label="MONTHS" value="MONTHS"></el-option>
                                <el-option label="YEARS" value="YEARS"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <el-form-item
                            v-if="
                              formBuilder.settings &&
                              formBuilder.settings.frequency &&
                              formBuilder.settings.schedules.status
                            "
                          >
                            <el-row>
                              <el-col :span="7">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutes="isminutesIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllminutes"
                                        @change="handleCheckMinutesChange"
                                      >
                                        Minutes
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.minutes"
                                      @change="handleCheckedMinuteChange"
                                    >
                                      <el-checkbox
                                        v-for="minute in minutes"
                                        :label="minute"
                                        :key="minute"
                                      >
                                        {{ minute }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="4">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminuteshours="ishoursIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllhours"
                                        @change="handleCheckHoursChange"
                                      >
                                        Hours
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.hours"
                                      @change="handleCheckedHourChange"
                                    >
                                      <el-checkbox v-for="hour in hours" :label="hour" :key="hour">
                                        {{ hour }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="5">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesdays="isdaysIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAlldays"
                                        @change="handleCheckDaysChange"
                                      >
                                        Days
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.days"
                                      @change="handleCheckedDayChange"
                                    >
                                      <el-checkbox v-for="day in days" :label="day" :key="day">
                                        {{ day }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="3">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesweeks="isweeksIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllweeks"
                                        @change="handleCheckWeeksChange"
                                      >
                                        Days of Week
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.days_of_week"
                                      @change="handleCheckedWeekChange"
                                    >
                                      <el-checkbox v-for="week in weeks" :label="week" :key="week">
                                        {{ week }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="3">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesmonths="ismonthsIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllmonths"
                                        @change="handleCheckMonthsChange"
                                      >
                                        Months
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.months"
                                      @change="handleCheckedMonthChange"
                                    >
                                      <el-checkbox
                                        v-for="month in months"
                                        :label="month"
                                        :key="month"
                                      >
                                        {{ month }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                              <el-col :span="2">
                                <el-card class="box-card">
                                  <div slot="header" class="clearfix">
                                    <span>
                                      <el-checkbox
                                        :indeterminateminutesyears="isyearsIndeterminate"
                                        v-model="formBuilder.settings.schedules.checkAllyears"
                                        @change="handleCheckYearsChange"
                                      >
                                        Years
                                      </el-checkbox>
                                    </span>
                                  </div>
                                  <div class="text item">
                                    <el-checkbox-group
                                      v-model="formBuilder.settings.schedules.years"
                                      @change="handleCheckedYearChange"
                                    >
                                      <el-checkbox v-for="year in years" :label="year" :key="year">
                                        {{ year }}
                                      </el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-card>
                              </el-col>
                            </el-row>
                          </el-form-item>
                        </el-form>
                      </el-form>
                    </el-collapse-item>

                    <el-collapse-item
                      v-if="formBuilder.form_builders_owner"
                      name="user_submission_settings"
                    >
                      <template #title>
                        <span>
                          <i class="el-icon-tickets"></i>
                          User Submission Settings
                        </span>
                      </template>
                      <el-form ref="form" label-width="120px" label-position="top">
                        <el-form-item label="User will Submit Form builder data">
                          <el-radio-group v-model="formBuilder.settings.frequency">
                            <el-radio :label="false">Only One Time</el-radio>
                            <el-radio :label="true">Allow Multiple Submissions</el-radio>
                          </el-radio-group>
                        </el-form-item>

                        <el-form-item
                          label="User will submit multiple Form builder data"
                          v-if="formBuilder.settings.frequency"
                        >
                          <el-radio-group
                            v-model="formBuilder.settings.limit_responses"
                            :disable="formBuilder.settings.frequency"
                          >
                            <el-radio :label="false">No Limit</el-radio>
                            <el-radio :label="true">Max Submissions for Single User</el-radio>
                          </el-radio-group>
                          <el-input-number
                            class="!ml-2"
                            v-if="
                              formBuilder.settings.limit_responses && formBuilder.settings.frequency
                            "
                            type="number"
                            v-model="formBuilder.settings.no_responses_limited"
                          />
                        </el-form-item>

                        <el-form-item label="User will view or edit his/her submitted responses">
                          <el-checkbox v-model="formBuilder.settings.view_responses">
                            Allow user to View
                          </el-checkbox>
                          <el-checkbox
                            v-model="formBuilder.settings.edit_responses"
                            v-if="formBuilder.settings.view_responses"
                          >
                            Allow user to edit
                          </el-checkbox>
                        </el-form-item>

                        <el-form-item
                          label="Form builder Total Submissions"
                          v-if="formBuilder.settings.frequency"
                        >
                          <el-radio-group v-model="formBuilder.settings.limit_total_submissions">
                            <el-radio :label="false">No Limit</el-radio>
                            <el-radio :label="true">
                              Max Submissions allowed for Form builder
                            </el-radio>
                          </el-radio-group>
                          <el-input-number
                            class="!ml-2"
                            v-if="formBuilder.settings.limit_total_submissions"
                            type="number"
                            v-model="formBuilder.settings.no_total_submissions_limited"
                          />
                        </el-form-item>
                      </el-form>
                    </el-collapse-item>

                    <el-collapse-item name="success_pages_redirects">
                      <template #title>
                        <span>
                          <i class="el-icon-finished"></i>
                          Success Pages & Redirects
                        </span>
                      </template>

                      <el-form ref="form" label-width="120px" label-position="top">
                        <el-form-item>
                          <label for="">Success Page</label>
                          <div class="!mb-2">
                            <el-checkbox
                              v-model="
                                formBuilder.settings.success_and_redirect_page.notify_reciever
                              "
                            >
                              Notify Reciever
                            </el-checkbox>
                            <el-checkbox
                              v-model="formBuilder.settings.success_and_redirect_page.notify_sender"
                            >
                              Notify Owners
                            </el-checkbox>
                          </div>
                          <div>
                            <el-select
                              class="!mb-2"
                              v-if="formBuilder.settings.success_and_redirect_page.notify_sender"
                              multiple
                              collapse-tags
                              v-model="
                                formBuilder.settings.success_and_redirect_page.mail_recievers
                              "
                              style="width: 350px"
                              placeholder="Select E-mail Recievers"
                            >
                              <el-option
                                v-for="user of company_users.filter((e) =>
                                  formBuilder.form_builder_owners.includes(e._id)
                                )"
                                :key="user.email"
                                :label="user.email"
                                :value="user._id"
                              ></el-option>
                            </el-select>
                          </div>
                          <el-switch
                            class="!pt-1 !px-2"
                            v-model="formBuilder.settings.success_and_redirect_page.redirect_to"
                            inactive-text="Thankyou Page"
                            active-text="Redirects to Page"
                            active-color="var(--brand-500)"
                            inactive-color="var(--black-200)"
                          ></el-switch>
                        </el-form-item>

                        <el-form-item
                          label="Redirect URL"
                          v-if="formBuilder.settings.success_and_redirect_page.redirect_to"
                        >
                          <el-input
                            v-model="formBuilder.settings.success_and_redirect_page.redirect_to_url"
                          />
                        </el-form-item>

                        <div
                          class="text-editor"
                          v-if="!formBuilder.settings.success_and_redirect_page.redirect_to"
                        >
                          <label class="label !pb-1.5">Thank you page text</label>
                          <CkEditorOffline
                            v-model="formBuilder.settings.success_and_redirect_page.thankyou_page"
                            :config="editorConfig2"
                          ></CkEditorOffline>
                          <!-- <TextEditor
                        :editorData.sync="
                          formBuilder.settings.success_and_redirect_page
                            .thankyou_page
                        "
                        ></TextEditor>-->
                        </div>
                      </el-form>
                    </el-collapse-item>

                    <el-collapse-item
                      v-if="this.formBuilder.settings.reminder_settings"
                      name="reminder_settings"
                    >
                      <template #title>
                        <span>
                          <i class="el-icon-bell"></i>
                          Reminder Settings
                        </span>
                      </template>
                      <el-form>
                        <el-form-item label="Send reminders">
                          <el-checkbox
                            v-model="formBuilder.settings.reminder_settings.status"
                          ></el-checkbox>
                        </el-form-item>

                        <el-form-item
                          label="Send first reminder"
                          v-if="formBuilder.settings.reminder_settings.status"
                        >
                          after schedule sent
                          <el-input-number
                            :controls="false"
                            v-model="
                              formBuilder.settings.reminder_settings.first_reminder_interval_value
                            "
                            size="mini"
                          ></el-input-number>

                          <el-select
                            v-model="
                              formBuilder.settings.reminder_settings.first_reminder_interval_type
                            "
                            placeholder="Select Type"
                            class="ml-1"
                            size="mini"
                          >
                            <el-option label="MINUTES" value="MINUTES"></el-option>
                            <el-option label="HOURS" value="HOURS"></el-option>
                            <el-option label="DAYS" value="DAYS"></el-option>
                            <el-option label="WEEKS" value="WEEKS"></el-option>
                            <el-option label="MONTHS" value="MONTHS"></el-option>
                            <el-option label="YEARS" value="YEARS"></el-option>
                          </el-select>
                        </el-form-item>
                        <el-form-item
                          label="Repeat Reminder"
                          v-if="formBuilder.settings.reminder_settings.status"
                        >
                          for every
                          <el-input-number
                            :controls="false"
                            v-model="formBuilder.settings.reminder_settings.reminder_interval_value"
                            size="mini"
                          ></el-input-number>

                          <el-select
                            v-model="formBuilder.settings.reminder_settings.reminder_interval_type"
                            placeholder="Select Type"
                            class="ml-1"
                            size="mini"
                          >
                            <el-option label="MINUTES" value="MINUTES"></el-option>
                            <el-option label="HOURS" value="HOURS"></el-option>
                            <el-option label="DAYS" value="DAYS"></el-option>
                            <el-option label="WEEKS" value="WEEKS"></el-option>
                            <el-option label="MONTHS" value="MONTHS"></el-option>
                            <el-option label="YEARS" value="YEARS"></el-option>
                          </el-select>
                          until completed or expires
                        </el-form-item>
                      </el-form>
                    </el-collapse-item>
                    <el-collapse-item
                      name="receiver_email_customization"
                      v-if="formBuilder.form_builders_owner !== 'ANONYMOUS'"
                    >
                      <template #title>
                        <span>
                          <i class="el-icon-chat-line-square"></i>
                          Receiver email customization
                        </span>
                      </template>
                      Subject
                      <el-input
                        v-model="formBuilder.receiver_mail_template.subject"
                        placeholder="Enter subject"
                        class="mb-1"
                      ></el-input>
                      Custom message
                      <CkEditorOffline
                        v-model="formBuilder.receiver_mail_template.body"
                        :config="editorConfig"
                      ></CkEditorOffline>
                      <div
                        @click="chooseFromParentEmailTemplatesReceiver"
                        style="
                          cursor: pointer;
                          color: #409eff;
                          margin-left: 200px;
                          margin-top: 10px;
                        "
                      >
                        <span v-if="!formBuilder.receiver_mail_template.name">
                          Choose Parent Template(Header & Footer)
                        </span>
                        <span v-else>Change Parent Template (Header & Footer)</span>
                      </div>
                      <div
                        v-if="formBuilder.receiver_mail_template.name"
                        class="mb-2"
                        style="margin-left: 200px"
                      >
                        Selected Parent :
                        <span>{{ formBuilder.receiver_mail_template.name }}</span>
                        <span>
                          <i
                            style="cursor: pointer"
                            @click="resetParentReceiver"
                            class="el-icon-error"
                          ></i>
                        </span>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item name="approval_settings">
                      <template #title>
                        <span>
                          <i class="el-icon-circle-check"></i>
                          Approval Settings
                        </span>
                      </template>
                      <el-row>
                        <el-checkbox
                          @change="addInitialUsers"
                          v-model="formBuilder.is_approval_form"
                        >
                          Is approval form?
                        </el-checkbox>
                        <el-checkbox
                          v-if="
                            formBuilder.is_approval_form &&
                            formBuilder.approval_users &&
                            formBuilder.approval_users.length > 1 &&
                            !formBuilder.approve_all_user
                          "
                          v-model="formBuilder.priority_based"
                        >
                          Approvals by priority
                          <el-popover
                            placement="top-start"
                            trigger="hover"
                            content="Last user has high priority"
                          >
                            <i class="el-icon-info" slot="reference"></i>
                          </el-popover>
                        </el-checkbox>
                      </el-row>
                      <div v-if="formBuilder.is_approval_form" class="all-template-container">
                        <el-collapse
                          v-model="activeApprovalTab"
                          @tab-click="onApprovalTabChange"
                          v-if="getIsMobile"
                        >
                          <el-collapse-item title="Users" name="users">
                            <el-row
                              v-for="(user, i) in formBuilder.approval_users"
                              :key="'user_' + i"
                              class="mt-1"
                            >
                              <el-col v-if="user.apply_condition" :span="6">
                                <div style="display: flex; align-items: center; gap: 3px">
                                  <span>If</span>
                                  <el-select
                                    v-model="user.selected_filter_id"
                                    clearable
                                    size="mini"
                                    placeholder="Select saved filter"
                                    filterable
                                    style="flex: 1"
                                  >
                                    <el-option
                                      v-for="filter in formbuilderAllFilters"
                                      :key="filter._id"
                                      :label="filter.filter_name"
                                      :value="filter._id"
                                    >
                                      {{ filter.filter_name }}
                                    </el-option>
                                  </el-select>
                                  <span>then</span>
                                </div>
                              </el-col>
                              <el-col :span="8">
                                <el-select
                                  v-model="user.user_type"
                                  size="mini"
                                  @change="(value) => updateCompanyUsers(value, user)"
                                  placeholder="Select company user type"
                                  class="ml-1"
                                >
                                  <el-option
                                    v-for="userType in userTypes"
                                    :key="userType.value"
                                    :label="userType.label"
                                    :value="userType.value"
                                  ></el-option>
                                </el-select>
                              </el-col>
                              <template v-if="user.user_type == 'COMPANY'">
                                <el-col :span="8">
                                  <el-select
                                    v-model="user.company_user_type"
                                    clearable
                                    size="mini"
                                    @change="(value) => updateCompanyUsers(value, user)"
                                    placeholder="Select company user type"
                                    class="ml-1"
                                  >
                                    <el-option
                                      v-for="item in getUserTypeList"
                                      :key="item._id"
                                      :label="getLabel(item)"
                                      :value="item._id"
                                    ></el-option>
                                  </el-select>
                                </el-col>
                                <el-col :span="10">
                                  <el-select
                                    v-if="user.company_user_type"
                                    v-model="user.preferred_company_users"
                                    collapse-tags
                                    clearable
                                    size="mini"
                                    multiple
                                    placeholder="Select preferred user"
                                    class="ml-1"
                                    default-first-option
                                  >
                                    <el-option
                                      v-for="item in getCompanyUsersByType(user.company_user_type)"
                                      :key="item._id + '_company_user'"
                                      :label="item.email"
                                      :value="item._id"
                                    >
                                      {{ item.email }}
                                    </el-option>
                                  </el-select>
                                </el-col>
                                <el-col :span="8">
                                  <el-checkbox
                                    class="ml-1"
                                    v-if="getCompanyUsersByType(user.company_user_type).length > 1"
                                    v-model="user.any_user_can_approve"
                                  >
                                    Any user can approve
                                  </el-checkbox>
                                </el-col>
                                <el-col :span="2" v-if="formBuilder.allow_field_level_permissions">
                                  <div>
                                    <el-tooltip
                                      content="Add Field Level Permissions"
                                      placement="top"
                                    >
                                      <i
                                        class="el-icon-setting icon-class ml-1"
                                        @click="openFormBuilderSettings(user, i)"
                                      ></i>
                                    </el-tooltip>
                                  </div>
                                </el-col>
                                <el-col :span="6" class="mr-2" v-if="formBuilderId">
                                  <el-checkbox
                                    class="ml-1"
                                    v-model="user.apply_condition"
                                    @change="onApplyConditionChanged(user)"
                                  >
                                    Apply condition
                                  </el-checkbox>
                                </el-col>
                              </template>
                              <template v-else-if="user.user_type == 'APPLICATION'">
                                <el-col :span="8">
                                  <el-select
                                    v-model="user.application_user_type"
                                    clearable
                                    size="mini"
                                    @change="updateApplicationUserType(user)"
                                    placeholder="Select application user type"
                                    class="ml-1"
                                  >
                                    <el-option
                                      v-for="(type, index) in (getAllContactTypes &&
                                        getAllContactTypes.data) ||
                                      getAllContactTypes"
                                      :key="index + 1"
                                      :value="type._id"
                                      :label="type.name"
                                    >
                                      {{ type.name }}
                                    </el-option>
                                  </el-select>
                                </el-col>
                                <el-col :span="10">
                                  <div class="ml-1" v-if="user.application_user_type">
                                    <el-select
                                      v-model="user.preferred_application_users"
                                      collapse-tags
                                      clearable
                                      multiple
                                      size="mini"
                                      placeholder="Select preferred user"
                                      :disabled="user.relational_user"
                                    >
                                      <el-option
                                        v-for="(contact, index) in getUserTypeContacts(
                                          user.application_user_type
                                        )"
                                        :key="index + '_application_user_mail'"
                                        :value="contact.email"
                                        :label="contact.email"
                                      >
                                        {{ contact.email }}
                                      </el-option>
                                    </el-select>
                                    <el-checkbox
                                      v-if="checkIsRelational(user.application_user_type)"
                                      :disabled="
                                        user.preferred_application_users &&
                                        user.preferred_application_users.length
                                          ? true
                                          : false
                                      "
                                      v-model="user.relational_user"
                                    >
                                      User relational data
                                    </el-checkbox>
                                  </div>
                                </el-col>
                                <el-col :span="8" class="mr-1">
                                  <el-col
                                    :span="2"
                                    v-if="formBuilder.allow_field_level_permissions"
                                  >
                                    <div>
                                      <el-tooltip
                                        content="Add Field Level Permissions"
                                        placement="top"
                                      >
                                        <i
                                          class="el-icon-setting icon-class ml-1"
                                          @click="openFormBuilderSettings(user, i)"
                                        ></i>
                                      </el-tooltip>
                                    </div>
                                  </el-col>
                                  <el-checkbox
                                    class="ml-1"
                                    v-if="
                                      getUserTypeContacts(user.application_user_type).length > 1 &&
                                      !user.relational_user
                                    "
                                    v-model="user.any_user_can_approve"
                                  >
                                    Any user can approve
                                  </el-checkbox>
                                </el-col>
                                <el-col :span="6" v-if="formBuilderId">
                                  <el-checkbox
                                    class="ml-1"
                                    v-model="user.apply_condition"
                                    @change="onApplyConditionChanged(user)"
                                  >
                                    Apply condition
                                  </el-checkbox>
                                </el-col>
                              </template>
                              <template v-else-if="user.user_type == 'LINKEDFIELD'">
                                <el-col :span="8">
                                  <el-select
                                    v-model="user.approval_linked_field"
                                    clearable
                                    size="mini"
                                    placeholder="Select user data field"
                                    class="ml-1"
                                  >
                                    <el-option
                                      v-for="(option, index) of getAllFields"
                                      :key="index"
                                      :value="option.key"
                                      :label="option.label"
                                      :disabled="
                                        checkDuplicate(i, option.key, 'approval_linked_field')
                                      "
                                    >
                                      {{ option.label }}
                                    </el-option>
                                  </el-select>
                                </el-col>
                              </template>
                              <template>
                                <el-col :span="6" style="margin-left: 40px !important">
                                  <el-link
                                    icon="el-icon-delete"
                                    :underline="false"
                                    type="danger"
                                    @click="removeUser(i)"
                                  ></el-link>
                                </el-col>
                              </template>
                            </el-row>
                            <el-row>
                              <el-button
                                class="mt-1"
                                type="primary"
                                plain
                                size="mini"
                                icon="el-icon-plus"
                                @click="addApprovers"
                              >
                                Add Approvers
                              </el-button>
                              <el-checkbox
                                class="ml-2"
                                v-if="
                                  formBuilder.approval_users.length > 1 &&
                                  !formBuilder.priority_based
                                "
                                v-model="formBuilder.approve_all_user"
                              >
                                All users needs to approve
                              </el-checkbox>
                            </el-row>
                          </el-collapse-item>
                          <el-collapse-item title="Mail template" name="mail">
                            Subject
                            <el-input
                              v-model="formBuilder.approval_mail_template.subject"
                              placeholder="Enter subject"
                            ></el-input>
                            Custom message
                            <CkEditorOffline
                              v-model="formBuilder.approval_mail_template.body"
                              :config="editorConfig1"
                            ></CkEditorOffline>
                            <div
                              @click="chooseFromParentEmailTemplates"
                              style="
                                cursor: pointer;
                                color: #409eff;
                                margin-left: 200px;
                                margin-top: 10px;
                              "
                            >
                              <span v-if="!formBuilder.approval_mail_template.name">
                                Choose Parent Template(Header & Footer)
                              </span>
                              <span v-else>Change Parent Template (Header & Footer)</span>
                            </div>
                            <div
                              v-if="formBuilder.approval_mail_template.name"
                              class="mb-2"
                              style="margin-left: 200px"
                            >
                              Selected Parent :
                              <span>{{ formBuilder.approval_mail_template.name }}</span>
                              <span>
                                <i
                                  style="cursor: pointer"
                                  @click="resetParent"
                                  class="el-icon-error"
                                ></i>
                              </span>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            title="Permissions"
                            name="permissions"
                            v-if="
                              formBuilder.is_approval_form &&
                              formBuilder.approval_receiver_permissions
                            "
                          >
                            Please specify the permissions to be granted to the receiver for
                            viewing, editing, or deleting the submission after the form is approved:
                            <br />
                            <div class="mt-1">
                              <el-checkbox v-model="formBuilder.approval_receiver_permissions.view">
                                VIEW
                              </el-checkbox>
                              <el-checkbox v-model="formBuilder.approval_receiver_permissions.edit">
                                EDIT
                              </el-checkbox>
                              <el-checkbox
                                v-model="formBuilder.approval_receiver_permissions.delete"
                              >
                                DELETE
                              </el-checkbox>
                            </div>
                          </el-collapse-item>
                          <el-collapse-item
                            label="Fields to be shown for anonymous form"
                            v-if="formBuilder && formBuilder.form_builders_owner == 'ANONYMOUS'"
                          >
                            <el-select
                              placeholder="Primary fields"
                              v-model="formBuilder.primary_fields"
                              multiple
                              collapse-tags
                              class="mt-1"
                            >
                              <el-option
                                v-for="field in allFormbuilderFields"
                                :key="field.key"
                                :value="field.key"
                                :label="field.label"
                              ></el-option>
                            </el-select>
                          </el-collapse-item>
                        </el-collapse>
                      </div>
                    </el-collapse-item>
                    <el-collapse-item name="expiration_settings">
                      <template #title>
                        <span>
                          <i class="el-icon-time"></i>
                          Expiration Settings
                        </span>
                      </template>
                      <span>
                        When form response is in pending status, in how many days/months/years will
                        it be expired?
                      </span>
                      <el-row class="mt-1">
                        <el-select
                          placeholder="Expiry type"
                          v-model="formBuilder.expiration_settings.expiry_type"
                        >
                          <el-option value="YEARS" label="Year(s)"></el-option>
                          <el-option value="MONTHS" label="Month(s)"></el-option>
                          <el-option value="DAYS" label="Day(s)"></el-option>
                        </el-select>
                        <el-input-number
                          placeholder="Expiry Duration"
                          v-model="formBuilder.expiration_settings.expiry_duration"
                          :min="0"
                          class="ml-1"
                        ></el-input-number>
                      </el-row>
                    </el-collapse-item>
                    <el-collapse-item name="customization">
                      <template #title>
                        <span slot>
                          <i class="el-icon-finished"></i>
                          Customization
                        </span>
                      </template>
                      <el-row>
                        <el-col :span="6">
                          Add button label
                          <el-input
                            v-model="formBuilder.customization.add_button_label"
                            placeholder="Enter label"
                          ></el-input>
                          Finish button label
                          <el-input
                            v-model="formBuilder.customization.finish_button_label"
                            placeholder="Enter label"
                          ></el-input>
                          <el-checkbox v-model="formBuilder.customization.show_link_to_be_copy">
                            Show link to copy
                          </el-checkbox>
                          <el-checkbox v-model="formBuilder.customization.show_detailed_link">
                            Show detailed view
                          </el-checkbox>
                          <el-checkbox
                            v-model="formBuilder.customization.show_initial_confirmation"
                          >
                            Show initial confirmation to continue
                          </el-checkbox>
                          <el-checkbox
                            v-model="formBuilder.customization.show_try_esigns_and_content"
                          >
                            Show try Our Application button and content
                          </el-checkbox>
                          <el-checkbox v-model="formBuilder.customization.show_title_bar">
                            Show top bar and company logo
                          </el-checkbox>
                        </el-col>
                        <el-col :span="6"></el-col>
                      </el-row>
                    </el-collapse-item>
                  </el-collapse>
                </el-col>
              </div>
            </el-row>
          </div>
        </el-form>
      </div>

      <!-- Select an Icon -->
      <dialog-component
        :title="'Select An Icon'"
        :visible="iconPickerdialogVisible"
        @before-close="closeIconModel"
        :isShowFooter="false"
        :containerWidth="'65%'"
        top="25px"
        width="1000px"
      >
        <div class="icons-component">
          <div class="iconslistScrollable">
            <icons-list @icon-data="getIconPath"></icons-list>
          </div>
        </div>
      </dialog-component>

      <!-- Title Settings -->
      <dialog-component
        :visible="configureSettings"
        :title="'Settings'"
        :containerWidth="'50%'"
        @before-close="doneTitleConfigure"
        :lock-scroll="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="resetConfigureSettings"
      >
        <div class="settings-formBuilder" id="stepSettingsFormBuilder">
          <h3 class="!text-black-950 !font-normal !mb-6">Step settings</h3>
          <el-form label-position="left">
            <el-row :gutter="30" type="flex" justify="center">
              <el-col :span="12">
                <el-form-item class="!w-full" label="Sender display name:">
                  <el-input
                    placeholder="Enter sender display name"
                    type="text"
                    maxlength="70"
                    v-model="configureTitles.sender_title"
                    class="!mt-1"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item class="!w-full" label="Receivers display name:">
                  <el-input
                    placeholder="Receivers display name"
                    type="text"
                    maxlength="70"
                    v-model="configureTitles.receiver_title"
                    class="!mt-1"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              :gutter="20"
              type="flex"
              v-if="
                formBuilder.form_builders_owner == 'ENTITY' &&
                seletedStepData.type == 'ENTITY' &&
                seletedStepData.entity == formBuilder.entity_id
              "
            >
              <el-col :span="24" style="display: flex">
                <el-checkbox
                  v-model="configureTitles.isLoginEntity"
                  style="margin-top: 5px"
                  @change="checkForIndividual(configureTitles.selectedTemplates)"
                >
                  Link this entity to reciever?
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row v-if="seletedStepData.type == 'ENTITY'">
              User can access following templates
              <el-select
                multiple
                collapse-tags
                v-model="configureTitles.selectedTemplates"
                placeholder="Select templates"
                size="mini"
                @change="(val) => checkForIndividual(val)"
              >
                <el-option
                  v-for="(temp, i) in entityTemplates"
                  :key="'eTemplates' + temp._id + i"
                  :value="temp._id"
                  :label="temp.name"
                >
                  {{ temp.name }}
                </el-option>
              </el-select>
            </el-row>
            <el-row
              type="flex"
              v-if="
                seletedStepData.type == 'TEMPLATE' &&
                checkIsInvolved &&
                !seletedStepData.standard_template
              "
            >
              <el-col :span="24" style="display: flex">
                <el-checkbox v-model="configureTitles.is_repeatable" style="margin-top: 3px">
                  Use it as repeatable
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              v-if="
                seletedStepData.type == 'TEMPLATE' &&
                checkIsInvolved &&
                seletedStepData.standard_template
              "
              style="margin-top: 10px"
            >
              <el-col :span="24">
                Create contact with
                <el-select
                  v-model="configureTitles.contact_entity"
                  size="mini"
                  placeholder="Select entity"
                  filterable
                  clearable
                  @change="updateEntityName"
                >
                  <el-option
                    v-for="(entity, index) in (this.allEntitiesData || []).filter(
                      (e) =>
                        ['INDIVIDUAL'].indexOf(e.entity_type) !== -1 ||
                        (formBuilder.form_builders_owner == 'ENTITY' &&
                          e._id == formBuilder.entity_id)
                    )"
                    :key="'et_' + entity._id + index"
                    :label="entity.name"
                    :value="entity._id"
                  >
                    {{ entity.name }}
                  </el-option>
                </el-select>
                type
              </el-col>
            </el-row>
            <!-- <el-divider></el-divider> -->
            <hr v-if="configureTitles.is_repeatable" />
            <el-row
              v-if="
                entityTables &&
                entityTables.length &&
                !configureTitles.is_repeatable &&
                checkIsInvolved &&
                seletedStepData.type == 'TEMPLATE'
              "
            >
              <el-col :span="24">
                <div style="display: flex; justify-content: space-between">
                  <p>Configure entity tables</p>
                  <el-link
                    type="primary"
                    :underline="false"
                    icon="el-icon-plus"
                    @click="addNewField"
                  >
                    Add
                  </el-link>
                </div>
                <div v-if="!entityTablesRefresh">
                  <el-row :gutter="30">
                    <el-col :span="6">Field</el-col>
                    <el-col :span="6">Max</el-col>
                    <el-col :span="6">Min</el-col>
                    <el-col :span="6" v-if="formBuilder.form_builders_owner == 'ENTITY'">
                      Apply relationship?
                    </el-col>
                  </el-row>
                  <el-row
                    :gutter="30"
                    v-for="(row, i) of entity_table_configuration"
                    :key="'table_' + i"
                    style="border-bottom: 1px solid #d0d0d0"
                    class="pb-1"
                  >
                    <el-col :span="6">
                      <el-select v-model="row.selectField" placeholder="Select field" size="mini">
                        <el-option
                          v-for="(op, j) of entityTables"
                          :key="'op_' + j"
                          :label="op.label"
                          :value="op.key"
                          :disabled="checkDuplicateField(i, op.key, 'selectField')"
                        ></el-option>
                      </el-select>
                    </el-col>
                    <el-col :span="6">
                      <el-select
                        placeholder="Select field"
                        v-model="row.linked_field"
                        size="mini"
                        clearable
                      >
                        <el-option
                          v-for="(op, i) of getPrevStepFields"
                          :key="op.key + i"
                          :value="op.key"
                          :label="op.label"
                        >
                          {{ op.label }}
                        </el-option>
                      </el-select>
                      <span class="ml-1 mr-1" v-if="!row.linked_field">OR</span>
                      <el-input-number
                        v-if="!row.linked_field"
                        v-model="row.max_records"
                        :min="1"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                    <el-col :span="6">
                      <el-select
                        placeholder="Select field"
                        v-model="row.linked_min_field"
                        size="mini"
                        clearable
                      >
                        <el-option
                          v-for="(op, i) of getPrevStepFields"
                          :key="op.key + i"
                          :value="op.key"
                          :label="op.label"
                        >
                          {{ op.label }}
                        </el-option>
                      </el-select>
                      <span class="ml-1 mr-1" v-if="!row.linked_min_field">OR</span>
                      <el-input-number
                        v-if="!row.linked_min_field"
                        v-model="row.min_records"
                        :min="1"
                        size="mini"
                      ></el-input-number>
                    </el-col>
                    <el-col :span="6">
                      <el-checkbox
                        v-model="row.applyRelationship"
                        v-if="
                          entityTables &&
                          row.selectField &&
                          entityTables.find((e) => e.key == row.selectField) &&
                          checkRelationship(
                            entityTables.find((e) => e.key == row.selectField).entity_id
                          )
                        "
                      ></el-checkbox>
                      <el-link
                        icon="el-icon-delete"
                        :underline="false"
                        type="danger"
                        @click="removeNewField(i)"
                      ></el-link>
                    </el-col>
                  </el-row>
                </div>
              </el-col>
            </el-row>
            <el-row v-if="configureTitles.is_repeatable" class="mt-1">
              <el-col :span="24">
                <label>Min no of records can be added</label>
                <el-select
                  placeholder="Select field"
                  v-model="configureTitles.linked_min_field"
                  size="mini"
                  clearable
                  class="ml-1"
                >
                  <el-option
                    v-for="(op, i) of getPrevStepFields"
                    :key="op.key + i"
                    :value="op.key"
                    :label="op.label"
                  >
                    {{ op.label }}
                  </el-option>
                </el-select>
                <span class="ml-2 mr-2" v-if="!configureTitles.linked_min_field">OR</span>
                <el-input-number
                  v-if="!configureTitles.linked_min_field"
                  v-model="configureTitles.min_records"
                  :min="1"
                  size="mini"
                  class="ml-3"
                ></el-input-number>
              </el-col>
              <el-col :span="24" class="mt-1">
                <label>Max no of records can be added field</label>
                <el-select
                  placeholder="Select field"
                  v-model="configureTitles.linked_field"
                  size="mini"
                  clearable
                  class="ml-1"
                >
                  <el-option
                    v-for="(op, i) of getPrevStepFields"
                    :key="op.key + i"
                    :value="op.key"
                    :label="op.label"
                  >
                    {{ op.label }}
                  </el-option>
                </el-select>
                <span class="ml-2 mr-2" v-if="!configureTitles.linked_field">OR</span>
                <el-input-number
                  v-if="!configureTitles.linked_field"
                  v-model="configureTitles.max_records"
                  :min="1"
                  size="mini"
                ></el-input-number>
              </el-col>
            </el-row>
            <el-row
              :gutter="30"
              type="flex"
              v-if="
                formBuilder.form_builders_owner == 'ENTITY' &&
                seletedStepData.type == 'ENTITY' &&
                checkRelationship(seletedStepData.entity)
              "
            >
              <el-col :span="24">
                <el-checkbox v-model="configureTitles.applyRelationship">
                  {{ getRelationshipText }}
                </el-checkbox>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <button
            class="!px-4 !py-1.5 !rounded-md !text-xs bg-brand-500 !text-white 2xl:!text-sm"
            id="submitButton"
            @click="doneTitleConfigure"
            :disabled="checkSubmitDisabled"
          >
            <span>Submit</span>
          </button>
        </span>
      </dialog-component>

      <!-- Company Documents -->
      <el-dialog
        :visible.sync="configureDocumentSettings"
        title="Settings"
        :fullscreen="true"
        :lock-scroll="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        class="settings-selection-dialog"
        center
      >
        <div class="document-selection-box">
          <div class="mx-auto">
            <el-row
              v-if="configureCompanyDocumentsVisible"
              :gutter="30"
              type="flex"
              justify="center"
            >
              <el-col :span="16">
                <el-card shadow="never">
                  <h3 class="dialog-sub-title blue-2">
                    <i class="el-icon-document-add"></i>
                    <span class="pl-1">Choose Documents</span>
                  </h3>
                  <el-divider class="mb-05 mt-1"></el-divider>

                  <el-form v-model="searchDocumentFormData">
                    <el-row :gutter="20">
                      <el-col :span="8">
                        <el-form-item label="Type">
                          <el-select
                            v-model="searchDocumentFormData.type"
                            @change="getCompanyDocuments"
                          >
                            <el-option label="CUSTOM" value="CUSTOM"></el-option>
                            <el-option label="STATIC" value="STATIC"></el-option>
                            <el-option label="STANDARD" value="STANDARD"></el-option>
                            <el-option label="REQUESTED" value="REQUESTED"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          label="Category"
                          v-if="searchDocumentFormData.type != 'STANDARD'"
                        >
                          <el-select
                            v-model="searchDocumentFormData.category_id"
                            @change="getCompanyDocuments"
                            clearable
                          >
                            <el-option
                              v-for="(category, index) of getAllCategories"
                              :key="index"
                              :label="category.name"
                              :value="category._id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item
                          label="Group"
                          v-if="searchDocumentFormData.type != 'STANDARD'"
                        >
                          <el-select
                            v-model="searchDocumentFormData.group_id"
                            @change="getCompanyDocuments"
                            clearable
                          >
                            <el-option
                              v-for="(group, index) of getAllGroups"
                              :key="index"
                              :label="group.name"
                              :value="group._id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div class="table-scrollable">
                    <el-table
                      class="vue-data-table-default"
                      v-if="
                        searchDocumentFormData.type != 'STANDARD' &&
                        getCompanyAllDocuments &&
                        getCompanyAllDocuments.data &&
                        getCompanyAllDocuments.data.length
                      "
                      :data="getCompanyAllDocuments.data"
                      height="calc(100vh - 320px)"
                    >
                      <el-table-column label="Name" prop="title"></el-table-column>
                      <el-table-column label="Type" prop="type"></el-table-column>
                      <el-table-column label="Category" prop="category.name"></el-table-column>
                      <el-table-column label="Groups">
                        <template slot-scope="scope">
                          {{ scope.row.groups.map((e) => e.name).join(', ') }}
                        </template>
                      </el-table-column>
                      <el-table-column label="Add">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            :disabled="isDocExisted(scope.row, scope.row.type)"
                            @click="addDocumentToStep(scope.row, scope.row.type.toLowerCase())"
                          >
                            <i class="el-icon-circle-plus-outline"></i>
                            Add
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-table
                      class="vue-data-table-default"
                      v-if="
                        searchDocumentFormData.type == 'STANDARD' &&
                        standardDocumentsList &&
                        standardDocumentsList.length
                      "
                      :data="standardDocumentsList"
                    >
                      <el-table-column label="Name" prop="title"></el-table-column>
                      <el-table-column label="Type" prop="type"></el-table-column>
                      <el-table-column label="Add">
                        <template slot-scope="scope">
                          <el-button
                            size="mini"
                            type="primary"
                            :disabled="isDocExisted(scope.row, scope.row.type)"
                            @click="addDocumentToStep(scope.row, 'standard')"
                          >
                            <i class="el-icon-circle-plus-outline"></i>
                            Add
                          </el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-card>
              </el-col>
              <el-col :span="7">
                <div class="submit-block right">
                  <el-button id="submitButton" type="success" round @click="doneCompanyDocuemnts()">
                    <i class="el-icon-finished"></i>
                    <span>Done</span>
                  </el-button>
                </div>
                <div class="selected-docx">
                  <h3 class="dialog-sub-title success">
                    <i class="el-icon-document-checked"></i>
                    <span class="pl-1">Selected Documents</span>
                  </h3>

                  <div v-if="getTotalDocuments(seletedStepData.company_documents)">
                    <el-card
                      shadow="never"
                      class="scrollable-min"
                      v-if="
                        seletedStepData &&
                        seletedStepData.company_documents.static &&
                        seletedStepData.company_documents.static.length
                      "
                    >
                      <h4 class="blue-2 card-title">
                        <i class="el-icon-document"></i>
                        Static Documents
                      </h4>
                      <el-divider class="mb-0 mt-0"></el-divider>
                      <div
                        class="each-document"
                        v-for="(doc, index) of seletedStepData.company_documents.static"
                        :key="index"
                      >
                        <el-button
                          circle
                          class="float-right"
                          size="mini"
                          type="danger"
                          icon="el-icon-close"
                          @click="removeComapnyDocument('static', index)"
                        ></el-button>
                        <h4>{{ doc.title }}</h4>
                      </div>
                    </el-card>

                    <el-card
                      shadow="never"
                      class="scrollable-min"
                      v-if="
                        seletedStepData &&
                        seletedStepData.company_documents.requested &&
                        seletedStepData.company_documents.requested.length
                      "
                    >
                      <h4 class="blue-2 card-title">
                        <i class="el-icon-document"></i>
                        Requested Documents
                      </h4>
                      <el-divider class="mb-0 mt-0"></el-divider>
                      <div
                        class="each-document"
                        v-for="(doc, index) of seletedStepData.company_documents.requested"
                        :key="index"
                      >
                        <el-button
                          circle
                          class="float-right"
                          size="mini"
                          type="danger"
                          icon="el-icon-close"
                          @click="removeComapnyDocument('requested', index)"
                        ></el-button>
                        <h4>{{ doc.title }}</h4>
                      </div>
                    </el-card>
                    <el-card
                      shadow="never"
                      class="scrollable-min"
                      v-if="
                        seletedStepData &&
                        seletedStepData.company_documents.custom &&
                        seletedStepData.company_documents.custom.length
                      "
                    >
                      <h4 class="blue-2 card-title">
                        <i class="el-icon-document"></i>
                        Custom Documents
                      </h4>
                      <el-divider class="mb-0 mt-0"></el-divider>
                      <div
                        class="each-document"
                        v-for="(doc, index) of seletedStepData.company_documents.custom"
                        :key="index"
                      >
                        <el-button
                          circle
                          class="float-right"
                          size="mini"
                          type="danger"
                          icon="el-icon-close"
                          @click="removeComapnyDocument('custom', index)"
                        ></el-button>
                        <h4>{{ doc.title }}</h4>
                      </div>
                    </el-card>
                    <el-card
                      shadow="never"
                      class="scrollable-min"
                      v-if="
                        seletedStepData &&
                        seletedStepData.company_documents.standard &&
                        seletedStepData.company_documents.standard.length
                      "
                    >
                      <h4 class="blue-2 card-title">
                        <i class="el-icon-document"></i>
                        Standard Documents
                      </h4>
                      <el-divider class="mb-0 mt-0"></el-divider>
                      <div
                        class="each-document"
                        v-for="(doc, index) of seletedStepData.company_documents.standard"
                        :key="index"
                      >
                        <el-button
                          circle
                          class="float-right"
                          size="mini"
                          type="danger"
                          icon="el-icon-close"
                          @click="removeComapnyDocument('standard', index)"
                        ></el-button>
                        <h4>{{ doc.title }}</h4>
                      </div>
                    </el-card>
                  </div>
                  <div v-else>
                    <h3 class="text-center mt-2 font-weight-normal">No Documents</h3>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-dialog>
      <dialog-component
        :containerMaxHeight="getIsMobile ? '100%' : '60%'"
        :containerMinWidth="getIsMobile ? '100%' : '30%'"
        title="Update Logo"
        :visible="logoUploadModal"
        @before-close="closeLogoModal"
      >
        <div class="uploader">
          <vue-anka-cropper
            class="upload-file"
            :options="{
              aspectRatio: false,
              closeOnSave: true,
              cropArea: 'box',
              croppedHeight: 1000,
              croppedWidth: 1000,
              cropperHeight: false,
              dropareaMessage: ' Drag & Drop  file here or use the button below.',
              frameLineDash: [1, 1000],
              frameStrokeColor: 'rgba(255, 255, 255, 0.8)',
              handleFillColor: 'rgba(255, 255, 255, 0.2)',
              handleHoverFillColor: 'rgba(255, 255, 255, 0.4)',
              handleHoverStrokeColor: 'rgba(255, 255, 255, 1)',
              handleSize: 5,
              handleStrokeColor: 'rgba(255, 255, 255, 0.8)',
              layoutBreakpoint: 40,
              maxCropperHeight: 1000,
              maxFileSize: 8000000,
              overlayFill: 'rgba(0, 0, 0, 0.5)',
              previewOnDrag: true,
              previewQuality: 0.65,
              resultQuality: 0.8,
              resultMimeType: ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'],
              selectButtonLabel: 'Select File Supported : JPG, PNG, JPEG, GIF',
              showPreview: true,
              skin: 'light',
              uploadData: {},
              uploadTo: false,
            }"
            name="logo"
            @cropper-error="fileError"
            @cropper-preview="uploadFile"
            @cropper-file-selected="uploadFile"
            @cropper-saved="uploadLogo"
            v-loading="upLoadEffect"
            accept="image/jpeg, image/png, image/jpg, image/gif"
          ></vue-anka-cropper>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              outerVisible = false;
              files = null;
              closeLogoModal();
            "
          >
            Cancel
          </el-button>
          <el-button type="primary" @click="uploadLogo">Save</el-button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Add New Group'"
        :visible="showAddGroupDialog"
        :containerWidth="getIsMobile ? '100%' : '30%'"
        @before-close="showAddGroupDialog = false"
      >
        <el-form class="m-tb-2">
          <div v-loading="loadingSaveGroup">
            <p>Group Title</p>
            <el-input
              type="text"
              v-model="groupName"
              placeholder="Enter Title"
              :style="{ height: '50px' }"
            ></el-input>
          </div>
        </el-form>
        <span slot="footer" class="text-center">
          <button
            class="!mr-1 !px-3 !py-1 !border !rounded-sm !border-black/10 hover:border hover:!border-brand-500 hover:text-brand-500"
            type="button"
            @click="showAddGroupDialog = false"
          >
            Cancel
          </button>
          <button
            class="!border !border-brand-500 !px-3 !py-1 !bg-brand-500 !text-white !rounded-sm"
            type="button"
            @click="saveGroup"
          >
            Save Group
          </button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="emailTemplatesParentListDialog"
        @before-close="emailTemplatesParentListDialog = false"
        :containerWidth="'100%'"
      >
        <singleEntityTemplatesList
          :content="formBuilder.approval_mail_template"
          style="padding: 10px"
          entity_id
          type="PARENT"
          v-on:closeDialog="closeEmailFooter"
        />
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="receiverEmailTemplatesParentListDialog"
        @before-close="receiverEmailTemplatesParentListDialog = false"
        :containerWidth="'100%'"
      >
        <singleEntityTemplatesList
          :content="formBuilder.receiver_mail_template"
          style="padding: 10px"
          entity_id
          type="PARENT"
          v-on:closeDialog="closeEmailFooterReceiver"
        />
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="receiverApprovalEmailTemplatesListDialog"
        @before-close="closeEmailFooterReceiverApproval"
        :containerWidth="'100%'"
      >
        <singleEntityTemplatesList
          :content="formBuilder.receiver_approval_update_mail_template"
          style="padding: 10px"
          entity_id
          type="PARENT"
          v-on:closeDialog="closeEmailFooterReceiverApproval"
        />
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="reworkUserEmailTemplatesListDialog"
        @before-close="closeEmailFooterReworkMailTemps"
        :containerWidth="'100%'"
      >
        <singleEntityTemplatesList
          :content="formBuilder.rework_user_mail_template"
          style="padding: 10px"
          entity_id
          type="PARENT"
          v-on:closeDialog="closeEmailFooterReworkMailTemps"
        />
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="approvalActionsEmailTemplatesListDialog"
        @before-close="closeEmailFooterActionsApprovalMailTemps"
        :containerWidth="'100%'"
      >
        <div
          v-if="
            formBuilder.approval_data_actions.length &&
            formBuilder.approval_data_actions[selectedFormActionsIndex] &&
            formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings
          "
        >
          <singleEntityTemplatesList
            :content="
              formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings
            "
            style="padding: 10px"
            entity_id
            type="PARENT"
            v-on:closeDialog="closeEmailFooterActionsApprovalMailTemps"
          />
        </div>
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="rejectActionsEmailTemplatesListDialog"
        @before-close="closeEmailFooterActionsRejectMailTemps"
        :containerWidth="'100%'"
      >
        <div
          v-if="
            formBuilder.reject_data_actions.length &&
            formBuilder.reject_data_actions[selectedFormActionsIndex] &&
            formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings
          "
        >
          <singleEntityTemplatesList
            :content="formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings"
            style="padding: 10px"
            entity_id
            type="PARENT"
            v-on:closeDialog="closeEmailFooterActionsRejectMailTemps"
          />
        </div>
      </dialog-component>
      <dialog-component
        :title="'Parent Templates(Header Footer)'"
        :visible="receiverRejectionEmailTemplatesListDialog"
        @before-close="closeEmailFooterReceiverRejection"
        :containerWidth="'100%'"
      >
        <singleEntityTemplatesList
          :content="formBuilder.receiver_rejection_update_mail_template"
          style="padding: 10px"
          entity_id
          type="PARENT"
          v-on:closeDialog="closeEmailFooterReceiverRejection"
        />
      </dialog-component>
      <dialog-component
        :title="previewTemplateName"
        :visible="showDetailedView"
        :containerWidth="getIsMobile ? '100%' : '70%'"
        :containerMaxHeight="'90%'"
        v-loading="modalLoading"
        element-loading-text="Please wait, we are getting things ready for you."
        element-loading-spinner="pencil"
        element-loading-background="rgba(202, 197, 197, 0.173)"
        class="detailedTemplatesView"
        @before-close="resetTemplateData"
        :isShowFooter="false"
      >
        <div
          v-loading="loading"
          element-loading-text="Updating, please wait..."
          element-loading-spinner="el-icon-loading"
        >
          <el-collapse v-model="activeTempId" accordion>
            <el-collapse-item
              v-for="(temp, index) in detailedTempIds"
              :key="index + '_temp'"
              :name="temp.id"
              :title="temp.name"
            >
              <viewTemplate
                :templateIdViewId="temp.id"
                :formbuilderId="formBuilder._id"
                :isFromFormbuilder="true"
                :isEntityStep="temp.isEntityStep"
                :defaultValuesForm="temp.defaultValuesForm"
                @saveFormbuilderDefaultValues="saveFormbuilderDefaultValues"
              ></viewTemplate>
            </el-collapse-item>
          </el-collapse>
        </div>
      </dialog-component>
      <dialog-component
        title="Create Template with AI"
        :visible.sync="visible"
        @before-close="visible = false"
        :containerWidth="getIsMobile ? '100%' : '25vw'"
        @close="resetForm"
      >
        <el-form class="mr-1">
          <el-form-item label="Form Template Name">
            <el-input
              type="text"
              placeholder="Enter the form template name"
              @keydown.enter.prevent.native="handleSubmit"
              v-model="templatename"
              @blur="checkDuplicateTemplateName"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <button
            type="button"
            @click="handleSubmit"
            :disabled="!templatename || isDuplicate"
            class="btn btn btn-sm btn-outline-primary"
          >
            Create
          </button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Customise the mail for sending the form'"
        :visible="actionsFormbuilderMailTempDialog"
        @before-close="closeActionsFormbuilderMailTemp"
        :containerWidth="'60%'"
        :containerHeight="'75%'"
      >
        <div
          class="p-3"
          v-if="
            formBuilder.approval_data_actions &&
            formBuilder.approval_data_actions[selectedFormActionsIndex] &&
            formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings &&
            formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings.subject
          "
        >
          <span style="font-weight: 400">Subject</span>
          <el-input
            v-model="
              formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings.subject
            "
            placeholder="Enter Subject"
            class="mb-1"
          ></el-input>
          <span style="font-weight: 400">Custom Message</span>
          <CkEditorOffline
            v-model="
              formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings.body
            "
            :config="editorConfig7"
          ></CkEditorOffline>
          <div
            @click="chooseFromActionsApprovalMailTemps"
            style="cursor: pointer; color: #409eff; margin-left: 200px; margin-top: 10px"
          >
            <span
              v-if="
                formBuilder.approval_data_actions &&
                formBuilder.approval_data_actions[selectedFormActionsIndex] &&
                formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings &&
                !formBuilder.approval_data_actions[selectedFormActionsIndex].form_mail_settings.name
              "
            >
              Choose Parent Template(Header & Footer)
            </span>
            <span v-else>Change Parent Template (Header & Footer)</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeActionsFormbuilderMailTemp">Save</el-button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Customise the mail for sending the form'"
        :visible="actionsRejectMailTempDialog"
        @before-close="closeRejectActionsMailTemp"
        :containerWidth="'60%'"
        :containerHeight="'75%'"
      >
        <div
          class="p-3"
          v-if="
            formBuilder.reject_data_actions &&
            formBuilder.reject_data_actions[selectedFormActionsIndex] &&
            formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings &&
            formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings.subject
          "
        >
          <span style="font-weight: 400">Subject</span>
          <el-input
            v-model="
              formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings.subject
            "
            placeholder="Enter Subject"
            class="mb-1"
          ></el-input>
          <span style="font-weight: 400">Custom Message</span>
          <CkEditorOffline
            v-model="
              formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings.body
            "
            :config="editorConfig8"
          ></CkEditorOffline>
          <div
            @click="chooseFromActionsRejectMailTemps"
            style="cursor: pointer; color: #409eff; margin-left: 200px; margin-top: 10px"
          >
            <span
              v-if="
                formBuilder.reject_data_actions &&
                formBuilder.reject_data_actions[selectedFormActionsIndex] &&
                formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings &&
                !formBuilder.reject_data_actions[selectedFormActionsIndex].form_mail_settings.name
              "
            >
              Choose Parent Template(Header & Footer)
            </span>
            <span v-else>Change Parent Template (Header & Footer)</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeRejectActionsMailTemp">Save</el-button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Revoke approval data actions'"
        :visible="revokeApprovalActionsDialog"
        @before-close="closeRevokeApprovalActions"
        :containerWidth="'50%'"
        :containerHeight="'65%'"
      >
        <div class="p-3">
          <table style="width: 92%; border-collapse: collapse; border: 1px solid lightgrey">
            <thead>
              <tr style="text-align: left">
                <th style="width: 180px; padding: 8px; border: 1px solid lightgrey">Field</th>
                <th style="width: 200px; padding: 8px; border: 1px solid lightgrey">Update with</th>
                <th style="width: 40px; padding: 8px; border: 1px solid lightgrey">
                  <el-button @click="addRevokeApprovalAction()" type="success" size="mini">
                    <i class="el-icon-plus"></i>
                    Add
                  </el-button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(action, index) in formBuilder.revoke_approval_data_actions"
                :key="action.field_key + index"
              >
                <td style="padding: 8px; border: 1px solid lightgrey">
                  <el-select
                    v-model="action.field_key"
                    placeholder="Select the field"
                    clearable
                    filterable
                    size="mini"
                    @change="updateRevokeActionsObject"
                  >
                    <el-option
                      v-for="field in getMappedFormbuilderFields()"
                      :key="field.key"
                      :label="field.label"
                      :value="field.key"
                    />
                  </el-select>
                </td>
                <td style="padding: 8px; border: 1px solid lightgrey">
                  <AnyFieldsExecute
                    v-if="action.field_key"
                    :fieldsData="getMappedFormbuilderFields()"
                    :field="getSelectedField(action.field_key)"
                    :form="revokeActionsMapObject[index]"
                  />
                </td>
                <td style="padding: 8px; border: 1px solid lightgrey">
                  <el-button
                    type="primary"
                    icon="el-icon-delete"
                    size="mini"
                    @click="removeRevokeApprovalAction(index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="closeRevokeApprovalActions">Save</el-button>
        </span>
      </dialog-component>
      <dialog-component
        :title="'Add filtered approvers'"
        :visible="openApproverFilters"
        @before-close="closeApproverFilters"
        :containerWidth="'60%'"
        :containerHeight="'65%'"
      >
        <div
          class="p-3"
          v-if="
            formBuilder?.approval_users[currentApproverIndex]?.individual_entity_resource ==
              'FILTER' &&
            formBuilder?.approval_users[currentApproverIndex]?.filter_type == 'CONFIGURE_FILTER'
          "
          v-loading="loading"
          element-loading-text="Fetching, please wait..."
          element-loading-spinner="el-icon-loading"
        >
          <EntityFilter
            :currentEntity="currentFetchedEntity"
            :entityFiltersData="formBuilder.approval_users[currentApproverIndex].filters_data"
            :entityUserFiltersData="formBuilder.approval_users[currentApproverIndex].filters_data"
            :selectedEntityFields="selectedEntityFields"
            :fromConstApproverFilters="true"
            :hideSave="true"
          ></EntityFilter>
        </div>
      </dialog-component>
      <dialog-component
        :title="'Field Level Permissions'"
        :visible="fieldLevelPermissionsModal"
        @before-close="saveCustomization"
        :isShowFooter="false"
        :containerWidth="'40%'"
      >
        <div>
          <FieldLevelPermissions
            :templateData="allFormBuilderOriginalFields"
            :customization="selectedFormBuilderCustomization"
            :fromFormbuilder="true"
            @updateCustomization="handleUpdate"
          ></FieldLevelPermissions>
        </div>
      </dialog-component>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { getCodeByName } from '@/utils/appHelper';
  var iconsData = require('@/assets/data/icons.json');
  import UserHelper from '@/mixins/UserHelper';
  import DocumentsHelper from '@/mixins/CompanyDocumentsHelper';
  import viewTemplate from '@/components/templates/ViewTemplate';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper.js';
  import companyDocuments from '@/constants/lg-en/companyDocuments';
  import TextEditor from '../contentBlocks/TextEditor';
  import draggable from 'vuedraggable';
  import { bus } from '../../main';
  import * as moment from 'moment';
  import fonts from '@/constants/fonts.js';
  import { makeSlug } from '@/helpers/appHelper';
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  import vueAnkaCropper from 'vue-anka-cropper';
  import { fetchEntityRelationships } from '@/repo/entityRelationshipsRepo';
  import 'vue-anka-cropper/dist/VueAnkaCropper.css';
  // import chatgpt from "../ChatGpt-EmailTemplates.vue";
  import { fetchGroups, addSingleGroupToLocal } from '@/repo/groupsRepo';
  import { addSingleFormbuilderToLocal, updateFormbuilderData } from '@/repo/formbuilderDetails';
  import { postAPICall } from '../../helpers/httpHelper';
  import AccessManagement from '../../mixins/AccessManagement';
  import {
    // fetchFormbuilderFiltersFromLocal,
    fetchAllFormbuilderFiltersById,
    fetchAllEntityFiltersByEntity,
  } from '@/repo/filtersRepo';
  import ApprovalsHelper from '@/mixins/ApprovalsHelper';
  import { fetchEntityById } from '../../repo/entityRepo';

  const weeksArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  const monthsArray = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  const timezonesArray = [
    'Africa/Abidjan',
    'Africa/Accra',
    'Africa/Addis_Ababa',
    'Africa/Algiers',
    'Africa/Asmara',
    'Africa/Bamako',
    'Africa/Bangui',
    'Africa/Banjul',
    'Africa/Bissau',
    'Africa/Blantyre',
    'Africa/Brazzaville',
    'Africa/Bujumbura',
    'Africa/Cairo',
    'Africa/Casablanca',
    'Africa/Ceuta',
    'Africa/Conakry',
    'Africa/Dakar',
    'Africa/Dar_es_Salaam',
    'Africa/Djibouti',
    'Africa/Douala',
    'Africa/El_Aaiun',
    'Africa/Freetown',
    'Africa/Gaborone',
    'Africa/Harare',
    'Africa/Johannesburg',
    'Africa/Juba',
    'Africa/Kampala',
    'Africa/Khartoum',
    'Africa/Kigali',
    'Africa/Kinshasa',
    'Africa/Lagos',
    'Africa/Libreville',
    'Africa/Lome',
    'Africa/Luanda',
    'Africa/Lubumbashi',
    'Africa/Lusaka',
    'Africa/Malabo',
    'Africa/Maputo',
    'Africa/Maseru',
    'Africa/Mbabane',
    'Africa/Mogadishu',
    'Africa/Monrovia',
    'Africa/Nairobi',
    'Africa/Ndjamena',
    'Africa/Niamey',
    'Africa/Nouakchott',
    'Africa/Ouagadougou',
    'Africa/Porto-Novo',
    'Africa/Sao_Tome',
    'Africa/Tripoli',
    'Africa/Tunis',
    'Africa/Windhoek',
    'America/Adak',
    'America/Anchorage',
    'America/Anguilla',
    'America/Antigua',
    'America/Araguaina',
    'America/Argentina/Buenos_Aires',
    'America/Argentina/Catamarca',
    'America/Argentina/Cordoba',
    'America/Argentina/Jujuy',
    'America/Argentina/La_Rioja',
    'America/Argentina/Mendoza',
    'America/Argentina/Rio_Gallegos',
    'America/Argentina/Salta',
    'America/Argentina/San_Juan',
    'America/Argentina/San_Luis',
    'America/Argentina/Tucuman',
    'America/Argentina/Ushuaia',
    'America/Aruba',
    'America/Asuncion',
    'America/Atikokan',
    'America/Bahia',
    'America/Bahia_Banderas',
    'America/Barbados',
    'America/Belem',
    'America/Belize',
    'America/Blanc-Sablon',
    'America/Boa_Vista',
    'America/Bogota',
    'America/Boise',
    'America/Cambridge_Bay',
    'America/Campo_Grande',
    'America/Cancun',
    'America/Caracas',
    'America/Cayenne',
    'America/Cayman',
    'America/Chicago',
    'America/Chihuahua',
    'America/Costa_Rica',
    'America/Creston',
    'America/Cuiaba',
    'America/Curacao',
    'America/Danmarkshavn',
    'America/Dawson',
    'America/Dawson_Creek',
    'America/Denver',
    'America/Detroit',
    'America/Dominica',
    'America/Edmonton',
    'America/Eirunepe',
    'America/El_Salvador',
    'America/Fort_Nelson',
    'America/Fortaleza',
    'America/Glace_Bay',
    'America/Godthab',
    'America/Goose_Bay',
    'America/Grand_Turk',
    'America/Grenada',
    'America/Guadeloupe',
    'America/Guatemala',
    'America/Guayaquil',
    'America/Guyana',
    'America/Halifax',
    'America/Havana',
    'America/Hermosillo',
    'America/Indiana/Indianapolis',
    'America/Indiana/Knox',
    'America/Indiana/Marengo',
    'America/Indiana/Petersburg',
    'America/Indiana/Tell_City',
    'America/Indiana/Vevay',
    'America/Indiana/Vincennes',
    'America/Indiana/Winamac',
    'America/Inuvik',
    'America/Iqaluit',
    'America/Jamaica',
    'America/Juneau',
    'America/Kentucky/Louisville',
    'America/Kentucky/Monticello',
    'America/Kralendijk',
    'America/La_Paz',
    'America/Lima',
    'America/Los_Angeles',
    'America/Lower_Princes',
    'America/Maceio',
    'America/Managua',
    'America/Manaus',
    'America/Marigot',
    'America/Martinique',
    'America/Matamoros',
    'America/Mazatlan',
    'America/Menominee',
    'America/Merida',
    'America/Metlakatla',
    'America/Mexico_City',
    'America/Miquelon',
    'America/Moncton',
    'America/Monterrey',
    'America/Montevideo',
    'America/Montserrat',
    'America/Nassau',
    'America/New_York',
    'America/Nipigon',
    'America/Nome',
    'America/Noronha',
    'America/North_Dakota/Beulah',
    'America/North_Dakota/Center',
    'America/North_Dakota/New_Salem',
    'America/Ojinaga',
    'America/Panama',
    'America/Pangnirtung',
    'America/Paramaribo',
    'America/Phoenix',
    'America/Port-au-Prince',
    'America/Port_of_Spain',
    'America/Porto_Velho',
    'America/Puerto_Rico',
    'America/Rainy_River',
    'America/Rankin_Inlet',
    'America/Recife',
    'America/Regina',
    'America/Resolute',
    'America/Rio_Branco',
    'America/Santa_Isabel',
    'America/Santarem',
    'America/Santiago',
    'America/Santo_Domingo',
    'America/Sao_Paulo',
    'America/Scoresbysund',
    'America/Sitka',
    'America/St_Barthelemy',
    'America/St_Johns',
    'America/St_Kitts',
    'America/St_Lucia',
    'America/St_Thomas',
    'America/St_Vincent',
    'America/Swift_Current',
    'America/Tegucigalpa',
    'America/Thule',
    'America/Thunder_Bay',
    'America/Tijuana',
    'America/Toronto',
    'America/Tortola',
    'America/Vancouver',
    'America/Whitehorse',
    'America/Winnipeg',
    'America/Yakutat',
    'America/Yellowknife',
    'Antarctica/Casey',
    'Antarctica/Davis',
    'Antarctica/DumontDUrville',
    'Antarctica/Macquarie',
    'Antarctica/Mawson',
    'Antarctica/McMurdo',
    'Antarctica/Palmer',
    'Antarctica/Rothera',
    'Antarctica/Syowa',
    'Antarctica/Troll',
    'Antarctica/Vostok',
    'Arctic/Longyearbyen',
    'Asia/Aden',
    'Asia/Almaty',
    'Asia/Amman',
    'Asia/Anadyr',
    'Asia/Aqtau',
    'Asia/Aqtobe',
    'Asia/Ashgabat',
    'Asia/Baghdad',
    'Asia/Bahrain',
    'Asia/Baku',
    'Asia/Bangkok',
    'Asia/Beirut',
    'Asia/Bishkek',
    'Asia/Brunei',
    'Asia/Chita',
    'Asia/Choibalsan',
    'Asia/Colombo',
    'Asia/Damascus',
    'Asia/Dhaka',
    'Asia/Dili',
    'Asia/Dubai',
    'Asia/Dushanbe',
    'Asia/Gaza',
    'Asia/Hebron',
    'Asia/Ho_Chi_Minh',
    'Asia/Hong_Kong',
    'Asia/Hovd',
    'Asia/Irkutsk',
    'Asia/Jakarta',
    'Asia/Jayapura',
    'Asia/Jerusalem',
    'Asia/Kabul',
    'Asia/Kamchatka',
    'Asia/Karachi',
    'Asia/Kathmandu',
    'Asia/Khandyga',
    'Asia/Kolkata',
    'Asia/Krasnoyarsk',
    'Asia/Kuala_Lumpur',
    'Asia/Kuching',
    'Asia/Kuwait',
    'Asia/Macau',
    'Asia/Magadan',
    'Asia/Makassar',
    'Asia/Manila',
    'Asia/Muscat',
    'Asia/Nicosia',
    'Asia/Novokuznetsk',
    'Asia/Novosibirsk',
    'Asia/Omsk',
    'Asia/Oral',
    'Asia/Phnom_Penh',
    'Asia/Pontianak',
    'Asia/Pyongyang',
    'Asia/Qatar',
    'Asia/Qyzylorda',
    'Asia/Rangoon',
    'Asia/Riyadh',
    'Asia/Sakhalin',
    'Asia/Samarkand',
    'Asia/Seoul',
    'Asia/Shanghai',
    'Asia/Singapore',
    'Asia/Srednekolymsk',
    'Asia/Taipei',
    'Asia/Tashkent',
    'Asia/Tbilisi',
    'Asia/Tehran',
    'Asia/Thimphu',
    'Asia/Tokyo',
    'Asia/Ulaanbaatar',
    'Asia/Urumqi',
    'Asia/Ust-Nera',
    'Asia/Vientiane',
    'Asia/Vladivostok',
    'Asia/Yakutsk',
    'Asia/Yekaterinburg',
    'Asia/Yerevan',
    'Atlantic/Azores',
    'Atlantic/Bermuda',
    'Atlantic/Canary',
    'Atlantic/Cape_Verde',
    'Atlantic/Faroe',
    'Atlantic/Madeira',
    'Atlantic/Reykjavik',
    'Atlantic/South_Georgia',
    'Atlantic/St_Helena',
    'Atlantic/Stanley',
    'Australia/Adelaide',
    'Australia/Brisbane',
    'Australia/Broken_Hill',
    'Australia/Currie',
    'Australia/Darwin',
    'Australia/Eucla',
    'Australia/Hobart',
    'Australia/Lindeman',
    'Australia/Lord_Howe',
    'Australia/Melbourne',
    'Australia/Perth',
    'Australia/Sydney',
    'Europe/Amsterdam',
    'Europe/Andorra',
    'Europe/Athens',
    'Europe/Belgrade',
    'Europe/Berlin',
    'Europe/Bratislava',
    'Europe/Brussels',
    'Europe/Bucharest',
    'Europe/Budapest',
    'Europe/Busingen',
    'Europe/Chisinau',
    'Europe/Copenhagen',
    'Europe/Dublin',
    'Europe/Gibraltar',
    'Europe/Guernsey',
    'Europe/Helsinki',
    'Europe/Isle_of_Man',
    'Europe/Istanbul',
    'Europe/Jersey',
    'Europe/Kaliningrad',
    'Europe/Kiev',
    'Europe/Lisbon',
    'Europe/Ljubljana',
    'Europe/London',
    'Europe/Luxembourg',
    'Europe/Madrid',
    'Europe/Malta',
    'Europe/Mariehamn',
    'Europe/Minsk',
    'Europe/Monaco',
    'Europe/Moscow',
    'Europe/Oslo',
    'Europe/Paris',
    'Europe/Podgorica',
    'Europe/Prague',
    'Europe/Riga',
    'Europe/Rome',
    'Europe/Samara',
    'Europe/San_Marino',
    'Europe/Sarajevo',
    'Europe/Simferopol',
    'Europe/Skopje',
    'Europe/Sofia',
    'Europe/Stockholm',
    'Europe/Tallinn',
    'Europe/Tirane',
    'Europe/Uzhgorod',
    'Europe/Vaduz',
    'Europe/Vatican',
    'Europe/Vienna',
    'Europe/Vilnius',
    'Europe/Volgograd',
    'Europe/Warsaw',
    'Europe/Zagreb',
    'Europe/Zaporozhye',
    'Europe/Zurich',
    'Indian/Antananarivo',
    'Indian/Chagos',
    'Indian/Christmas',
    'Indian/Cocos',
    'Indian/Comoro',
    'Indian/Kerguelen',
    'Indian/Mahe',
    'Indian/Maldives',
    'Indian/Mauritius',
    'Indian/Mayotte',
    'Indian/Reunion',
    'Pacific/Apia',
    'Pacific/Auckland',
    'Pacific/Bougainville',
    'Pacific/Chatham',
    'Pacific/Chuuk',
    'Pacific/Easter',
    'Pacific/Efate',
    'Pacific/Enderbury',
    'Pacific/Fakaofo',
    'Pacific/Fiji',
    'Pacific/Funafuti',
    'Pacific/Galapagos',
    'Pacific/Gambier',
    'Pacific/Guadalcanal',
    'Pacific/Guam',
    'Pacific/Honolulu',
    'Pacific/Johnston',
    'Pacific/Kiritimati',
    'Pacific/Kosrae',
    'Pacific/Kwajalein',
    'Pacific/Majuro',
    'Pacific/Marquesas',
    'Pacific/Midway',
    'Pacific/Nauru',
    'Pacific/Niue',
    'Pacific/Norfolk',
    'Pacific/Noumea',
    'Pacific/Pago_Pago',
    'Pacific/Palau',
    'Pacific/Pitcairn',
    'Pacific/Pohnpei',
    'Pacific/Port_Moresby',
    'Pacific/Rarotonga',
    'Pacific/Saipan',
    'Pacific/Tahiti',
    'Pacific/Tarawa',
    'Pacific/Tongatapu',
    'Pacific/Wake',
    'Pacific/Wallis',
    'UTC',
  ];

  let minutesArray = [];
  let hoursArray = [];
  let daysArray = [];
  let yearsArray = [];
  export default {
    data() {
      return {
        accountNamesObj: {},
        mappedEntityPrimaryFields: {},
        filtersByEntityId: [],
        filtersByEntityIdObj: {},
        openApproverFilters: false,
        selectedEntityFields: [],
        currentFetchedEntity: {},
        currentApproverIndex: 0,
        filterComponentKey: 'key',
        approvalDataActionsMailSettings: {
          subject: 'Action Required: Please Complete the Form at Your Earliest Convenience',
          body: `
            <p>Dear User,</p>
            <p>We hope this message finds you well.</p>
            <p>We kindly request you to complete the form linked below. Your input is important to us and will help ensure we have the correct and complete information.</p>
            <p>Please click the button below to begin filling out the form:</p>
            <p>Thank you in advance for your time and cooperation.</p>
            <p>Best regards</p>
          `,
          cc_user: [],
          header_body: '',
          footer_body: '',
          name: '',
        },
        revokeApprovalActionsDialog: false,
        revokeActionsMapObject: {},
        allFormbuilders: [],
        approvalActionsMapObject: {},
        rejectActionsMapObject: {},
        selectedFormActionsIndex: 0,
        actionsFormbuilderMailTempDialog: false,
        actionsRejectMailTempDialog: false,
        checkApprovalUpdateMailCC: false,
        getCompanyUsers: [],
        getAllContacts: [],
        checkApprovalUpdateMailBCC: false,
        hasAccess: false,
        originalFormbuilderName: '',
        showDetailedView: false,
        redirectEntityFields: [],
        refreshEntityFilterDialog: false,
        redirectEntity: null,
        formbuilderFields: [],
        templateGroups: [],
        positionOptions: [
          {
            value: 'TOP',
            label: 'Top',
          },
          {
            value: 'BOTTOM',
            label: 'Bottom',
          },
        ],
        horizontalPositionOptions: [
          {
            value: 'LEFT',
            label: 'Left',
          },
          {
            value: 'CENTER',
            label: 'Center',
          },
          {
            value: 'RIGHT',
            label: 'Right',
          },
        ],
        visible: false,
        templatename: '',
        isDuplicate: false,
        previewTemplateName: '',
        templateData: [],
        value2: '',
        templateId: null,
        showChatbot: false,
        isminutesIndeterminate: true,
        ishoursIndeterminate: true,
        isdaysIndeterminate: true,
        isweeksIndeterminate: true,
        ismonthsIndeterminate: true,
        isyearsIndeterminate: true,
        minutes: minutesArray,
        hours: hoursArray,
        days: daysArray,
        weeks: weeksArray,
        months: monthsArray,
        years: yearsArray,
        time_zone: timezonesArray,
        modalLoading: false,

        action: 'Add',
        userTypeValue: '',
        company_users: [],
        form_builder: {},
        formBuilder: {
          name: '',
          steps: [],
          description: '',
          code: '',
          user_type: '',
          icon_type: '',
          icon: '',
          form_builders_owner: '',
          form_builder_filter: '',
          logo: '',
          entity_id: null,
          form_builder_owners: [],
          contact_email: '',
          approval_users: [],
          approve_all_user: false,
          enforce_order: false,
          is_approval_form: false,
          priority_based: false,
          approval_configuration_type: 'STANDARD',
          advanced_approval_users: [],
          approval_receiver_permissions: {
            view: true,
            edit: false,
            delete: false,
          },
          rejection_receiver_permissions: {
            view: true,
            edit: false,
            delete: false,
          },
          allow_export_as_excel: false,
          allow_export_as_pdf: false,
          allow_revoke_approval: false,
          allow_revoke_for_approved: false,
          allow_revoke_for_rejected: false,
          allow_revoke_for_both: true,
          allow_revoke_for_approved_for_filler: false,
          allow_revoke_for_rejected_for_filler: false,
          allow_revoke_for_both_for_filler: true,
          show_revoke_reason_dialog: true,
          show_approval_reason_dialog: false,
          show_approval_rating: false,
          allow_edit_for_approver: false,
          allow_field_level_permissions: false,
          settings: {
            is_time_bond: false,
            disableDate: new Date(),
            formbuilder_start_time: '',
            formbuilder_date_range: [new Date(), new Date()],
            formbuilder_end_time: '',

            frequency: false,
            limit_responses: false,
            is_allowed_to_all_users: false,
            no_responses_limited: 1,
            secure_access: false,
            access_to_all: true,
            edit_responses: false,
            view_responses: false,
            success_and_redirect_page: {
              thankyou_page: 'Thanks! We have received your submission.',
              redirect_to: false,
              redirect_to_url: '',
              notify_sender: true,
              notify_reciever: true,
              mail_recievers: [],
            },
            allowed_entity_users: [],
            schedules: {
              entity_id: null,
              filters: [],
              entity_data: [],
              limit: 0,
              start_time: '',
              end_time: '',
              interval: '',
              expired_time_interval_type: '',
              expired_time_interval_value: 0,
              interval_value: 0,
              daily_start_time: '',
              minutes: [],
              hours: [],
              days: [],
              months: [],
              days_of_week: [],
              years: [],
              checkAllminutes: false,
              checkAllhours: false,
              checkAlldays: false,
              checkAllweeks: false,
              checkAllmonths: false,
              checkAllyears: false,
              time_zone: '',
              status: false,
              multiple: false,
            },
            interval_settings: {
              status: false,
              start_time: '',
              end_time: '',
              type: '',
              expired_time_interval_type: '',
              expired_time_interval_value: 0,
            },
            reminder_settings: {
              type: 'FORMBUILDER',
              formBuilder_details_id: '',
              reminder_start_time: '',
              reminder_end_time: '',
              reminder_interval_type: '',
              reminder_interval_value: 0,
              status: true,
              first_reminder_interval_type: '',
              first_reminder_interval_value: 0,
            },
          },
          customization: {
            add_button_color: '#3ABFF8',
            finish_button_color: '#3ABFF8',
            button_background_color: '#ffffff',
            default_font_type: fonts?.fontTypes?.[0]?.value || '',
            add_button_size: 'small',
            finish_button_size: 'small',
            add_button_label: 'Add',
            finish_button_label: 'Finish',
            show_link_to_be_copy: true,
            show_detailed_link: true,
            show_initial_confirmation: true,
            show_try_esigns_and_content: true,
            show_title_bar: true,
            button_position: 'TOP',
            rework_button_name: 'Rework',
            isFormLabel: false,
            save_as_draft: false,
            selected_fields: [],
            separator: '',
            show_labels: true,
            remove_special_characters: false,
            settingEntity: '',
            settingField: '',
          },
          expiration_settings: {
            expiry_type: '',
            expiry_duration: 0,
          },
          global_date_format: '',
          groups: this.$route.query.group ? [this.$route.query.group] : [],
          approval_mail_template: {
            subject: 'Approval request',
            body: '<p>Hello,</p>\n\n<p>Please click on the below link to approve it.</p>\n\n<p>Thank you.</p>\n',
            cc_user: [],
            header_body: '',
            footer_body: '',
            name: '',
          },
          receiver_mail_template: {
            subject: 'Form filled',
            body: '<p>Hello,</p>\n\n<p>We would like to confirm that we have received your response to the form. Thank you for taking the time to complete it.</p>\n\n<p>Thank you.</p>\n',
            cc_user: [],
            header_body: '',
            footer_body: '',
            name: '',
          },
          send_receiver_approval_mail: false,
          approval_update_receivers: [],
          receiver_approval_update_mail_template: {
            subject: 'Update on approval form',
            body: '<p>Hello,</p>\n\n<p>We are here to update you that your approval status is now [[approval_status]]. Please click the button below to access the form for further details and next steps.</p>\n\n<p>Thank you.</p>\n',
            cc_user: [],
            cc_user_type: '',
            cc_company_user_type: '',
            cc_application_user_type: '',
            bcc_user: [],
            bcc_user_type: '',
            bcc_company_user_type: '',
            bcc_application_user_type: '',
            header_body: '',
            footer_body: '',
            name: '',
          },
          receiver_rejection_update_mail_template: {
            subject: 'Update on approval form',
            body: '<p>Hello,</p>\n\n<p>We are here to update you that your approval status is now REJECTED. Please click the button below to access the form for further details and next steps.</p>\n\n<p>Thank you.</p>\n',
            cc_user: [],
            cc_user_type: '',
            cc_company_user_type: '',
            cc_application_user_type: '',
            bcc_user: [],
            bcc_user_type: '',
            bcc_company_user_type: '',
            bcc_application_user_type: '',
            header_body: '',
            footer_body: '',
            name: '',
          },
          rework_user_mail_template: {
            subject: 'Action Required: Please Revise Your Submitted Form',
            body: `<p>Dear User,</p>

          <p>We have reviewed your recent form submission and identified areas that require revision.</p>

          <p>Please revisit the form, make the necessary updates, and resubmit it at your earliest convenience.</p>

          <p>If you have any questions or need further assistance, feel free to reach out.</p>

          <p>Thank you for your attention to this matter.</p>

          <p>Best regards`,
            header_body: '',
            footer_body: '',
            name: '',
          },
          allow_rework_on_form: false,
          approval_child_entity_tables: [],
          approval_redirection: '',
          approval_redirection_filter: {
            filters: [],
            filter_name: '',
            entity_id: '',
            isSaveFilter: false,
            columns_settings: [],
            quick_filters: [],
          },
          approval_data_actions_type: 'SIMPLE',
          approval_data_actions: [],
          reject_data_actions: [],
          revoke_approval_data_actions: [],
          conditional_approval_data_actions: [],
          primary_fields: [],
        },
        default_settings: {
          frequency: false,
          limit_responses: false,
          no_responses_limited: 1,
          is_allowed_to_all_users: false,
          success_and_redirect_page: {
            thankyou_page: '',
            redirect_to: false,
            redirect_to_url: '',
            notify_sender: true,
            notify_reciever: true,
          },
          allowed_entity_users: [],

          // schedules: {
          //   entity_id: null,
          //   filters: [],
          //   limit: 0,
          //   start_time: null,
          //   end_time: null,
          //   interval: "",
          //   expired_time_interval_type: "",
          //   expired_time_interval_value: 0,
          //   daily_start_time: "",
          //   entity_data: [],
          //   status: false,
          // },
          // interval_settings: {
          //   status: false,
          //   start_time: "",
          //   end_time: "",
          //   type: "",
          //   expired_time_interval_type: "",
          //   expired_time_interval_value: 0,
          // },
          // reminder_settings: {
          //   type: "WORKFLOW",
          //   formBuilder_details_id: "",
          //   reminder_start_time: "",
          //   reminder_end_time: "",
          //   reminder_interval_type: "",
          //   reminder_interval_value: 0,
          //   status: false,
          // },
        },

        employeeTypes: [
          {
            name: 'W2 Salaried Employee',
            value: 'W2_SALARIED_EMPLOYEE',
          },
          {
            name: '1099 Employee',
            value: '1099_EMPLOYEE',
          },
        ],

        allOwnerTypes: [
          {
            label: 'Company User',
            value: 'USER',
          },
          {
            label: 'Application User',
            value: 'ENTITY',
          },
          {
            label: 'Anyone',
            value: 'COMPANY',
          },
          {
            label: 'Anonymous',
            value: 'ANONYMOUS',
          },
        ],

        assets: [
          {
            name: 'Offer Letter',
            value: 'OFFER_LETTER',
            slug: 'offer-letter',
          },
          {
            name: 'Company Documents',
            value: 'COMPANY_DOCUMENTS',
            slug: 'company-documents',
            company_documents: {
              static: [],
              custom: [],
              standard: [],
              requested: [],
            },
          },
          // {
          //   name: "Relational Data",
          //   value: "RELATIONAL_DATA",
          //   slug: "relational-data",
          //   relational_data: {
          //     template: "",
          //     fields: [],
          //     name: ""
          //   }
          // }
        ],

        standardDocumentsList: companyDocuments.STANDARD_DOCUMENTS_LIST,
        templateName: '',
        benefitNames: {
          OFFER_LETTER: 'Offer Letter',
          COMPANY_DOCUMENTS: 'Company Documents',
          RELATIONAL_DATA: 'Relational Data',
        },
        benefitIcons: {
          OFFER_LETTER: 'employee-CV.svg',
          COMPANY_DOCUMENTS: 'document-folder.svg',
          RELATIONAL_DATA: 'document-folder.svg',
          TEMPLATE: 'document-folder.svg',
          ENTITY: 'document-folder.svg',
        },
        loading: true,
        currentTemplate: null,
        currentAsset: null,
        formBuilderId: null,
        seletedStepData: {
          company_documents: {
            static: [],
            standard: [],
            custom: [],
            requested: [],
          },
          relational_data: {
            name: '',
            template: '',
            fields: [],
          },
        },
        selectedStepIndex: -1,
        selectedRelationalDataFields: [],
        configureTitles: {
          sender_title: '',
          receiver_title: '',
          isLoginEntity: false,
          applyRelationship: false,
          linkedToUserTemplate: false,
          selectedTemplates: [],
          is_repeatable: false,
          max_records: 3,
          min_records: 1,
          linked_field: '',
          linked_min_field: '',
          contact_entity: '',
          contact_entity_name: '',
          contact_entity_type: '',
          entity_table_configuration: [],
        },
        configureSettings: false,
        configureDocumentSettings: false,
        configureCompanyDocumentsVisible: false,
        configureStepTitlesVisible: false,
        configureRelationalDataVisible: false,
        searchDocumentFormData: {
          type: '',
          group_id: '',
          category_id: '',
          searchedDocuments: [],
        },
        allUserTypes: [],
        iconPickerdialogVisible: false,
        iconSearch: '',
        formbuilderIconPath: 'block-portfolio.svg',
        iconType: 'DEFAULT',
        templateTitle: {
          sender_title: '',
          reciever_title: '',
        },
        customTemplateComponent: {
          title: '',
          description: '',
          templateName: '',
          primaryFieldsOption: [
            {
              value: 'HTML',
              label: 'HTML',
            },
            {
              value: 'CSS',
              label: 'CSS',
            },
            {
              value: 'JavaScript',
              label: 'JavaScript',
            },
          ],
          primaryFields: [],
        },
        activeStep: 0,
        templateSearchString: '',
        formBuilderEditStep: 'Form Builder Details',
        entitySearchString: '',
        currentEntity: null,
        entitiesData: [],
        templatesData: [],
        allEntitiesData: [],
        allTemplatesData: [],
        logoUploadModal: false,
        relationshipsData: [],
        refresh: true,
        pickerOptions: {
          disabledDate: this.disabledDatesUptoYesterday,
          shortcuts: [
            {
              text: '24 Hours',
              onClick() {
                bus.$emit('date_range', 'TOMARROW');
              },
            },
            {
              text: 'Weekly',
              onClick() {
                bus.$emit('date_range', 'WEEK');
              },
            },
            {
              text: 'Bi-weekly',
              onClick() {
                bus.$emit('date_range', 'BIWEEKLY');
              },
            },
            {
              text: 'Monthly',
              onClick() {
                bus.$emit('date_range', 'MONTHLY');
              },
            },
            {
              text: 'Quarterly',
              onClick() {
                bus.$emit('date_range', 'QUARTERLY');
              },
            },
            {
              text: 'Half-yearly',
              onClick() {
                bus.$emit('date_range', 'HALFYEARLY');
              },
            },
            {
              text: 'Yearly',
              onClick() {
                bus.$emit('date_range', 'YEARLY');
              },
            },
          ],
        },
        entityTemplates: [],
        entityUsers: [],
        showApprovers: false,
        userTypes: [
          { value: 'APPLICATION', label: 'Application Users' },
          { value: 'COMPANY', label: 'Company Users' },
          { value: 'LINKEDFIELD', label: 'Based on filled data' },
        ],
        accountTypes: [
          { value: 'GROUP', label: 'Group' },
          { value: 'SPECIFIC_USER', label: 'Specific User' },
        ],
        ccuserTypes: [
          { value: 'APPLICATION', label: 'Application Users' },
          { value: 'COMPANY', label: 'Company Users' },
          { value: 'CUSTOM', label: 'Custom Email' },
        ],
        resourceTypes: [
          { value: 'FILTER', label: 'Group' },
          { value: 'SPECIFIC_USER', label: 'Specific User' },
        ],
        filterTypes: [
          { value: 'SAVED_FILTER', label: 'Saved Filters' },
          { value: 'CONFIGURE_FILTER', label: 'Add new filter' },
        ],
        selectedUserType: '',
        selectedCompanyUserType: '',
        selectedEntityUserType: '',
        selectedApplicationUserEmails: [],
        selectedCompanyUserEmails: [],
        allContacts: [],
        activeApprovalTab: 'users',
        activeMainTab: 'primary_settings',
        editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
        editorConfig1: {},
        editorConfig2: {},
        editorConfig3: {},
        editorConfig4: {},
        editorConfig5: {},
        editorConfig6: {},
        editorConfig7: {},
        editorConfig8: {},
        allMentionableFields: [],
        formbuilderGroupsData: [],
        loadingSaveGroup: false,
        showAddGroupDialog: false,
        groupName: '',
        emailTemplatesParentListDialog: false,
        receiverEmailTemplatesParentListDialog: false,
        receiverApprovalEmailTemplatesListDialog: false,
        receiverRejectionEmailTemplatesListDialog: false,
        reworkUserEmailTemplatesListDialog: false,
        approvalActionsEmailTemplatesListDialog: false,
        rejectActionsEmailTemplatesListDialog: false,
        entityTables: [],
        entityTablesRefresh: false,
        entity_table_configuration: [],
        entityFilters: [],
        files: null,
        upLoadEffect: false,
        getAllEntityGroupsData: [],
        allFormbuilderFields: [],
        detailedTempIds: [],
        activeTempId: null,
        approvalDataActions: [],
        rejectDataActions: [],
        selectedActionType: 'approved',
        formbuilderAllFilters: [],
        ConcatenateFields: '',
        fieldLevelPermissionsModal: false,
        selectedFormBuilderCustomization: {},
        selctedUserAndFilter: null,
        allFormBuilderOriginalFields: [],
        types: [
          'SINGLE_LINE_TEXT',
          'PHONE_COUNTRY_CODE',
          'ENTITY',
          'DATE',
          'DATE_TIME',
          'DATE_TIME_RANGE',
          'TIME',
          'TIME_RANGE',
          'FILE',
          'MULTI_SELECT',
          'SELECT',
          'NUMBER',
          'CURRENCY',
          'CHECKBOX',
          'FORMULA',
          'LIST',
          'AGGREGATE_FUNCTION',
          'AUTO_INCREMENT_NUMBER',
          'RANDOM_TEXT',
          'WEEKDAYS',
          'STAR_RATING',
          'CONCATENATE',
          'DATE_RANGE',
          'MULTI_LINE_TEXT',
          'INTEGRATION',
          'INTEGRATION_VARIABLE',
          'PRICE',
          'SLOT',
          'YES_OR_NO',
          'SIGNATURE',
          'RADIO',
          'RADIO_BUTTON_GROUP',
          'CHECKBOX_GROUP',
        ],
        localSettings: {},
        settingEntityName: '',
      };
    },
    components: {
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
      EntityFilter: () => import('../entity/entityFilters.vue'),
      AnyFieldsExecute: () => import('../templates/formComponentsExecute/AnyFieldsExecute.vue'),
      AdvancedApprovalSettings: () => import('./advancedApprovalSettings.vue'),
      AdvancedApprovalDataActions: () => import('./advancedApprovalDataActions.vue'),
      TextEditor,
      draggable,
      viewTemplate,
      singleEntityTemplatesList: () =>
        import('@/components/emailTemplates/singleEntityTemplatesList.vue'),
      vueAnkaCropper,
      FieldLevelPermissions: () => import('../entity/FieldLevelPermissions.vue'),
    },
    props: ['Step', 'fromEntityData', 'entitydataformsetting'],
    mounted() {
      if (this.fromEntityData) {
        this.activeStep = this.Step;
        this.formBuilder = this.entitydataformsetting;
        this.activeMainTab = 'approval_settings';
      }
      this.checkMonths();
      this.checkHours();
      this.checkDays();
      this.checkYears();
      this.getTimeZone();
      this.getNecessaryInfo();
      this.$store.dispatch('formBuilders/clearErrors');
      this.configCKeditor();
      this.fetchCompanyGroups();
    },
    mixins: [UserHelper, DocumentsHelper, TemplateBuilderHelper, AccessManagement, ApprovalsHelper],
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile', 'getIsRSOpen']),
      ...mapGetters('companyTemplates', ['getAllCompanyTemplatesData']),
      ...mapGetters('entities', [
        'getAllEntities',
        'getEntityDataByEntityId',
        'getEntityRecordsForTable',
        'getEntityDataById',
      ]),
      ...mapGetters('formBuilders', [
        'getFormBuilderAddStatus',
        'getFormBuilderAddData',
        'getFormBuilder',
        'getFormBuilderRemindersSettings',
        'getFormBuilderUpdateStatus',
        'getFormBuilderUpdateData',
        'getFormBuilderErrors',
        'getformbuildertemplateDatawithAi',
      ]),
      ...mapGetters('auth', [
        'getAuthenticatedUser',
        'getUserTypeList',
        'getActiveWorkspace',
        'getDefaultDateFormat',
      ]),
      ...mapGetters('contactTypes', ['getAllContactTypes']),

      ...mapGetters('entityGroups', [
        'getSingleEntityGroupData',
        'getEntityGroupErrors',
        'getError',
      ]),
      ...mapGetters('filters', ['getAllEntityFilters']),
      errors() {
        return {};
      },
      getAvailableFontTypes() {
        return fonts.fontTypes;
      },
      templateIcons() {
        if (!this.templatesData) {
          return;
        }
        const data = {};
        this.templatesData.forEach((template) => (data[template._id] = template.icon));
        return data;
      },
      iconList() {
        return iconsData.filter((e) => {
          if (this.iconSearch) {
            if (e.name.toString().includes(this.iconSearch.toString().toLowerCase())) {
              return e;
            }
          } else {
            return e;
          }
        });
      },
      getRelationshipText() {
        if (this.seletedStepData.entity && this.formBuilder?.entity_id) {
          let selectedEntity1 = (this.allEntitiesData || []).find(
            (e) => e._id == this.formBuilder.entity_id
          );
          let selectedEntity2 = (this.allEntitiesData || []).find(
            (e) => e._id == this.seletedStepData.entity
          );
          if (selectedEntity1?.name && selectedEntity2?.name) {
            return `Link ${selectedEntity2?.name} to ${selectedEntity1?.name}`;
          }
          return 'Use relational data?';
        }
        return 'Use relational data?';
      },
      templates() {
        return this.allTemplatesData ? this.allTemplatesData : [];
      },
      templateNames() {
        if (!this.templates) {
          return;
        }
        const data = {};
        this.templates.forEach((template) => (data[template._id] = template.name));
        return data;
      },
      entityIcons() {
        if (!this.entities) {
          return;
        }
        const data = {};
        this.entities.forEach((entity) => (data[entity._id] = entity.icon));
        return data;
      },
      entities() {
        return this.allEntitiesData ? this.allEntitiesData : [];
      },
      entityNames() {
        if (!this.entities) {
          return;
        }
        const data = {};
        this.entities.forEach((entity) => (data[entity._id] = entity.name));
        return data;
      },
      checkSubmitDisabled() {
        if (
          this.seletedStepData.type == 'ENTITY' &&
          (!this.configureTitles.selectedTemplates ||
            !this.configureTitles.selectedTemplates.length)
        ) {
          return true;
        } else if (
          this.seletedStepData?.standard_template &&
          !this.configureTitles.contact_entity
        ) {
          return true;
        }
        return false;
      },
      getPrevStepFields() {
        let prevTemplates = [];
        let result = [];
        this.formBuilder.steps.forEach((step, index) => {
          if (index < this.selectedStepIndex) {
            if (step.type == 'TEMPLATE' && !step?.settings?.is_repeatable) {
              prevTemplates.push({
                template_id: step.template,
                type: 'TEMPLATE',
                stepIndex: index,
              });
            } else if (step.type == 'ENTITY') {
              let currentEntity = (this.allEntitiesData || []).find((e) => e._id == step.entity);
              if (currentEntity?.templates) {
                prevTemplates = [
                  ...prevTemplates,
                  ...currentEntity?.templates.map((e) => ({
                    template_id: e.template_id,
                    type: 'ENTITY',
                    name: currentEntity.name,
                    stepIndex: index,
                  })),
                ];
              }
            }
          }
        });
        if (prevTemplates && prevTemplates.length) {
          prevTemplates.forEach((temp) => {
            result = [
              ...result,
              ...this.getTemplateFields(temp.template_id, temp.name, temp.stepIndex, temp.type),
            ];
          });
        }
        return result;
      },
      checkIsInvolved() {
        let isInvolved = this.formBuilder.steps.find(
          (e) =>
            e?.settings?.is_repeatable &&
            ((e?.settings?.linked_field &&
              e.settings.linked_field.includes('#') &&
              e.settings.linked_field.split('#')[1] == this.seletedStepData.template) ||
              (e?.settings?.linked_min_field &&
                e.settings.linked_min_field.includes('#') &&
                e.settings.linked_min_field.split('#')[1] == this.seletedStepData.template))
        );
        if (isInvolved) {
          return false;
        }
        return true;
      },
      getLabel() {
        return (userType) => {
          if (userType && userType.role) {
            return userType.role.title + ' - ' + userType.name;
          } else {
            return userType.name;
          }
        };
      },
      selectedUserEntity() {
        if (this.formBuilder?.entity_id && this.formBuilder?.form_builders_owner == 'ENTITY') {
          let selectedEntity = (this.allEntitiesData || []).find(
            (e) => e._id == this.formBuilder.entity_id
          );
          if (selectedEntity?.name && selectedEntity?.entity_type) {
            return selectedEntity;
          }
          return null;
        }
        return null;
      },
      getChildEntityTables() {
        let childTables = [];
        this.formBuilder.steps.forEach((st) => {
          if (st.type == 'ENTITY') {
            let entity = this.allEntitiesData.find((e) => e._id == st?.entity);
            entity?.templates.forEach((temp) => {
              let template = this.allTemplatesData.find((e) => e._id == temp?.template_id);
              let fields = template?.sections[0]?.fields || [];
              fields.forEach((fd) => {
                if (fd.input_type == 'ENTITY_TABLE') {
                  childTables.push({
                    key: fd.key,
                    label: fd.label,
                    entity_id: fd.entity_id,
                  });
                }
              });
            });
          } else if (st.type == 'TEMPLATE') {
            let template = this.allTemplatesData.find((e) => e._id == st?.template);
            let fields = template?.sections[0]?.fields || [];
            fields.forEach((fd) => {
              if (fd.input_type == 'ENTITY_TABLE') {
                childTables.push({
                  key: fd.key,
                  label: fd.label,
                  entity_id: fd.entity_id,
                });
              }
            });
          }
        });
        return childTables;
      },
      getAllFields() {
        let allFields = [];
        if (this.formBuilder && this.formBuilder.steps) {
          let entitySteps = this.formBuilder.steps.filter(
            (step) => step.type == 'ENTITY' && step.entity
          );
          if (entitySteps && entitySteps.length) {
            entitySteps.forEach((entity) => {
              let matchedEntity = (this.allEntitiesData || []).find((e) => e._id == entity.entity);
              if (matchedEntity?.templates) {
                const currentTemplates = (this.allTemplatesData || []).filter((e) =>
                  matchedEntity?.templates.flatMap((e) => e.template_id).includes(e._id)
                );
                if (currentTemplates && currentTemplates.length) {
                  currentTemplates.forEach((temp) => {
                    if (temp?.sections && temp?.sections?.[0]) {
                      temp.sections[0].fields.forEach((fl) => {
                        if (fl.inputType == 'ENTITY') {
                          let selectedEntity = (this.allEntitiesData || []).find(
                            (e) => e._id == fl.entity_id
                          );
                          if (
                            selectedEntity?.entity_type == 'INDIVIDUAL' ||
                            selectedEntity?.entity_type == 'BUSINESS'
                          ) {
                            allFields.push({
                              label: selectedEntity.name + '-' + temp.name + '-' + fl.label,
                              field: fl.key,
                              key:
                                entity.entity +
                                '#' +
                                selectedEntity._id +
                                '#' +
                                temp._id +
                                '#' +
                                fl.key,
                            });
                          }
                        }
                        if (fl.inputType == 'SINGLE_LINE_TEXT' && fl.input_type == 'EMAIL') {
                          allFields.push({
                            label: temp.name + '-' + fl.label,
                            field: fl.key,
                            key: entity.entity + '#' + temp._id + '#' + fl.key,
                          });
                        }
                      });
                    }
                  });
                }
              }
            });
          }
        }
        return allFields;
      },
    },
    methods: {
      handleSettingFieldChange(selectedKey) {
        if (!selectedKey) {
          this.formBuilder.customization.settingEntity = '';
          return;
        }
        const selectedField = this.getAvailableFields().find((f) => f.key === selectedKey);
        if (selectedField && selectedField.entity_id) {
          this.formBuilder.customization.settingEntity = selectedField.entity_id;
        } else {
          this.formBuilder.customization.settingEntity = '';
        }
      },
      async loadEntityName(entityId) {
        try {
          const entity = await fetchEntityById(entityId);
          this.settingEntityName = entity?.name || '';
        } catch (err) {
          console.error('Failed to load entity name:', err);
          this.settingEntityName = '';
        }
      },
      loadFormBuilderData(formBuilder) {
        this.localSettings = formBuilder.settings || {};
      },
      emitSettings() {
        this.$emit('update-settings', this.formBuilder);
      },
      async getFiltersByEntityId(entityId) {
        const getAllEntityFilters = await fetchAllEntityFiltersByEntity({
          entityId: entityId,
        });
        this.filtersByEntityIdObj[entityId] = getAllEntityFilters;
      },
      updateFilterName(filter_id, entity_id, index) {
        let filters = this.filtersByEntityIdObj[entity_id];
        let filterData = filters.find((f) => f._id == filter_id);
        this.formBuilder.approval_users[index].filter_name = filterData.filter_name;
      },
      async addFiltersForApprovers(approverIndex) {
        this.loading = true;

        if (!this.formBuilder?.approval_users?.[approverIndex]?.filters_data) {
          this.$set(this.formBuilder.approval_users, approverIndex, {
            ...this.formBuilder.approval_users[approverIndex],
            filters_data: {
              parentFilterId: '',
              query_type: 'AND',
              filters: [
                {
                  field: '',
                  operator: '',
                  value: '',
                  value_type: '',
                  value_source: '',
                  data_type: '',
                  query_type: 'AND',
                  value_field: '',
                  validations: {
                    data_type: '',
                  },
                  grouping: {},
                  relation_entity_id: '',
                  relational_filter_query: 'includes',
                  isUserFilter: false,
                },
              ],
              filter_name: '',
              isSaveFilter: false,
              columns_settings: [],
            },
          });
        }

        this.currentApproverIndex = approverIndex;
        let entityId = this.formBuilder.approval_users[approverIndex].application_user_type;
        this.currentFetchedEntity = this.entitiesData.find((e) => e._id == entityId);
        await this.setSelectedEntityFields(entityId);
        this.loading = false;

        setTimeout(() => {
          this.openApproverFilters = true;
        }, 300);
      },
      closeApproverFilters() {
        this.openApproverFilters = false;
      },
      async getEntityFields(entity_id) {
        let fields = [];
        let entity = await fetchEntityById(entity_id);
        if (entity) {
          entity.templates.forEach((tem) => {
            fields = [...fields, ...this.getFieldsByTemplateInfo(tem.templateInfo, entity)];
          });
        }
        return fields;
      },
      getFieldsByTemplateInfo(data, entity) {
        let fields = [];
        let tempData = JSON.parse(JSON.stringify(data));
        let contentFields = [
          'HEADING',
          'PARAGRAPH',
          'HTML_CONTENT',
          'SINGLE_LINE_CONTENT',
          'VIDEO',
          'ACTION_BUTTON',
          'HORIZONTAL_LINE',
          'DIVISION',
        ];
        tempData.sections.forEach((e) => {
          fields = [
            ...fields,
            ...e.fields.filter((e) => contentFields.indexOf(e.inputType) === -1),
          ];
        });
        fields = fields.map((e) => {
          e.template_id = data._id;
          e.template_name = data.name;
          if (!e.template_key) {
            e.template_key = e.template_id + '#' + e.key;
          }
          if (!e.mention_key) {
            e.mention_key = e.template_id + '#' + e.key;
          }
          if (e.key && !e.key.includes('#')) {
            e.key = e.template_id + '#' + e.key;
          }
          e.label = entity.name + ' - ' + e.label;
          return e;
        });
        return fields;
      },
      async onApplyConditionChanged(user) {
        if (user.apply_condition && !this.formbuilderAllFilters?.length) {
          this.formbuilderAllFilters = await fetchAllFormbuilderFiltersById({
            formbuilderId: this.formBuilderId,
          });
        }
        if (!user.apply_condition) {
          user.selected_filter_id = null;
        }
      },
      getLabelForBusinessAccount(data) {
        if (
          data.entity_id &&
          data.entityData &&
          this.mappedEntityPrimaryFields[data.entity_id] &&
          this.mappedEntityPrimaryFields[data.entity_id].includes('#')
        ) {
          let [tempId, key] = this.mappedEntityPrimaryFields[data.entity_id].split('#');
          if (data.entityData[tempId] && data.entityData[tempId][key]) {
            return data.entityData[tempId][key + '/name']
              ? data.entityData[tempId][key + '/name']
              : data.entityData[tempId][key];
          } else if (data.entity_prime_data[key]) {
            return data.entity_prime_data[key];
          } else {
            return Object.keys(data.entity_prime_data) &&
              Object.keys(data.entity_prime_data)[0] &&
              data.entity_prime_data[Object.keys(data.entity_prime_data)[0]]
              ? data.entity_prime_data[Object.keys(data.entity_prime_data)[0]]
              : '';
          }
        }
      },
      async getBusinessAccountNames(contactType) {
        let params = {
          contact_types: typeof contactType == 'string' ? [contactType] : contactType,
        };
        const data = await postAPICall('POST', '/entity/account-names', params);
        this.accountNamesObj = data.data;
        this.getAllContactTypes?.forEach((e) => {
          this.mappedEntityPrimaryFields[e._id] =
            e.primaryFields &&
            e.primaryFields[0] &&
            e.primaryFields[0].key &&
            e.primaryFields[0].template_id
              ? e.primaryFields[0].template_id + '#' + e.primaryFields[0].key
              : '';
        });
      },
      checkIsBusinessUserType(type) {
        let isBusiness = this.getAllContactTypes?.find(
          (ctype) => ctype._id == type && ctype.entity_type == 'BUSINESS'
        );
        return isBusiness ? true : false;
      },
      removeRevokeApprovalAction(index) {
        this.formBuilder.revoke_approval_data_actions.splice(index, 1);
      },
      addRevokeApprovalAction() {
        let row = {
          field_key: '',
          value: '',
        };
        let index = this.formBuilder.revoke_approval_data_actions.length;
        this.$set(this.revokeActionsMapObject, index, {});
        this.formBuilder.revoke_approval_data_actions.push(row);
      },
      openRevokeApprovalActions() {
        this.revokeApprovalActionsDialog = true;
      },
      closeRevokeApprovalActions() {
        this.revokeApprovalActionsDialog = false;
      },
      updateRevokeActionsObject() {
        this.formBuilder.revoke_approval_data_actions.map((action, index) => {
          if (this.revokeActionsMapObject?.[index]?.[action.field_key]) {
            action.value = this.revokeActionsMapObject[index][action.field_key];
          }
        });
      },
      openActionsFormbuilderMailTemplate(index, type) {
        if (type == 'approved') {
          this.actionsFormbuilderMailTempDialog = true;
          this.selectedFormActionsIndex = index;
          if (!this.formBuilder?.approval_data_actions?.[index]?.form_mail_settings?.body) {
            this.formBuilder.approval_data_actions[index].form_mail_settings =
              this.approvalDataActionsMailSettings;
          }
          this.formBuilder.approval_data_actions[index].form_mail_settings.body =
            this.mapMailTemplatevariables(
              this.formBuilder.approval_data_actions[index].form_mail_settings.body,
              true
            );
        } else {
          this.actionsRejectMailTempDialog = true;
          this.selectedFormActionsIndex = index;
          if (!this.formBuilder?.reject_data_actions?.[index]?.form_mail_settings?.body) {
            this.formBuilder.reject_data_actions[index].form_mail_settings =
              this.approvalDataActionsMailSettings;
          }
          this.formBuilder.reject_data_actions[index].form_mail_settings.body =
            this.mapMailTemplatevariables(
              this.formBuilder.reject_data_actions[index].form_mail_settings.body,
              true
            );
        }
      },
      closeRejectActionsMailTemp() {
        this.actionsRejectMailTempDialog = false;
        this.formBuilder.reject_data_actions[
          this.selectedFormActionsIndex
        ].form_mail_settings.body = this.mapMailTemplatevariables(
          this.formBuilder.reject_data_actions[this.selectedFormActionsIndex].form_mail_settings
            .body
        );
      },
      closeActionsFormbuilderMailTemp() {
        this.actionsFormbuilderMailTempDialog = false;
        this.formBuilder.approval_data_actions[
          this.selectedFormActionsIndex
        ].form_mail_settings.body = this.mapMailTemplatevariables(
          this.formBuilder.approval_data_actions[this.selectedFormActionsIndex].form_mail_settings
            .body
        );
      },
      updateRejectActionsObject() {
        this.formBuilder.reject_data_actions.map((action, index) => {
          if (this.rejectActionsMapObject?.[index]?.[action.field_key]) {
            action.value = this.rejectActionsMapObject[index][action.field_key];
          }
        });
      },
      updateApprovalActionsObject() {
        this.formBuilder.approval_data_actions.map((action, index) => {
          if (this.approvalActionsMapObject?.[index]?.[action.field_key]) {
            action.value = this.approvalActionsMapObject[index][action.field_key];
          }
        });
      },
      updateUserType(index) {
        if (
          this.formBuilder?.approval_users?.length &&
          this.formBuilder.approval_users?.[index] &&
          this.formBuilder.approval_users[index]?.user_type &&
          ['COMPANY', 'APPLICATION'].includes(this.formBuilder.approval_users[index].user_type) &&
          this.formBuilder.approval_users[index].approval_linked_field
        ) {
          this.formBuilder.approval_users[index].approval_linked_field = '';
        }
      },
      getMappedFormbuilderFields() {
        let allFormFields = this.getFormBuilderAllFields();
        allFormFields.forEach((f) => {
          if (f?.properties?.filed_content === 'READ ONLY') {
            f.properties.filed_content = '';
          }
        });
        return allFormFields.map((e) => {
          if (e.key && !e.key.includes('#')) {
            e.key = e.template_key;
          }
          return e;
        });
      },
      getSelectedField(fieldKey) {
        return this.getMappedFormbuilderFields().find((f) => f.key === fieldKey) || null;
      },
      addApprovalAction(type) {
        let row = {
          field_key: '',
          level: '',
          value: '',
          formbuilder_id: '',
          form_mail_settings: {
            subject: 'Action Required: Please Complete the Form at Your Earliest Convenience',
            body: `
            <p>Dear User,</p>

            <p>We hope this message finds you well.</p>

            <p>We kindly request you to complete the form linked below. Your input is important to us and will help ensure we have the correct and complete information.</p>

            <p>Please click the button below to begin filling out the form:</p>

            <p>Thank you in advance for your time and cooperation.</p>

            <p>Best regards</p>
          `,
            cc_user: [],
            header_body: '',
            footer_body: '',
            name: '',
          },
        };
        if (type == 'rejected') {
          let index = this.formBuilder.reject_data_actions.length;
          this.$set(this.rejectActionsMapObject, index, {});
          this.formBuilder.reject_data_actions.push(row);
        } else {
          let index = this.formBuilder.approval_data_actions.length;
          this.$set(this.approvalActionsMapObject, index, {});
          this.formBuilder.approval_data_actions.push(row);
        }
      },
      removeApprovalAction(type, index) {
        if (type === 'approved') {
          this.formBuilder.approval_data_actions.splice(index, 1);
        } else if (type === 'rejected') {
          this.formBuilder.reject_data_actions.splice(index, 1);
        }
      },
      getFieldProperty(fields, key, keyProperty, property = '', defaultValue = '') {
        if (fields && fields.length && key && keyProperty) {
          let field = fields.find((e) => e && e[keyProperty] == key);
          if (field) {
            if (property) {
              return field[property] ? field[property] : defaultValue;
            }
            return field;
          }
          return defaultValue;
        }
        return defaultValue;
      },
      setRedirectEntityFields(value) {
        this.formbuilderFields = [];
        this.redirectEntityFields = [];
        this.redirectEntity = null;
        this.refreshEntityFilterDialog = false;
        this.redirectEntity = this.entitiesData.find((e) => e._id == value);
        if (this.redirectEntity?.templates) {
          let templates = this.allTemplatesData.filter((t) =>
            this.redirectEntity.templates.flatMap((e) => e.template_id).includes(t._id)
          );
          templates.forEach((temp) => {
            if (temp?.sections && temp?.sections?.[0]) {
              temp.sections[0].fields.forEach((fl) => {
                if (fl.key && !fl.key.includes('#')) {
                  fl.key = temp._id + '#' + fl.key;
                  fl.template_name = temp.name;
                }
                this.redirectEntityFields.push(fl);
              });
            }
          });
          this.formbuilderFields = this.getFormBuilderAllFields();
          this.formbuilderFields = this.formbuilderFields.map((e) => {
            e.key = e.template_key;
            return e;
          });
        }
        setTimeout(() => {
          this.refreshEntityFilterDialog = true;
        }, 100);
        console.log('redirectEntityFields', this.formbuilderFields);
      },
      async setSelectedEntityFields(value) {
        this.currentFetchedEntity = {};
        this.selectedEntityFields = [];
        this.currentFetchedEntity = this.entitiesData.find((e) => e._id == value);
        if (this.currentFetchedEntity?.templates) {
          let templates = this.currentFetchedEntity.templates
            .map((temp) => {
              let template = this.allTemplatesData.find((t) => t._id === temp.template_id);
              if (template) {
                return {
                  ...template,
                  customization: temp.customization || {},
                };
              }
              return null;
            })
            .filter((template) => template !== null);
          templates.forEach((temp) => {
            let fields = temp.sections?.[0]?.fields || [];
            if (temp.customization && Object.keys(temp.customization).length > 0) {
              fields = this.applyCustomizationOnFields(fields, temp.customization);
            }
            if (fields?.length) {
              fields.forEach((fl) => {
                if (fl.key && !fl.key.includes('#')) {
                  fl.key = temp._id + '#' + fl.key;
                  fl.template_name = temp.name;
                }
                this.selectedEntityFields.push(fl);
              });
            }
          });
        }
      },
      openApprovalRedirect() {
        console.log('clicked....');
        if (this.formBuilder.approval_redirection) {
          this.setRedirectEntityFields(this.formBuilder.approval_redirection);
        }
      },
      handleCheckboxChangeForFiller() {
        if (
          this.formBuilder.allow_revoke_for_approved_for_filler ||
          this.formBuilder.allow_revoke_for_rejected_for_filler ||
          this.formBuilder.allow_revoke_for_both_for_filler
        ) {
          this.forceDisableOthersForFiller();
        }
      },
      forceDisableOthersForFiller() {
        if (this.formBuilder.allow_revoke_for_approved_for_filler) {
          this.formBuilder.allow_revoke_for_rejected_for_filler = false;
          this.formBuilder.allow_revoke_for_both_for_filler = false;
        } else if (this.formBuilder.allow_revoke_for_rejected_for_filler) {
          this.formBuilder.allow_revoke_for_approved_for_filler = false;
          this.formBuilder.allow_revoke_for_both_for_filler = false;
        } else if (this.formBuilder.allow_revoke_for_both_for_filler) {
          this.formBuilder.allow_revoke_for_approved_for_filler = false;
          this.formBuilder.allow_revoke_for_rejected_for_filler = false;
        }
      },
      isAnyOtherCheckedForFiller(current) {
        return (
          (current !== 'approved' && this.formBuilder.allow_revoke_for_approved_for_filler) ||
          (current !== 'rejected' && this.formBuilder.allow_revoke_for_rejected_for_filler) ||
          (current !== 'both' && this.formBuilder.allow_revoke_for_both_for_filler)
        );
      },
      handleCheckboxChange() {
        if (
          this.formBuilder.allow_revoke_for_approved ||
          this.formBuilder.allow_revoke_for_rejected ||
          this.formBuilder.allow_revoke_for_both
        ) {
          this.forceDisableOthers();
        }
      },
      forceDisableOthers() {
        if (this.formBuilder.allow_revoke_for_approved) {
          this.formBuilder.allow_revoke_for_rejected = false;
          this.formBuilder.allow_revoke_for_both = false;
        } else if (this.formBuilder.allow_revoke_for_rejected) {
          this.formBuilder.allow_revoke_for_approved = false;
          this.formBuilder.allow_revoke_for_both = false;
        } else if (this.formBuilder.allow_revoke_for_both) {
          this.formBuilder.allow_revoke_for_approved = false;
          this.formBuilder.allow_revoke_for_rejected = false;
        }
      },
      isAnyOtherChecked(current) {
        return (
          (current !== 'approved' && this.formBuilder.allow_revoke_for_approved) ||
          (current !== 'rejected' && this.formBuilder.allow_revoke_for_rejected) ||
          (current !== 'both' && this.formBuilder.allow_revoke_for_both)
        );
      },
      async saveFormbuilderDefaultValues(form, templateId, isEntityStep) {
        let templateStep;
        let entityStep;
        if (isEntityStep) {
          entityStep = this.formBuilder.steps.find((step) => {
            if (step.type === 'ENTITY') {
              if (!step?.default_values) {
                step.default_values = {};
              }
              let entity = this.allEntitiesData.find((e) => e._id == step?.entity);
              if (entity) {
                let foundTemplate = entity.templates.find((t) => t.template_id == templateId);
                if (foundTemplate) {
                  step.default_values[templateId] = form;
                }
                return foundTemplate !== undefined;
              }
            }
            return false;
          });
        } else {
          templateStep = this.formBuilder.steps.find((s) => s?.template == templateId);
          templateStep.default_values = form;
        }
        if (templateStep?.default_values || entityStep?.default_values) {
          this.loading = true;
          const payload = this.prepareFormBuilderData();
          await this.$store.dispatch('formBuilders/updateFormBuilder', payload);
          if (this.getFormBuilderUpdateStatus) {
            this.$notify.success({
              title: 'Success',
              message: 'Default values updated successfully!',
            });
          } else {
            this.$notify.success({
              title: 'Success',
              message: 'Default values saved successfully!',
            });
          }
          this.loading = false;
        } else {
          this.loading = false;
          console.log('Step not found!');
        }
      },
      openDialog() {
        this.visible = true;
      },

      checkDuplicateTemplateName() {
        this.isDuplicate = this.templates.some((template) => template.name === this.templatename);

        if (this.isDuplicate) {
          return this.$message.error('Template Already Exists with the same name');
        }
      },
      resetForm() {
        this.templatename = '';
      },
      getAllFormbuilderFields(types) {
        let allFields = [];
        if (this.formBuilder && this.formBuilder.steps) {
          this.formBuilder.steps.forEach((step, index) => {
            if (step.type == 'ENTITY' && step.entity) {
              let stepName =
                step.settings && step.settings.sender_title
                  ? step.settings.sender_title
                  : this.entityNames[step.entity];
              let matchedEntity = (this.allEntitiesData || []).find((e) => e._id == step.entity);
              if (matchedEntity?.templates) {
                const currentTemplates = (this.allTemplatesData || []).filter((e) =>
                  matchedEntity?.templates.flatMap((e) => e.template_id).includes(e._id)
                );
                if (currentTemplates && currentTemplates.length) {
                  currentTemplates.forEach((temp) => {
                    if (temp?.sections && temp?.sections?.[0]) {
                      temp.sections[0].fields.forEach((fl) => {
                        if (types?.includes(fl.inputType)) {
                          allFields.push({
                            label: stepName + ' - ' + temp.name + ' - ' + fl.label,
                            field: fl.key,
                            key: index + '#' + temp._id + '#' + fl.key,
                          });
                        }
                      });
                    }
                  });
                }
              }
            } else if (step.type == 'TEMPLATE' && step.template) {
              let stepName =
                step.settings && step.settings.sender_title
                  ? step.settings.sender_title
                  : this.templateNames[step.entity];
              const currentTemplate = (this.allTemplatesData || []).find(
                (e) => e._id == step.template
              );
              if (currentTemplate?.sections) {
                currentTemplate?.sections[0]?.fields.forEach((fl) => {
                  if (types.includes(fl.inputType)) {
                    allFields.push({
                      label: stepName + ' - ' + currentTemplate.name + ' - ' + fl.label,
                      field: fl.key,
                      key: index + '#' + currentTemplate._id + '#' + fl.key,
                    });
                  }
                });
              }
            }
          });
        }
        return allFields;
      },
      async getAllFormBuilderFieldsOriginal(types) {
        let allFields = [];
        if (!this.formBuilder || !this.formBuilder.steps) return allFields;
        for (const [index, step] of this.formBuilder.steps.entries()) {
          if (step.type === 'ENTITY' && step.entity) {
            const matchedEntity = await fetchEntityById(step.entity);
            if (matchedEntity?.templates?.length) {
              for (const t of matchedEntity.templates) {
                const customization = t?.customization || {};
                const fields = t.templateInfo?.sections[0]?.fields || [];

                const customizedFields = await this.applyCustomizationOnFields(
                  fields,
                  customization
                );
                const primaryFields = matchedEntity?.primaryFields || [];
                customizedFields.forEach((fl) => {
                  if (types?.includes(fl.inputType)) {
                    const isPrimary = primaryFields.some((pf) => pf.key === fl.key);
                    allFields.push({
                      ...fl,
                      key: `${index}#${t.template_id}#${fl.key}`,
                      isPrimary: !!isPrimary,
                    });
                  }
                });
              }
            }
          } else if (step.type === 'TEMPLATE' && step.template) {
            const currentTemplate = (this.allTemplatesData || []).find(
              (e) => e._id === step.template
            );
            if (!currentTemplate?.sections?.[0]) continue;

            const fields = currentTemplate.sections[0].fields || [];
            fields.forEach((fl) => {
              if (types?.includes(fl.inputType)) {
                allFields.push({
                  ...fl,
                  key: `${index}#${currentTemplate._id}#${fl.key}`,
                });
              }
            });
          }
        }
        return allFields;
      },
      async onFieldLevelPermissionChange(value) {
        if (value) {
          this.allFormBuilderOriginalFields = await this.getAllFormBuilderFieldsOriginal(
            this.types
          );
        } else {
          this.allFormBuilderOriginalFields = [];
        }
      },
      createTemplate() {
        this.TemplatewithAi();
      },
      uploadFile(file) {
        if (file && typeof file === 'string') {
          // Convert data URL to a Blob
          this.files = this.dataURLtoFile(file, 'image1');
        } else {
          this.files = file;
        }
      },

      fileError() {
        this.$alert('File Supported: JPG, PNG, JPEG, GIF');
      },

      dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(',');
        var mime = arr[0].match(/:(.*?);/)[1];
        var bstr = atob(arr[1]);
        var n = bstr.length;
        var u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },
      disabledDatesUptoYesterday(time) {
        const currentDateTime = new Date();
        const yesterdayDate = new Date(currentDateTime);
        yesterdayDate.setDate(currentDateTime.getDate() - 1);
        return time.getTime() < yesterdayDate.getTime();
      },
      ReseticonPickerdialogVisible() {
        this.iconPickerdialogVisible = false;
      },
      ResetlogoUploadModal() {
        this.logoUploadModal = false;
      },
      checkDuplicateField(index, value, type) {
        if (this.entity_table_configuration) {
          let otherField = this.entity_table_configuration.find(
            (f, i) => i != index && f[type] == value
          );
          return otherField ? true : false;
        }
        return false;
      },
      removeNewField(index) {
        this.entity_table_configuration.splice(index, 1);
      },
      addNewField() {
        this.entityTablesRefresh = true;
        this.entity_table_configuration.push({
          applyRelationship: false,
          min_records: 1,
          max_records: 3,
          linked_field: '',
          linked_min_field: '',
          selectField: '',
        });
        setTimeout(() => {
          this.entityTablesRefresh = false;
        }, 100);
      },
      checkDuplicate(index, value, type) {
        if (this.formBuilder.approval_users) {
          let otherUsers = this.formBuilder.approval_users.find(
            (user, i) => i != index && user[type] == value
          );
          return otherUsers ? true : false;
        }
        return false;
      },
      checkDuplicateReceiver(index, value, type) {
        if (this.formBuilder?.approval_update_receivers) {
          let otherUsers = this.formBuilder.approval_update_receivers.find(
            (user, i) => i != index && user[type] == value
          );
          return otherUsers ? true : false;
        }
        return false;
      },
      CloseChatBot() {
        this.showChatbot = false;
      },

      updateApplicationUserType(user) {
        this.$set(user, 'preferred_application_users', []);
      },
      updateCompanyUsers(value, user) {
        this.$set(user, 'preferred_company_users', []);
        if (value) {
          let users = this.getCompanyUsersByType(value);
          if (users && users.length == 1) {
            user.preferred_company_users = [...users.map((e) => e._id)];
          }
        }
      },
      chooseFromParentEmailTemplatesReceiver() {
        this.receiverEmailTemplatesParentListDialog = true;
      },
      closeEmailFooterReceiver() {
        this.receiverEmailTemplatesParentListDialog = false;
      },
      chooseFromRecieverApprovalMailTemps() {
        this.receiverApprovalEmailTemplatesListDialog = true;
      },
      closeEmailFooterReceiverApproval() {
        this.receiverApprovalEmailTemplatesListDialog = false;
      },
      chooseFromRecieverRejectionMailTemps() {
        this.receiverRejectionEmailTemplatesListDialog = true;
      },
      closeEmailFooterReceiverRejection() {
        this.receiverRejectionEmailTemplatesListDialog = false;
      },
      chooseFromReworkMailTemps() {
        this.reworkUserEmailTemplatesListDialog = true;
      },
      closeEmailFooterReworkMailTemps() {
        this.reworkUserEmailTemplatesListDialog = false;
      },
      chooseFromActionsApprovalMailTemps() {
        this.approvalActionsEmailTemplatesListDialog = true;
      },
      closeEmailFooterActionsApprovalMailTemps() {
        this.approvalActionsEmailTemplatesListDialog = false;
      },
      chooseFromActionsRejectMailTemps() {
        this.rejectActionsEmailTemplatesListDialog = true;
      },
      closeEmailFooterActionsRejectMailTemps() {
        this.rejectActionsEmailTemplatesListDialog = false;
      },
      resetParentReceiver() {
        if (this.formBuilder?.receiver_mail_template) {
          this.formBuilder.receiver_mail_template.footer_body = '';
          this.formBuilder.receiver_mail_template.header_body = '';
          this.formBuilder.receiver_mail_template.name = '';
        }
      },
      chooseFromParentEmailTemplates() {
        this.emailTemplatesParentListDialog = true;
      },
      closeEmailFooter() {
        this.emailTemplatesParentListDialog = false;
      },
      resetParent() {
        if (this.formBuilder?.approval_mail_template) {
          this.formBuilder.approval_mail_template.footer_body = '';
          this.formBuilder.approval_mail_template.header_body = '';
          this.formBuilder.approval_mail_template.name = '';
        }
      },
      resetParentReceiverApprovalMail() {
        if (this.formBuilder?.receiver_approval_update_mail_template) {
          this.formBuilder.receiver_approval_update_mail_template.footer_body = '';
          this.formBuilder.receiver_approval_update_mail_template.header_body = '';
          this.formBuilder.receiver_approval_update_mail_template.name = '';
        }
      },
      resetParentReceiverRejectionMail() {
        if (this.formBuilder?.receiver_rejection_update_mail_template) {
          this.formBuilder.receiver_rejection_update_mail_template.footer_body = '';
          this.formBuilder.receiver_rejection_update_mail_template.header_body = '';
          this.formBuilder.receiver_rejection_update_mail_template.name = '';
        }
      },
      resetReworkMailTemplate() {
        if (this.formBuilder?.rework_user_mail_template) {
          this.formBuilder.rework_user_mail_template.footer_body = '';
          this.formBuilder.rework_user_mail_template.header_body = '';
          this.formBuilder.rework_user_mail_template.name = '';
        }
      },
      handleSubmit() {
        this.checkDuplicateTemplateName();
        if (this.isDuplicate) {
          return;
        }
        let isFromAdd = this.$route.path.includes('/add');
        if (this.templatename) {
          this.$store.commit('formBuilders/setformbuildertemplateDatawithAi', this.formBuilder, {
            root: true,
          });
          if (isFromAdd) {
            this.$router.push({
              path: '/template/create-with-ai',
              query: {
                isFromFormBuilder: true,
                template_name: this.templatename,
                isFromAdd: isFromAdd,
              },
            });
          } else {
            this.$router.push({
              path: '/template/create-with-ai',
              query: {
                isFromFormBuilder: true,
                template_name: this.templatename,
                isFromAdd: isFromAdd,
                formId: this.$route?.params?.form_builder_id,
              },
            });
          }
          this.visible = false;
        }
      },

      OpenwithAi() {
        this.showChatbot = !this.showChatbot;
      },
      configCKeditor() {
        this.editorConfig.mentions = [
          {
            feed: this.dataFeed,
            itemTemplate:
              '<li data-id="{id}">' + '<strong class="label">{label}</strong>' + '</li>',
            outputTemplate: '<span>&nbsp;</span><span>[[{label}]]</span><span>&nbsp;</span>',
            minChars: 0,
            convertTo: function (item) {
              return {
                template_key: item.label,
              };
            },
          },
          {
            feed: '/tags?name={encodedQuery}',
            marker: '#',
          },
        ];
        this.editorConfig1 = {
          ...this.editorConfig,
          id: 'approval_mail_template',
        };
        this.editorConfig2 = {
          ...this.editorConfig,
          id: 'thank_you_page',
        };
        this.editorConfig3 = {
          ...this.editorConfig,
          id: 'receiver_approval_update_mail_template',
        };
        this.editorConfig4 = {
          ...this.editorConfig,
          id: 'approval_mail_subject',
        };
        this.editorConfig5 = {
          ...this.editorConfig,
          id: 'receiver_rejection_update_mail_template',
        };
        this.editorConfig6 = {
          ...this.editorConfig,
          id: 'rework_user_mail_template',
        };
        this.editorConfig7 = {
          ...this.editorConfig,
          id: 'send_form_approval_action_mail_template',
        };
        this.editorConfig8 = {
          ...this.editorConfig,
          id: 'send_form_rejection_action_mail_template',
        };
      },
      getFormBuilderAllFields(include_additional_fields = false) {
        let result = [];
        //Add fields from steps
        this.formBuilder.steps.forEach((step) => {
          if (step?.type == 'ENTITY') {
            let currentEntityTemplates = this.getEntityTemplates(step.entity);
            let selectedEntity = (this.allEntitiesData || []).find((e) => e._id == step.entity);
            result = [
              ...result,
              ...this.getFieldsFromTemplate(currentEntityTemplates, selectedEntity),
            ];
          } else if (!step?.settings?.is_repeatable && step?.type == 'TEMPLATE') {
            let templateData = (this.allTemplatesData || []).filter(
              (te) => te._id === step.template
            );
            result = [...result, ...this.getFieldsFromTemplate(templateData)];
          }
        });
        if (!include_additional_fields) {
          result = result.filter(
            (r) => r.input_type !== 'DATA_TABLE' && r.input_type !== 'ENTITY_TABLE'
          );
          return result;
        }
        //adding fields from user
        if (this.formBuilder?.form_builders_owner == 'ENTITY' && this.formBuilder?.entity_id) {
          //adding all templates user entity fields
          let currentEntityTemplates = this.getEntityTemplates(this.formBuilder.entity_id);
          let selectedEntity = (this.allEntitiesData || []).find(
            (e) => e._id == this.formBuilder.entity_id
          );
          let fields = this.getFieldsFromTemplate(currentEntityTemplates, selectedEntity);
          fields = fields.map((e) => {
            e.mention_key = 'user/' + e.mention_key;
            e.template_key = 'user/' + e.template_key;
            e.label = 'User-' + e.label;
            return e;
          });
          result = [...result, ...fields];
        } else {
          //adding only user fields
          ['first_name', 'last_name', 'email', 'phone', 'title', 'address', 'name'].forEach((f) => {
            result.push({
              mention_key: 'user/' + f,
              label: 'User - ' + this.capitalizeFirstLetter(f.replaceAll('_', ' ')),
              template_key: 'user/' + f,
              key: f,
              input_type: 'SINGLE_LINE_TEXT',
            });
          });
        }
        //adding approval user details
        if (this.activeMainTab == 'approval_settings') {
          if (this.activeApprovalTab == 'receiver_approval_mail') {
            result.unshift({
              mention_key: 'approval_status',
              label: 'Approval Status - Approved (or) Rejected',
              template_key: 'approval_status',
              key: 'approval_status',
              input_type: 'SINGLE_LINE_TEXT',
            });
            result.unshift({
              mention_key: 'approval_reason',
              label: 'Approval Reason',
              template_key: 'approval_reason',
              key: 'approval_reason',
              input_type: 'SINGLE_LINE_TEXT',
            });
          }
          if (this.activeApprovalTab == 'receiver_rejection_mail') {
            result.unshift({
              mention_key: 'rejection_reason',
              label: 'Rejection Reason',
              template_key: 'rejection_reason',
              key: 'rejection_reason',
              input_type: 'SINGLE_LINE_TEXT',
            });
          }
          ['first_name', 'last_name', 'email', 'phone', 'title', 'address', 'name'].forEach((f) => {
            result.push({
              mention_key: 'approver/' + f,
              label: 'Approver - ' + this.capitalizeFirstLetter(f.replaceAll('_', ' ')),
              template_key: 'approver/' + f,
              key: f,
              input_type: 'SINGLE_LINE_TEXT',
            });
          });
        }
        if (this.activeMainTab == 'rework_settings') {
          result.unshift({
            mention_key: 'rework_reason',
            label: 'Rework Reason',
            template_key: 'rework_reason',
            key: 'rework_reason',
            input_type: 'SINGLE_LINE_TEXT',
          });
        }
        return result;
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      },
      getFieldsFromTemplate(templateDataList, entity = null) {
        let result = [];
        if (templateDataList && templateDataList.length) {
          templateDataList.forEach((t) => {
            let temp = JSON.parse(JSON.stringify(t));
            let fields = temp.sections?.[0]?.fields || [];
            if (temp.customization && Object.keys(temp.customization).length > 0) {
              fields = this.applyCustomizationOnFields(fields, temp.customization);
            }
            result = [
              ...result,
              ...fields.map((e) => {
                e.template_id = temp._id;
                if (entity?._id) {
                  e.entity_key = entity.name;
                  e.mention_key = entity._id + '#' + temp._id + '#' + e.key;
                  e.label = entity.name + '-' + temp.name + '-' + e.label;
                  e.template_key = entity._id + '#' + temp._id + '#' + e.key;
                } else {
                  e.mention_key = temp._id + '#' + e.key;
                  e.label = temp.name + '-' + e.label;
                  e.template_key = temp._id + '#' + e.key;
                }
                return e;
              }),
            ];
          });
        }
        return result;
      },
      dataFeed(opts, callback) {
        var matchProperty = 'label',
          data = this.allMentionableFields.filter(function (item) {
            return item[matchProperty].toLowerCase().indexOf(opts.query.toLowerCase()) !== -1;
          });
        data = data.sort(function (a, b) {
          return a[matchProperty].localeCompare(b[matchProperty], undefined, {
            sensitivity: 'accent',
          });
        });
        callback(data);
      },
      onApprovalTabChange() {
        // getting all entity and template field that are present in form
        this.allMentionableFields = this.getFormBuilderAllFields(true);
        this.allMentionableFields = this.allMentionableFields.map((item) => {
          return {
            label: item.label,
            template_key: item.template_key,
            id: item.mention_key,
            input_type: item.inputType,
          };
        });
        if (this.activeMainTab == 'approval_data_actions') {
          this.allMentionableFields = this.allMentionableFields.filter((e) =>
            e?.template_key?.includes('user/')
          );
        }
        if (
          this.formBuilder?.is_approval_form &&
          this.formBuilder?.approval_mail_template?.body &&
          this.formBuilder?.approval_mail_template?.subject
        ) {
          this.formBuilder.approval_mail_template.body = this.mapMailTemplatevariables(
            this.formBuilder.approval_mail_template.body,
            true
          );
          this.formBuilder.approval_mail_template.subject = this.mapMailTemplatevariables(
            this.formBuilder.approval_mail_template.subject,
            true
          );
        }
        if (
          this.formBuilder?.is_approval_form &&
          this.formBuilder?.receiver_approval_update_mail_template?.body
        ) {
          this.formBuilder.receiver_approval_update_mail_template.body =
            this.mapMailTemplatevariables(
              this.formBuilder.receiver_approval_update_mail_template.body,
              true
            );
        }
        if (
          this.formBuilder?.is_approval_form &&
          this.formBuilder?.receiver_rejection_update_mail_template?.body
        ) {
          this.formBuilder.receiver_rejection_update_mail_template.body =
            this.mapMailTemplatevariables(
              this.formBuilder.receiver_rejection_update_mail_template.body,
              true
            );
        }
        if (this.formBuilder?.receiver_mail_template?.body) {
          this.formBuilder.receiver_mail_template.body = this.mapMailTemplatevariables(
            this.formBuilder.receiver_mail_template.body,
            true
          );
        }
        if (this.formBuilder?.rework_user_mail_template?.body) {
          this.formBuilder.rework_user_mail_template.body = this.mapMailTemplatevariables(
            this.formBuilder.rework_user_mail_template.body,
            true
          );
        }
        if (this.formBuilder?.settings?.success_and_redirect_page?.thankyou_page) {
          this.formBuilder.settings.success_and_redirect_page.thankyou_page =
            this.mapMailTemplatevariables(
              this.formBuilder.settings.success_and_redirect_page.thankyou_page,
              true
            );
        }
        if (this.fromEntityData) {
          this.cleanupPoppers();
        }
      },
      cleanupPoppers() {
        this.$nextTick(() => {
          setTimeout(() => {
            document.querySelectorAll('.el-popper').forEach((el) => el.remove());
          }, 50);
        });
      },
      removeUser(index) {
        this.formBuilder.approval_users.splice(index, 1);
      },
      removeUserReceiver(index) {
        this.formBuilder.approval_update_receivers.splice(index, 1);
      },
      checkIsRelational(type) {
        if (this.formBuilder.form_builders_owner == 'ENTITY' && this.formBuilder.entity_id) {
          return this.relationshipsData.find(
            (e) =>
              (e.child_entity_id == this.formBuilder.entity_id && e.parent_entity_id == type) ||
              (e.child_entity_id == type && e.parent_entity_id == this.formBuilder.entity_id)
          )
            ? true
            : false;
        }
        return false;
      },
      getUserTypeContacts(type) {
        return this.allContacts.filter((e) => {
          if (e?.contact_types) {
            return e.contact_types.find(
              (el) => el?.contact_type?._id == type || el?.contact_type == type
            )
              ? true
              : false;
          }
        });
      },
      addInitialUsers() {
        if (!this.formBuilder.approval_users || !this.formBuilder.approval_users.length) {
          this.addApprovers();
        }
      },
      getCompanyUsersByType(type) {
        return this.company_users.filter((e) => {
          if (e?.rolesList) {
            return e.rolesList.find((el) => el?.userType?._id == type) ? true : false;
          } else {
            return e.roles.find((el) => el?.userType_id == type) ? true : false;
          }
        });
      },
      async fetchContacts() {
        try {
          this.getAllContacts = await postAPICall('GET', '/contacts', {
            get_all: true,
            type: 'CONTACT',
          });
          this.allContacts = this.getAllContacts.data;
        } catch (err) {
          this.loading = false;
        }
      },
      getContactTypeIdFromValue(value) {
        let Id = '';
        try {
          if (this.getAllContactTypes && this.getAllContactTypes.data) {
            this.getAllContactTypes.data.forEach((type) => {
              if (type.name == value) {
                Id = type._id;
              }
            });
          }
        } catch (err) {
          console.log('fetchContacts', err);
        }
        if (Id == '') {
          try {
            if (this.getAllContactTypes) {
              this.getAllContactTypes.forEach((type) => {
                if (type.name == value) {
                  Id = type._id;
                }
              });
            }
          } catch (err) {
            console.log('getContactTypeIdFromValue', err);
          }
        }
        return Id;
      },
      addApprovers() {
        this.formBuilder.approval_users.push({});
      },
      addApprovalReceivers() {
        this.formBuilder.approval_update_receivers.push({});
      },
      //checking is standard template removed for individual entity
      checkForIndividual(temp) {
        if (
          this.formBuilder.form_builders_owner === 'ENTITY' &&
          this.configureTitles.isLoginEntity
        ) {
          return;
        }
        let selectedEntity = (this.allEntitiesData || []).find(
          (e) => e._id == this.seletedStepData.entity
        );
        if (selectedEntity?.entity_type == 'INDIVIDUAL') {
          let isStandardTemplate = (this.allTemplatesData || []).find(
            (el) => temp.indexOf(el._id) !== -1 && el.type == 'STANDARD'
          );
          let standardTemplate = (this.allTemplatesData || []).find((el) => el.type == 'STANDARD');
          if (!isStandardTemplate && standardTemplate?._id) {
            this.$message.error(`Individual entity must have 'contact details' template`);
            this.configureTitles.selectedTemplates.push(standardTemplate._id);
          }
        }
      },
      updateEntityName(data) {
        let selectedEntity = (this.allEntitiesData || []).find((e) => e._id == data);
        if (selectedEntity?.name) {
          this.configureTitles.contact_entity_name = selectedEntity.name;
          this.configureTitles.contact_entity_type = selectedEntity.entity_type;
        }
      },
      checkPosition(evt) {
        if (
          evt &&
          evt?.draggedContext &&
          typeof evt.draggedContext.futureIndex == 'number' &&
          typeof evt.draggedContext.index == 'number'
        ) {
          let currentStep = this.formBuilder.steps[evt.draggedContext.index];
          if (
            currentStep?.type == 'TEMPLATE' &&
            currentStep?.settings?.is_repeatable &&
            currentStep?.settings?.linked_field &&
            currentStep.settings.linked_field.includes('#')
          ) {
            let index = parseInt(currentStep.settings.linked_field.split('#')[0]);
            if (index >= evt.draggedContext.futureIndex) {
              this.checkSwapAlert();
              return false;
            }
          }
          if (
            currentStep?.type == 'TEMPLATE' &&
            currentStep?.settings?.is_repeatable &&
            currentStep?.settings?.linked_min_field &&
            currentStep.settings.linked_min_field.includes('#')
          ) {
            let index = parseInt(currentStep.settings.linked_min_field.split('#')[0]);
            if (index >= evt.draggedContext.futureIndex) {
              this.checkSwapAlert();
              return false;
            }
          }
        }
        return true;
      },
      checkSwapAlert() {
        this.$confirm('This step is repeatable & configured with previous step.', 'Warning', {
          confirmButtonText: 'Ok',
          cancelButtonText: 'Close',
        })
          .then(() => {})
          .catch(() => {});
      },
      getTemplateFields(id, name, index, type) {
        const currentTemplate = (this.allTemplatesData || []).find((e) => e._id == id);
        let result = [];
        if (currentTemplate?.sections[0]?.fields) {
          let tempName = name ? name : currentTemplate.name;
          currentTemplate?.sections[0]?.fields.forEach((fl) => {
            if (fl.inputType == 'NUMBER') {
              result.push({
                label:
                  parseInt(index) +
                  1 +
                  '. ' +
                  (type == 'ENTITY' ? name + '-' : '') +
                  tempName +
                  '-' +
                  fl.label,
                field: fl.key,
                key: index + '#' + currentTemplate._id + '#' + fl.key,
              });
            }
          });
        }
        return result;
      },
      getTimeZone() {
        let date1 = new Date();
        var sign = date1.getTimezoneOffset() > 0 ? '-' : '+';
        var offset = Math.abs(date1.getTimezoneOffset());
        var hours =
          Math.floor(offset / 60) < 10 ? '0' + Math.floor(offset / 60) : Math.floor(offset / 60);
        var minutes = offset % 60 < 10 ? '0' + (offset % 60) : offset % 60;
        let timezoneoffset = sign + hours + ':' + minutes;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timezone == 'Asia/Calcutta') {
          this.formBuilder.settings.schedules.time_zone = 'Asia/Kolkata';
        } else {
          this.formBuilder.settings.schedules.time_zone = timezone;
        }

        return timezone + ', UTC' + timezoneoffset;
      },

      checkMonths() {
        if (minutesArray == 0) {
          for (let i = 0; i <= 59; i++) {
            minutesArray.push(i);
          }
        }
      },
      checkHours() {
        if (hoursArray == 0) {
          for (let i = 0; i <= 23; i++) {
            hoursArray.push(i);
          }
        }
      },

      checkDays() {
        if (daysArray == 0) {
          for (let i = 1; i <= 31; i++) {
            daysArray.push(i);
          }
        }
      },

      checkYears() {
        if (yearsArray == 0) {
          for (let i = 2022; i <= 2030; i++) {
            yearsArray.push(i);
          }
        }
      },

      checkTemplateExists(templateId) {
        if (this.currentEntity && this.currentEntity.templates) {
          let isExist = this.currentEntity.templates.find((e) => e.template_id == templateId);
          if (isExist) {
            return true;
          }
          return false;
        }
        return false;
      },
      checkRelationship(entityId) {
        if (entityId !== this.formBuilder.entity_id) {
          return this.relationshipsData.find(
            (e) => e.child_entity_id == entityId || e.parent_entity_id == entityId
          );
        }
        return false;
      },

      handleCheckedHourChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAllhours = checkedCount === this.hours.length;
        this.ishoursIndeterminate = checkedCount > 0 && checkedCount < this.hours.length;
        this.formBuilder.settings.schedules.hours = value;
      },
      handleCheckedYearChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAllyears = checkedCount === this.years.length;
        this.isyearsIndeterminate = checkedCount > 0 && checkedCount < this.years.length;
        this.formBuilder.settings.schedules.years = value;
      },
      handleCheckYearsChange(val) {
        this.formBuilder.settings.schedules.years = val ? yearsArray : [];
        this.isyearsIndeterminate = false;
      },
      handleCheckedMonthChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAllmonths = checkedCount === this.months.length;
        this.ismonthsIndeterminate = checkedCount > 0 && checkedCount < this.months.length;
        this.formBuilder.settings.schedules.months = value;
      },
      handleCheckMonthsChange(val) {
        this.formBuilder.settings.schedules.months = val ? monthsArray : [];
        this.ismonthsIndeterminate = false;
      },
      handleCheckedWeekChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAllweeks = checkedCount === this.weeks.length;
        this.isweeksIndeterminate = checkedCount > 0 && checkedCount < this.weeks.length;
        this.formBuilder.settings.schedules.days_of_week = value;
      },
      handleCheckWeeksChange(val) {
        this.formBuilder.settings.schedules.days_of_week = val ? weeksArray : [];
        this.isweeksIndeterminate = false;
      },
      handleCheckedDayChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAlldays = checkedCount === this.days.length;
        this.isdaysIndeterminate = checkedCount > 0 && checkedCount < this.days.length;
        this.formBuilder.settings.schedules.days = value;
      },
      handleCheckDaysChange(val) {
        this.formBuilder.settings.schedules.days = val ? daysArray : [];
        this.isdaysIndeterminate = false;
      },
      handleCheckHoursChange(val) {
        this.formBuilder.settings.schedules.hours = val ? hoursArray : [];
        this.ishoursIndeterminate = false;
      },
      handleCheckMinutesChange(val) {
        this.formBuilder.settings.schedules.minutes = val ? minutesArray : [];
        this.isminutesIndeterminate = false;
      },
      handleCheckedMinuteChange(value) {
        let checkedCount = value.length;
        this.formBuilder.settings.schedules.checkAllminutes = checkedCount === this.minutes.length;
        this.isminutesIndeterminate = checkedCount > 0 && checkedCount < this.minutes.length;
        this.formBuilder.settings.schedules.minutes = value;
      },
      resetConfigureSettings() {
        this.configureTitles = {
          sender_title: '',
          receiver_title: '',
          isLoginEntity: false,
          applyRelationship: false,
          linkedToUserTemplate: false,
          selectedTemplates: [],
          is_repeatable: false,
          max_records: 3,
          min_records: 1,
          linked_field: '',
          linked_min_field: '',
          contact_entity: '',
          contact_entity_name: '',
          contact_entity_type: '',
          entity_table_configuration: [],
        };
        this.entity_table_configuration = [];
        this.configureSettings = false;
        this.entityTables = [];
      },
      doneTitleConfigure() {
        if (this.entity_table_configuration) {
          this.configureTitles.entity_table_configuration = this.entity_table_configuration;
        }
        this.formBuilder.steps[this.selectedStepIndex].settings = {
          ...this.configureTitles,
        };
        this.configureTitles = {
          sender_title: '',
          receiver_title: '',
          isLoginEntity: false,
          applyRelationship: false,
          linkedToUserTemplate: false,
          is_repeatable: false,
          max_records: 3,
          min_records: 1,
          linked_field: '',
          linked_min_field: '',
          contact_entity: '',
          contact_entity_name: '',
          contact_entity_type: '',
          entity_table_configuration: [],
        };
        this.selectedStepIndex = -1;
        this.configureStepTitlesVisible = false;
        this.configureSettings = false;
        this.entityTables = [];
        this.entity_table_configuration = [];
      },
      async updateStepData(step, index) {
        this.seletedStepData = { ...{}, ...JSON.parse(JSON.stringify(step)) };
        this.selectedStepIndex = index;
        this.configureSettings = true;
        this.entityTables = [];
        this.configureTitles = {
          sender_title: '',
          receiver_title: '',
          isLoginEntity: false,
          applyRelationship: false,
          linkedToUserTemplate: false,
          is_repeatable: false,
          max_records: 3,
          min_records: 1,
          linked_field: '',
          linked_min_field: '',
          selectedTemplates: [],
          contact_entity: '',
          contact_entity_name: '',
          contact_entity_type: '',
          entity_table_configuration: [],
        };
        if (this.seletedStepData?.type == 'TEMPLATE') {
          let selectedTemplate = this.allTemplatesData.find(
            (e) => e._id == this.seletedStepData.template
          );
          let fields = this.getFieldsFromTemplate([selectedTemplate]);
          if (fields && fields.length) {
            this.entityTables = fields.filter(
              (e) => e.input_type == 'ENTITY_TABLE' && e.child_table_type == 'interactive'
            );
          }
        }
        if (this.seletedStepData.type == 'ENTITY') {
          this.entityTemplates = [];
          this.entityTemplates = this.getEntityTemplates(this.seletedStepData.entity);
        }
        if (step.settings) {
          let data = { ...step.settings };
          if (data.isLoginEntity && data.selectedTemplates && data.selectedTemplates.length) {
            let entityTemplates = this.entityTemplates.flatMap((e) => e._id);
            data.selectedTemplates = data.selectedTemplates.filter(
              (dt) => entityTemplates.indexOf(dt) !== -1
            );
          }
          this.configureTitles = JSON.parse(JSON.stringify(data));
          this.entity_table_configuration =
            JSON.parse(JSON.stringify(data)).entity_table_configuration || [];
        }
      },
      backToStepOne() {
        if (this.activeStep == 1 || this.activeStep == 2) {
          this.activeStep = 0;
        }
      },
      backToStepTwo() {
        if (
          ((this.activeStep == 2 || this.activeStep == 0) &&
            this.formBuilder.name &&
            this.formBuilder.form_builders_owner &&
            this.formBuilder.form_builders_owner == 'ENTITY' &&
            this.formBuilder.entity_id) ||
          (this.formBuilder.form_builders_owner == 'USER' && this.formBuilder.user_type)
        ) {
          this.activeStep = 1;
        }
      },
      backToStepThree() {
        if (this.activeStep == 1) {
          if (!this.formBuilder.steps || !this.formBuilder.steps.length) {
            this.$message.warning(`Please add at least one form template or entity.`);
            return;
          }
        }
        if (
          (this.activeStep == 1 || this.activeStep == 0) &&
          this.formBuilder.name &&
          this.formBuilder.form_builders_owner &&
          this.formBuilder.steps &&
          this.formBuilder.steps.length
        ) {
          this.activeStep = 2;
          this.allFormbuilderFields = this.getAllFormbuilderFields([
            'SINGLE_LINE_TEXT',
            'PHONE_COUNTRY_CODE',
            'ENTITY',
            'DATE',
            'DATE_TIME',
            'DATE_TIME_RANGE',
            'TIME',
            'TIME_RANGE',
            'FILE',
            'MULTI_SELECT',
            'SELECT',
            'NUMBER',
            'CURRENCY',
            'CHECKBOX',
            'FORMULA',
            'LIST',
            'AGGREGATE_FUNCTION',
            'AUTO_INCREMENT_NUMBER',
            'RANDOM_TEXT',
            'WEEKDAYS',
            'STAR_RATING',
            'CONCATENATE',
            'DATE_RANGE',
          ]);
        }
      },
      uploadLogo() {
        if (!this.files) {
          this.$message.error('Please select a file.');
          return;
        }

        const maxSizeInBytes = 5 * 1024 * 1024;
        if (this.files.size > maxSizeInBytes) {
          this.$message.error('File size should be less than 5MB.');
          return;
        }

        let reader = new FileReader();
        let that = this;
        reader.onloadend = function () {
          that.formBuilder.logo = reader.result;
        };
        if (this.files instanceof Blob) {
          reader.readAsDataURL(this.files);
        } else {
          this.$message.error('Invalid file.');
          return;
        }
        this.logoUploadModal = false;
      },
      openLogoModal() {
        this.logoUploadModal = true;
      },
      closeLogoModal() {
        this.logoUploadModal = false;
      },
      closeIconModel() {
        this.iconPickerdialogVisible = false;
      },
      getIconPath(icon) {
        this.formbuilderIconPath = icon;
        this.iconPickerdialogVisible = false;
      },
      assetAlreadySeleted(asset) {
        if (asset.value != 'COMPANY_DOCUMENTS' && asset.value != 'RELATIONAL_DATA') {
          return this.formBuilder.steps.findIndex((x) => x.type == asset.value) > -1;
        }
        return false;
      },
      entityAlreadySelected(entity) {
        return (
          this.formBuilder.steps.findIndex((x) => x.type === 'ENTITY' && x.entity == entity._id) >
          -1
        );
      },
      searchTemplates() {
        if (this.templateSearchString.length > 0) {
          const regex = new RegExp(this.templateSearchString, 'i');
          const matchedTemplates = (this.allTemplatesData || []).filter(({ name }) =>
            name.match(regex)
          );
          this.templatesData = [...[], ...matchedTemplates];
        } else {
          this.templatesData = [...[], ...(this.allTemplatesData || [])];
        }
      },
      searchEntities() {
        if (this.entitySearchString.length > 0) {
          const regex = new RegExp(this.entitySearchString, 'i');
          const matchedTemplates = (this.allEntitiesData || []).filter(
            ({ name, type }) => name.match(regex) && type !== 'STANDARD'
          );
          this.entitiesData = [...[], ...matchedTemplates];
        } else {
          this.entitiesData = [...[], ...(this.allEntitiesData || [])];
        }
      },
      clickEntity(entity, type) {
        if (this.entityAlreadySelected(entity)) {
          return;
        }
        this.formBuilder.steps.push({
          entity: entity._id,
          type,
          slug: 'entity_' + (entity.slug ? entity.slug : makeSlug(entity.name)),
          settings: {
            ...this.configureTitles,
            ...{
              selectedTemplates: this.getEntityTemplates(entity._id).flatMap((e) => e._id),
              applyRelationship:
                this.formBuilder.form_builders_owner == 'ENTITY' &&
                this.checkRelationship(entity._id)
                  ? true
                  : false,
              isLoginEntity:
                this.formBuilder.form_builders_owner == 'ENTITY' &&
                entity._id == this.formBuilder.entity_id
                  ? true
                  : false,
            },
          },
        });
      },
      //getting entity templates by entity id
      getEntityTemplates(id) {
        let result = [];
        if (id) {
          let stepEntity = (this.allEntitiesData || []).find((e) => e._id == id);
          if (stepEntity?.templates) {
            stepEntity.templates.forEach((tpl) => {
              let fullTemplate = (this.allTemplatesData || []).find(
                (te) => te._id == tpl.template_id
              );
              if (fullTemplate) {
                result.push({
                  ...fullTemplate,
                  customization: tpl.customization || {},
                });
              }
            });
          }
        }
        return result;
      },
      clickTemplate(template, type) {
        if (this.templateAlreadySeleted(template)) {
          return;
        }
        let obj = {
          contact_entity: '',
          contact_entity_name: '',
          contact_entity_type: '',
        };
        let standardEntity = (this.allEntitiesData || []).find((e) => e.type == 'STANDARD');
        obj.contact_entity =
          this.formBuilder.form_builders_owner == 'ENTITY' && this.formBuilder.entity_id
            ? this.formBuilder.entity_id
            : standardEntity?._id
              ? standardEntity._id
              : '';
        if (obj.contact_entity) {
          let selectedEntityData = (this.allEntitiesData || []).find(
            (e) => e._id == obj.contact_entity
          );
          obj.contact_entity_name = selectedEntityData.name;
          obj.contact_entity_type = selectedEntityData.entity_type;
        }
        if (type === 'TEMPLATE' && template.type == 'STANDARD') {
          let receiverEntity = this.allEntitiesData.find((entity) => entity.name === 'Receiver');
          if (receiverEntity) {
            obj.contact_entity = receiverEntity._id;
            obj.contact_entity_name = receiverEntity.name;
            obj.contact_entity_type = receiverEntity.entity_type;
          }
        } else {
          obj.contact_entity = this.allEntitiesData[0]._id;
          obj.contact_entity_name = this.allEntitiesData[0].name;
          obj.contact_entity_type = this.allEntitiesData[0].entity_type;
        }
        this.formBuilder.steps.push({
          template: template._id,
          type,
          slug: template.slug,
          standard_template: template.type == 'STANDARD' ? true : false,
          settings: {
            is_repeatable: template.type == 'STANDARD' ? true : false,
            max_records: 3,
            min_records: 1,
            ...obj,
          },
        });
        this.currentTemplate = null;
      },
      templateAlreadySeleted(template) {
        return (
          this.formBuilder.steps.findIndex(
            (x) =>
              (x.type === 'TEMPLATE' && x.template == template._id) ||
              (x.type === 'RELATIONAL_DATA' && x.relational_data.template == template._id)
          ) > -1
        );
      },
      onChangeFormBuilderStep(action) {
        this.checkMailRecievers();
        if (this.activeStep == 1) {
          if (!this.formBuilder.steps || !this.formBuilder.steps.length) {
            this.$message.warning(`Please add at least one form template or entity.`);
            return;
          }
        }
        if (this.activeStep == 2 && this.formBuilder.approval_configuration_type == 'STANDARD') {
          let check = this.checkApprovalUsers();
          if (check) {
            return;
          }
        }
        if (action == 'Form Builder Details') {
          this.activeStep = 0;
        }

        if (action == 'Build Form Builder' && this.formBuilder.name) {
          this.activeStep = 1;
        }
        if (action == 'Form Builder Settings') {
          this.activeStep = 2;
          this.allFormbuilderFields = this.getAllFormbuilderFields([
            'SINGLE_LINE_TEXT',
            'PHONE_COUNTRY_CODE',
            'ENTITY',
            'DATE',
            'DATE_TIME',
            'DATE_TIME_RANGE',
            'TIME',
            'TIME_RANGE',
            'FILE',
            'MULTI_SELECT',
            'SELECT',
            'NUMBER',
            'CURRENCY',
            'CHECKBOX',
            'FORMULA',
            'LIST',
            'AGGREGATE_FUNCTION',
            'AUTO_INCREMENT_NUMBER',
            'RANDOM_TEXT',
            'WEEKDAYS',
            'STAR_RATING',
            'CONCATENATE',
            'DATE_RANGE',
          ]);
        }
      },
      checkApprovalUsers() {
        if (this.formBuilder?.is_approval_form) {
          if (!this.formBuilder.approval_users.length || !this.formBuilder.approval_users) {
            this.$message.warning(`Please add at least one approver.`);
            return true;
          }
          let ignoreFilterApprovers = this.formBuilder.approval_users.filter(
            (e) => !e.selected_entity_filter && e.filters_data && !e.filters_data.filters?.length
          );
          let notConfigeredUser = ignoreFilterApprovers.findIndex((e) => {
            if (!e.user_type) {
              return true;
            }
            if (e.user_type == 'APPLICATION') {
              return (
                !e.application_user_type ||
                (!e.relational_user && !e.preferred_application_users.length)
              );
            } else if (e.user_type == 'COMPANY') {
              return !e.company_user_type || !e.preferred_company_users.length;
            } else if (e.user_type == 'LINKEDFIELD') {
              return !e.approval_linked_field;
            }
          });
          if (notConfigeredUser !== -1) {
            this.$message.warning(`Please configure ${notConfigeredUser + 1} user`);
            return true;
          }
        }
        return false;
      },
      async fetchFormBuilderData() {
        await this.$store.dispatch('formBuilders/fetchFormBuilder', {
          id: this.formBuilderId,
          include_document_details: true,
        });
        if (this.getFormBuilder) {
          let data = JSON.parse(JSON.stringify(this.getFormBuilder));
          this.form_builder = data;
          this.formBuilder.name = data.name;
          this.originalFormBuilderName = data.name;
          this.formBuilder.description = data.description;
          this.formBuilder.steps = data.steps;
          this.formBuilder.user_type = data.user_type;
          this.formBuilder.form_builders_owner = data.form_builders_owner;
          this.formBuilder.form_builder_filter = data.form_builder_filter;
          this.formBuilder.is_approval_form = data.is_approval_form;
          this.formBuilder.enforce_order = data.enforce_order;
          this.formBuilder.priority_based = data.priority_based;
          this.formBuilder.approval_configuration_type = data.approval_configuration_type;
          this.formBuilder.advanced_approval_users = data.advanced_approval_users;
          this.formBuilder.approval_data_actions_type = data.approval_data_actions_type;
          this.formBuilder.conditional_approval_data_actions =
            data.conditional_approval_data_actions;
          this.formBuilder.entity_id = data.entity_id;
          this.formBuilder.logo = data.logo;
          this.formBuilder.approval_users = data.approval_users;
          this.formBuilder.approval_child_entity_tables = data.approval_child_entity_tables;
          this.formBuilder.approval_redirection = data.approval_redirection
            ? data.approval_redirection
            : '';
          this.formBuilder.approval_redirection_filter = data.approval_redirection_filter
            ? data.approval_redirection_filter
            : {
                filters: [],
                filter_name: '',
                entity_id: '',
                isSaveFilter: false,
                columns_settings: [],
                quick_filters: [],
              };
          this.formBuilder.approval_receiver_permissions.view = data?.approval_receiver_permissions
            ?.view
            ? data.approval_receiver_permissions.view
            : true;
          this.formBuilder.approval_receiver_permissions.edit = data?.approval_receiver_permissions
            ?.edit
            ? data.approval_receiver_permissions.edit
            : false;
          this.formBuilder.approval_receiver_permissions.delete = data
            ?.approval_receiver_permissions?.delete
            ? data.approval_receiver_permissions.edit
            : false;
          this.formBuilder.rejection_receiver_permissions.view = data
            ?.rejection_receiver_permissions?.view
            ? data.rejection_receiver_permissions.view
            : true;
          this.formBuilder.rejection_receiver_permissions.edit = data
            ?.rejection_receiver_permissions?.edit
            ? data.rejection_receiver_permissions.edit
            : false;
          this.formBuilder.rejection_receiver_permissions.delete = data
            ?.rejection_receiver_permissions?.delete
            ? data.rejection_receiver_permissions.edit
            : false;

          this.formBuilder.global_date_format = this.getDefaultDateFormat;
          this.formBuilder.allow_revoke_approval = data.allow_revoke_approval;
          this.formBuilder.allow_export_as_excel = data.allow_export_as_excel;
          this.formBuilder.allow_export_as_pdf = data.allow_export_as_pdf;
          this.formBuilder.allow_revoke_for_approved = data.allow_revoke_for_approved;
          this.formBuilder.allow_revoke_for_rejected = data.allow_revoke_for_rejected;
          this.formBuilder.allow_revoke_for_both = data.allow_revoke_for_both;
          this.formBuilder.allow_revoke_for_approved_for_filler =
            data.allow_revoke_for_approved_for_filler;
          this.formBuilder.allow_revoke_for_rejected_for_filler =
            data.allow_revoke_for_rejected_for_filler;
          this.formBuilder.allow_revoke_for_both_for_filler = data.allow_revoke_for_both_for_filler;
          this.formBuilder.show_revoke_reason_dialog = data.show_revoke_reason_dialog;
          this.formBuilder.show_approval_reason_dialog = data.show_approval_reason_dialog;
          this.formBuilder.show_approval_rating = data.show_approval_rating;
          this.formBuilder.allow_edit_for_approver = data.allow_edit_for_approver;
          this.formBuilder.allow_field_level_permissions = data.allow_field_level_permissions;
          this.formBuilder.approve_all_user = data.approve_all_user;
          this.formBuilder.contact_email = data.contact_email;
          this.formBuilder.primary_fields = data.primary_fields || [];
          this.formBuilder.approval_child_entity_tables = data.approval_child_entity_tables || [];
          if (data.receiver_mail_template)
            this.formBuilder.receiver_mail_template = data.receiver_mail_template;
          if (data.rework_user_mail_template)
            this.formBuilder.rework_user_mail_template = data.rework_user_mail_template;
          this.formBuilder.allow_rework_on_form = data.allow_rework_on_form;
          if (data.approval_mail_template)
            this.formBuilder.approval_mail_template = data.approval_mail_template;
          if (data.approval_update_receivers) {
            this.formBuilder.approval_update_receivers = data.approval_update_receivers;
          }
          if (data.approval_data_actions) {
            this.formBuilder.approval_data_actions = data.approval_data_actions;
          }
          if (data.reject_data_actions) {
            this.formBuilder.reject_data_actions = data.reject_data_actions;
          }
          if (data.revoke_approval_data_actions) {
            this.formBuilder.revoke_approval_data_actions = data.revoke_approval_data_actions;
          }
          if (data.receiver_approval_update_mail_template) {
            this.formBuilder.receiver_approval_update_mail_template =
              data.receiver_approval_update_mail_template;
            if (data.receiver_approval_update_mail_template?.cc_user_type) {
              this.checkApprovalUpdateMailCC = true;
            }
            if (data.receiver_approval_update_mail_template?.bcc_user_type) {
              this.checkApprovalUpdateMailBCC = true;
            }
          }
          if (data.receiver_rejection_update_mail_template) {
            this.formBuilder.receiver_rejection_update_mail_template =
              data.receiver_rejection_update_mail_template;
          }
          this.formBuilder.approval_data_actions.forEach((action, index) => {
            this.$set(this.approvalActionsMapObject, index, {
              [action.field_key]: action.value,
            });
          });
          this.formBuilder.reject_data_actions.forEach((action, index) => {
            this.$set(this.rejectActionsMapObject, index, {
              [action.field_key]: action.value,
            });
          });
          this.formBuilder?.revoke_approval_data_actions?.forEach((action, index) => {
            this.$set(this.revokeActionsMapObject, index, {
              [action.field_key]: action.value,
            });
          });
          if (data.customization) {
            this.formBuilder.customization = data.customization;
          }
          if (data.expiration_settings) {
            this.formBuilder.expiration_settings = data.expiration_settings;
          }
          if (data.field_level_permissions) {
            this.formBuilder.field_level_permissions = data.field_level_permissions;
          }
          let form_builder_owners = data.form_builder_owners;
          this.formBuilder.form_builder_owners = data.form_builder_owners.length
            ? data.form_builder_owners
            : [data.created_by];
          this.formBuilder.settings = {
            ...this.formBuilder.settings,
            ...data.settings,
            formbuilder_date_range: [
              data.settings.formbuilder_start_time,
              data.settings.formbuilder_end_time,
            ],
          };
          this.formBuilder.settings.success_and_redirect_page.mail_recievers =
            form_builder_owners.length
              ? data.settings.success_and_redirect_page.mail_recievers
              : [data.created_by];
          this.formBuilder.settings.schedules.entity_id = data.entity_id;
          this.formBuilder.groups = data.groups;
          this.formbuilderIconPath =
            data.icon && data.icon_type == 'DEFAULT' ? data.icon : 'block-portfolio.svg';

          this.iconType = data.icon_type || 'DEFAULT';
          if (this.formBuilder.form_builders_owner == 'ENTITY' && this.formBuilder.entity_id) {
            this.formBuilder.settings.allowed_entity_users = (
              data.settings.allowed_entity_users || []
            )
              .filter((e) => e.email && e.contact_id)
              .map((user) => {
                return user.contact_id + '#' + user.email;
              });
            this.fetchEntityData(this.formBuilder.entity_id);
          }
          if (!data?.settings?.is_time_bond && !data?.settings?.formbuilder_date_range) {
            this.formBuilder.settings.formbuilder_date_range = [new Date(), new Date()];
          }
          if (data.allow_field_level_permissions) {
            this.allFormBuilderOriginalFields = await this.getAllFormBuilderFieldsOriginal(
              this.types
            );
          }
          this.allFormbuilderFields = this.getAllFormbuilderFields([
            'SINGLE_LINE_TEXT',
            'PHONE_COUNTRY_CODE',
            'ENTITY',
            'DATE',
            'DATE_TIME',
            'DATE_TIME_RANGE',
            'TIME',
            'TIME_RANGE',
            'FILE',
            'MULTI_SELECT',
            'SELECT',
            'NUMBER',
            'CURRENCY',
            'CHECKBOX',
            'FORMULA',
            'LIST',
            'AGGREGATE_FUNCTION',
            'AUTO_INCREMENT_NUMBER',
            'RANDOM_TEXT',
            'WEEKDAYS',
            'STAR_RATING',
            'CONCATENATE',
            'DATE_RANGE',
          ]);
          if (this.formBuilder.approval_redirection) {
            this.setRedirectEntityFields(this.formBuilder.approval_redirection);
          }
          if (this.formBuilder.is_approval_form) {
            let allBusinessGroups = this.formBuilder.approval_users.filter(
              (user) =>
                user.business_account_type == 'GROUP' && user.application_user_business_account_id
            );
            let contact_types = allBusinessGroups.map((e) => e.application_user_type);
            if (contact_types?.length) {
              this.getBusinessAccountNames(contact_types);
            }
          }
        }
        if (this.formBuilder?.approval_users?.length) {
          let filterApprovers = this.formBuilder.approval_users.filter(
            (e) =>
              e?.user_type == 'APPLICATION' &&
              e?.application_user_type &&
              e.individual_entity_resource == 'FILTER' &&
              e?.selected_entity_filter
          );
          if (filterApprovers?.length) {
            filterApprovers.forEach(async (f) => {
              await this.getFiltersByEntityId(f.application_user_type);
            });
          }
        }
      },
      async fetchEntityData(entity_id) {
        let [fetchedEntityRelationships, contacts] = await Promise.all([
          fetchEntityRelationships({
            entity_id: entity_id,
          }),
          postAPICall('GET', '/contacts', {
            get_all: true,
            contact_type: entity_id,
            type: 'CONTACT',
          }),
          this.$store.dispatch('entities/fetchEntityById', {
            entity_id: entity_id,
          }),
          this.$store.dispatch('filters/fetchAllEntityFilters', {
            entityId: entity_id,
          }),
        ]);
        if (this.getAllEntityFilters) {
          this.entityFilters = this.getAllEntityFilters;
        }
        this.relationshipsData = [];
        this.entityTemplates = [];
        this.entityUsers = [];
        if (fetchedEntityRelationships) {
          this.relationshipsData = [...(fetchedEntityRelationships || [])];
        }
        this.currentEntity = null;
        if (this.getEntityDataById) {
          this.currentEntity = { ...{}, ...this.getEntityDataById };
          this.currentEntity.templates.forEach((temp) => {
            this.entityTemplates.push(temp.templateInfo);
          });
        }
        this.getAllContacts = contacts;
        if (this.getAllContacts?.data) {
          this.entityUsers = this.getAllContacts.data;
        }
      },
      setStandardUser(value) {
        this.setFormbuilderData();
        (this.formBuilder.steps || []).map((step) => {
          if (
            step?.standard_template &&
            step?.settings?.contact_entity !== value &&
            step?.settings?.contact_entity_type == 'BUSINESS'
          ) {
            let receiverEntity = this.allEntitiesData.find((entity) => entity.name === 'Receiver');
            let obj = step.settings;
            if (receiverEntity) {
              obj.contact_entity = receiverEntity._id;
              obj.contact_entity_name = receiverEntity.name;
              obj.contact_entity_type = receiverEntity.entity_type;
            }
            step.settings = { ...obj };
          }
          return step;
        });
      },
      setSettingsEntity(value) {
        this.formBuilder.settings.schedules.entity_id = value;
        this.setStandardUser(value);
        if (value) {
          this.fetchEntityData(value);
        }
      },
      async fetchFormBuilderRemindersSettings() {
        await this.$store.dispatch('formBuilders/fetchFormBuilderRemindersSettings', {
          id: this.formBuilderId,
        });

        if (this.getFormBuilderRemindersSettings && this.getFormBuilderRemindersSettings.type) {
          this.formBuilder.settings.reminder_settings = {
            ...this.getFormBuilderRemindersSettings,
          };
        } else {
          this.formBuilder.settings.reminder_settings = {
            type: 'WORKFLOW',
            workflow_details_id: '',
            reminder_start_time: '',
            reminder_end_time: '',
            reminder_interval_type: '',
            reminder_interval_value: 0,
            status: false,
          };
        }
      },
      // if the approver is deleted, then remove the approver mail
      removeApprovalUsers() {
        let aMails = this.allContacts.map((e) => e.email);
        let cMails = this.company_users.map((e) => e._id);
        this.formBuilder.approval_users = (this.formBuilder.approval_users || []).map((user) => {
          if (user?.preferred_company_users) {
            user.preferred_company_users = user.preferred_company_users.filter((e) =>
              cMails.includes(e)
            );
          } else if (user?.preferred_application_users) {
            user.preferred_application_users = user.preferred_application_users.filter((e) =>
              aMails.includes(e)
            );
          }
          return user;
        });
      },
      async getNecessaryInfo() {
        this.loading = true;
        if (this.$route.params.form_builder_id) {
          this.formBuilderId = this.$route.params.form_builder_id;
          this.formbuilderAllFilters = await fetchAllFormbuilderFiltersById({
            formbuilderId: this.formBuilderId,
          });
          this.action = 'Update';
          await this.fetchFormBuilderData();
          await this.fetchFormBuilderRemindersSettings();
        }
        await Promise.all([
          this.fetchAllDependentData(),
          this.$store.dispatch('contactTypes/fetchAllContactTypes', {
            get_all: true,
            type: 'CONTACT_TYPE',
          }),
          this.fetchContacts(),
          this.getCompanyUsersList(),
        ]);
        if (this.getformbuildertemplateDatawithAi != null) {
          this.formBuilder = {
            ...this.formBuilders,
            ...this.getformbuildertemplateDatawithAi,
          };
          this.activeStep = 1;
          this.$store.commit('formBuilders/setformbuildertemplateDatawithAi', null, { root: true });
          if (this.$route.query.templateId) {
            let temp = this.allTemplatesData.find((t) => t._id == this.$route.query.templateId);
            this.clickTemplate(temp, 'TEMPLATE');
          }
        }
        this.removeApprovalUsers();

        this.formBuilder.global_date_format = this.getDefaultDateFormat;
        this.loading = false;
      },
      async fetchAllDependentData() {
        this.loading = true;
        [this.allEntitiesData, this.allTemplatesData, this.allFormbuilders] = await Promise.all([
          this.fetchAllEntities(),
          this.fetchAllTemplates(),
          this.fetchAllFormbuilders(),
        ]);
        this.templatesData = [...this.allTemplatesData];
        this.entitiesData = [...this.allEntitiesData];
      },
      backToAllFormBuilders() {
        this.$router.push({ path: '/formBuilders', query: this.$route.query });
      },
      disableSaveAndNextButton() {
        return (
          !this.formBuilder.name ||
          !this.formBuilder.contact_email ||
          !this.formBuilder.form_builders_owner ||
          (this.formBuilder.form_builders_owner == 'ENTITY' && !this.formBuilder.entity_id) ||
          (this.formBuilder.form_builders_owner == 'USER' && !this.formBuilder.user_type) ||
          !this.formBuilder.form_builder_owners.length
        );
      },
      async validateUniqueName() {
        try {
          let params = {
            companyId: this.getAuthenticatedUser.current_workspace.company_id,
            formbuilderName: this.formBuilder.name,
          };
          const data = await postAPICall('GET', '/form-builder/validate-name', params);
          return data?.isUnique;
        } catch (error) {
          return false;
        }
      },
      async goToNextStep() {
        await this.checkMailRecievers();
        this.setStandardUser(this.formBuilder.entity_id);
        const isNameChanged = this.formBuilder.name !== this.originalFormBuilderName;
        const isUnique = await this.validateUniqueName();
        if (isNameChanged && !isUnique) {
          this.$message.error('Form Builder name already exists. Please use a different name.');
          return;
        }
        if (this.activeStep == 2) {
          try {
            await this.saveFormBuilder();
          } catch (err) {
            console.log('goToNextStep', err);
          }
        } else if (this.activeStep == 1) {
          if (!this.formBuilder.steps || !this.formBuilder.steps.length) {
            this.$message.warning(`Please add at least one form template or entity.`);
            return;
          }
          this.formBuilderEditStep = 'Form Builder Settings';
          this.activeStep++;
        } else {
          this.formBuilderEditStep = 'Build Form Builder';
          this.activeStep++;
        }
        this.onChangeFormBuilderStep(this.formBuilderEditStep);
      },
      checkMailTemplate(body) {
        let valid = true;
        const leftBracesCount = body.split('[[').length - 1;
        const rightBracesCount = body.split(']]').length - 1;
        if (leftBracesCount < rightBracesCount) {
          this.$message.warning('Please remove unwanted ]]');
          valid = false;
        } else if (leftBracesCount > rightBracesCount) {
          this.$message.warning('Please remove unwanted [[');
          valid = false;
        }
        const regex = /\[\[\s*]]/g;
        if (regex.test(body)) {
          this.$message.warning('There should be field inside [[ ]]');
          valid = false;
        }
        // Check for [[ before ]]
        if (/\[\[[^\]]*\[\[/.test(body)) {
          this.$message.warning('No [[ allowed inside double brackets');
          valid = false;
        }
        return valid;
      },
      validateMailTemplate() {
        let valid = true;
        if (this.formBuilder?.is_approval_form) {
          if (this.formBuilder?.approval_mail_template?.body) {
            valid = this.checkMailTemplate(this.formBuilder.approval_mail_template.body);
          }
        }
        if (this.formBuilder?.approval_users && this.formBuilder.approval_users.length) {
          let ignoreFilterApprovers = this.formBuilder.approval_users.filter(
            (e) => !e.selected_entity_filter && e.filters_data && !e.filters_data.filters?.length
          );
          let emptyUser = (ignoreFilterApprovers || []).findIndex((user) => {
            if (!user.user_type) {
              return true;
            }
            if (user.user_type == 'COMPANY') {
              if (
                !user.company_user_type ||
                !user.preferred_company_users ||
                !user.preferred_company_users.length
              ) {
                return true;
              }
            } else if (user.user_type == 'APPLICATION') {
              if (!user.application_user_type) {
                return true;
              }
              if (
                !user?.relational_user &&
                (!user.preferred_application_users || !user.preferred_application_users.length)
              ) {
                return true;
              }
            } else {
              if (!user.approval_linked_field) {
                return true;
              }
            }
          });
          if (
            this.formBuilder?.is_approval_form &&
            emptyUser > -1 &&
            this.formBuilder.approval_configuration_type == 'STANDARD'
          ) {
            this.$message.warning('Please config ' + (emptyUser + 1) + ' approver');
            valid = false;
          }
        } else {
          if (
            this.formBuilder?.is_approval_form &&
            this.formBuilder.approval_configuration_type == 'STANDARD'
          ) {
            this.$message.warning('Please add atleast one approver');
            valid = false;
          }
        }
        if (this.formBuilder?.receiver_mail_template?.body && valid) {
          valid = this.checkMailTemplate(this.formBuilder.receiver_mail_template.body);
        }
        return valid;
      },
      async saveFormBuilder() {
        try {
          let valid = this.validateMailTemplate();
          if (this.formBuilder?.settings?.is_time_bond) {
            if (!this.formBuilder?.settings?.formbuilder_date_range) {
              this.$message.error('Please select date range');
              return;
            }
          }
          if (!valid) {
            return;
          }
          this.loading = true;
          const payload = this.prepareFormBuilderData();
          if (this.formBuilderId) {
            await this.updateFormBuilder(payload);
          } else {
            await this.addFormBuilder(payload);
          }
          this.loading = false;
        } catch (err) {
          this.$message.error(
            `Error at ${this.formBuilderId ? 'Updating' : 'creating'} form builder`
          );
        }
      },
      async updatePreferredApplicationUsers(user) {
        //fetching contacts of the business account
        let params = {
          contactType: user.application_user_type,
          accountName: user.application_user_business_account_id,
          limit: 10,
          page: 1,
        };
        const response = await postAPICall(
          'GET',
          `/contacts/${params.contactType}/${params.accountName}/list`,
          params
        );
        let contacts = response?.data || [];
        user.preferred_application_users = contacts?.map((c) => c.email);
      },
      async updateReminderSettings() {
        await this.$store.dispatch('formBuilders/updateWorkFlowRemindersSettings', {
          id: this.formBuilderId,
          ...this.formBuilder.settings.reminder_settings,
        });
      },
      removeExistedField(index) {
        let currentStep = this.formBuilder.steps[index];
        if (currentStep && currentStep.type == 'TEMPLATE') {
          let isInvolved = this.formBuilder.steps.find(
            (e) =>
              e?.settings?.is_repeatable &&
              ((e?.settings?.linked_field &&
                e.settings.linked_field.includes('#') &&
                e.settings.linked_field.split('#')[1] == currentStep.template) ||
                (e?.settings?.linked_min_field &&
                  e.settings.linked_min_field.includes('#') &&
                  e.settings.linked_min_field.split('#')[1] == currentStep.template))
          );
          if (isInvolved) {
            this.$message({
              message: "This template is associated with other templates. Can't delete.",
              type: 'warning',
            });
          } else {
            this.formBuilder.steps.splice(index, 1);
          }
        } else {
          this.formBuilder.steps.splice(index, 1);
        }
      },
      setFormbuilderData() {
        if (
          this.formBuilder.form_builders_owner == 'COMPANY' ||
          this.formBuilder?.form_builders_owner == 'ANONYMOUS'
        ) {
          this.formBuilder.user_type = undefined;
          this.formBuilder.entity_id = undefined;
        } else if (this.formBuilder.form_builders_owner == 'ENTITY') {
          this.formBuilder.user_type = undefined;
        } else if (this.formBuilder.form_builders_owner == 'USER') {
          this.formBuilder.entity_id = undefined;
        }
      },
      prepareFormBuilderData() {
        this.formBuilder.name = this.formBuilder.name.replaceAll('/', '_');
        this.formBuilder.code = getCodeByName(this.formBuilder.name);
        this.formBuilder.icon = this.formbuilderIconPath;
        this.formBuilder.icon_type = this.iconType;
        this.updateApprovalActionsObject();
        this.updateRejectActionsObject();
        if (this.formBuilder.allow_revoke_approval) {
          this.updateRevokeActionsObject();
        }

        this.formBuilder.steps.map((step, index) => {
          if (step.type == 'COMPANY_DOCUMENTS') {
            if (step.company_documents && step.company_documents.custom) {
              step.company_documents.custom = step.company_documents.custom.map((e) => e._id);
            }
            if (step.company_documents && step.company_documents.static) {
              step.company_documents.static = step.company_documents.static.map((e) => e._id);
            }
            if (step.company_documents && step.company_documents.requested) {
              step.company_documents.requested = step.company_documents.requested.map((e) => e._id);
            }
          }
          if (this.formBuilder.form_builders_owner !== 'ENTITY' && step.type == 'ENTITY') {
            step.isLoginEntity = false;
            step.applyRelationship = false;
          }
          if (
            this.formBuilder.form_builders_owner == 'ENTITY' &&
            this.formBuilder.entity_id &&
            step.entity != this.formBuilder.entity_id &&
            step.isLoginEntity
          ) {
            step.isLoginEntity = false;
          }
          step.order = index + 1;
        });

        if (this.formBuilderId) {
          this.formBuilder._id = this.formBuilderId;
        }
        this.setFormbuilderData();
        if (this.formBuilder.form_builder_filter == '') {
          delete this.formBuilder.form_builder_filter;
        }
        if (this.formBuilder?.settings?.allowed_entity_users.length) {
          this.formBuilder.settings.allowed_entity_users =
            this.formBuilder.settings.allowed_entity_users
              .filter((e) => e.includes('#'))
              .map((el) => {
                return {
                  email: el.split('#')[1],
                  contact_id: el.split('#')[0],
                };
              });
        }
        if (this.formBuilder.settings.reminder_settings) {
          this.formBuilder.reminder_time_interval_type =
            this.formBuilder.settings.reminder_settings.reminder_interval_type;
          this.formBuilder.reminder_time_interval_value =
            this.formBuilder.settings.reminder_settings.reminder_interval_value;
          this.formBuilder.reminder_status = this.formBuilder.settings.reminder_settings.status;
          this.formBuilder.reminder_start_time =
            this.formBuilder.settings.reminder_settings.start_time;
          this.formBuilder.reminder_end_time = this.formBuilder.settings.reminder_settings.end_time;
        }
        if (this.formBuilder?.settings?.success_and_redirect_page?.thankyou_page) {
          this.formBuilder.settings.success_and_redirect_page.thankyou_page =
            this.mapMailTemplatevariables(
              this.formBuilder.settings.success_and_redirect_page.thankyou_page
            );
        }
        if (this.formBuilder?.receiver_mail_template?.body) {
          this.formBuilder.receiver_mail_template.body = this.mapMailTemplatevariables(
            this.formBuilder.receiver_mail_template.body
          );
        }
        if (this.formBuilder?.rework_user_mail_template?.body) {
          this.formBuilder.rework_user_mail_template.body = this.mapMailTemplatevariables(
            this.formBuilder.rework_user_mail_template.body
          );
        }
        if (!this.formBuilder?.customization?.add_button_size) {
          this.formBuilder.customization.add_button_size = 'small';
        }
        if (!this.formBuilder?.customization?.finish_button_size) {
          this.formBuilder.customization.finish_button_size = 'small';
        }
        if (!this.formBuilder?.customization?.default_font_type) {
          this.formBuilder.customization.default_font_type = fonts?.fontTypes?.[0]?.value || '';
        }
        if (this.formBuilder?.is_approval_form) {
          if (this.formBuilder?.approval_mail_template?.body) {
            this.formBuilder.approval_mail_template.body = this.mapMailTemplatevariables(
              this.formBuilder.approval_mail_template.body
            );
          }
          if (this.formBuilder?.approval_mail_template?.subject) {
            this.formBuilder.approval_mail_template.subject = this.mapMailTemplatevariables(
              this.formBuilder.approval_mail_template.subject
            );
          }
          if (this.formBuilder?.receiver_approval_update_mail_template?.body) {
            this.formBuilder.receiver_approval_update_mail_template.body =
              this.mapMailTemplatevariables(
                this.formBuilder.receiver_approval_update_mail_template.body
              );
          }
          if (this.formBuilder?.receiver_rejection_update_mail_template?.body) {
            this.formBuilder.receiver_rejection_update_mail_template.body =
              this.mapMailTemplatevariables(
                this.formBuilder.receiver_rejection_update_mail_template.body
              );
          }
          this.formBuilder.approval_users = this.formBuilder.approval_users.map((a, i) => {
            if (
              i == this.formBuilder.approval_users.length - 1 &&
              this.formBuilder?.priority_based
            ) {
              a.final_approver = true;
            } else {
              a.final_approver = false;
            }
            a.order = i;
            return a;
          });
        }
        return JSON.parse(JSON.stringify(this.formBuilder));
      },
      mapMailTemplatevariables(body, revert) {
        const childRegex = /\[\[(.*?)\]\]/g;
        const childVariables = [];
        let match;
        while ((match = childRegex.exec(body)) !== null) {
          childVariables.push(match[1]);
        }
        // Replace labels with their corresponding template_keys (need to change for other entities labels)
        body = body.replace(/\[\[(.*?)\]\]/g, (match, label) => {
          const template = this.allMentionableFields.find(
            (obj) => (!revert && obj.label === label) || (revert && obj.id == label)
          );
          let value = '';
          if (revert) {
            value = template?.label;
          } else {
            value = template?.template_key;
          }
          if (template?.input_type == 'PAY_BUTTON') {
            return template ? `[[${value}#pay]]` : match;
          }
          return template ? `[[${value}]]` : match;
        });
        return body;
      },
      async updateFormBuilder(payload) {
        if (this.formBuilder?.settings?.is_time_bond && payload?.settings?.formbuilder_date_range) {
          ((payload.settings.formbuilder_start_time = payload.settings.formbuilder_date_range[0]),
            (payload.settings.formbuilder_end_time = payload.settings.formbuilder_date_range[1]));
        }
        await this.$store.dispatch('formBuilders/updateFormBuilder', payload);
        if (this.getFormBuilderUpdateStatus) {
          if (this.getFormBuilderUpdateData?.data) {
            await updateFormbuilderData(this.formBuilderId, this.getFormBuilderUpdateData.data);
          }
          this.$notify.success({
            title: 'Success',
            message: 'Form Builder Updated successfully',
          });

          setTimeout(() => {
            this.backToAllFormBuilders();
          }, 100);
        } else {
          this.$notify.error({
            title: 'Error',
            message:
              this.errors && this.errors.critical_error
                ? this.errors.critical_errorder
                : 'Error while saving Form Builder',
          });
        }
      },
      async showDetailedViewOfStep(step) {
        if (step.type == 'TEMPLATE') {
          let template = this.allTemplatesData.find((t) => t._id == step.template);
          this.previewTemplateName = `Preview of ${template.name}` || 'Preview of the template';
          this.detailedTempIds = [
            {
              name: template.name,
              id: template._id,
              isEntityStep: false,
              defaultValuesForm: step?.default_values ? step.default_values : {},
            },
          ];
          this.activeTempId = template._id;
        } else if (step.type == 'ENTITY') {
          let entity = this.allEntitiesData.find((e) => e._id == step.entity);
          this.previewTemplateName = `Preview of ${entity.name}` || 'Preview of the entity';
          this.detailedTempIds = entity.templates.map((tmp) => {
            return {
              name: this.allTemplatesData.find((t) => t._id == tmp.template_id).name,
              id: tmp.template_id,
              isEntityStep: true,
              defaultValuesForm:
                step?.default_values && step.default_values[tmp?.template_id]
                  ? step.default_values[tmp.template_id]
                  : {},
            };
          });
          this.activeTempId = this.detailedTempIds[0].id;
        }
        this.showDetailedView = true;
      },
      resetTemplateData() {
        this.templateId = null;
        this.templateData = [];
        this.entityId = null;
        this.showDetailedView = false;
      },

      async addFormBuilder(payload) {
        if (this.formBuilder?.settings?.is_time_bond && payload?.settings?.formbuilder_date_range) {
          ((payload.settings.formbuilder_start_time = payload.settings.formbuilder_date_range[0]),
            (payload.settings.formbuilder_end_time = payload.settings.formbuilder_date_range[1]));
        }
        await this.$store.dispatch('formBuilders/addFormBuilder', payload);
        if (this.getFormBuilderAddStatus) {
          if (this.getFormBuilderAddData?.data) {
            await addSingleFormbuilderToLocal(this.getFormBuilderAddData.data);
          }
          this.$notify.success({
            title: 'Success',
            message: 'Form Builder Added successfully',
          });
          setTimeout(() => {
            this.backToAllFormBuilders();
          }, 100);
        } else {
          let message = this.getFormBuilderErrors
            ? this.getFormBuilderErrors.message
              ? this.getFormBuilderErrors.message
              : this.getFormBuilderErrors.errors &&
                  this.getFormBuilderErrors.errors.details &&
                  this.getFormBuilderErrors.errors.details[0] &&
                  this.getFormBuilderErrors.errors.details[0].message
                ? this.getFormBuilderErrors.errors.details[0].message
                : 'Error while saving Form Builder'
            : 'Error while saving Form Builder';
          this.$notify.error({
            title: 'Error',
            message: message,
          });
        }
      },
      async getCompanyUsersList() {
        try {
          [this.getCompanyUsers] = await Promise.all([
            postAPICall('GET', '/user/companyUsers'),
            this.$store.dispatch('auth/getUserTypeList', {
              companyId: this.getAuthenticatedUser.current_workspace.company_id,
              isMenu: true,
            }),
          ]);
          if (this.getCompanyUsers) {
            this.company_users = this.getCompanyUsers.data;
            if (!this.company_users.flatMap((e) => e._id).includes(this.getAuthenticatedUser._id)) {
              this.company_users.push(this.getAuthenticatedUser);
            }
          }
          let owner = this.company_users.find((e) => e._id == this.getAuthenticatedUser._id);
          if (
            this.formBuilder.form_builder_owners.length == 0 ||
            this.formBuilder.settings.success_and_redirect_page.mail_recievers.length == 0
          ) {
            this.formBuilder.form_builder_owners[0] = owner._id;
            this.formBuilder.settings.success_and_redirect_page.mail_recievers[0] = owner._id;
          }
          if (!this.formBuilder.contact_email) {
            this.formBuilder.contact_email = owner._id;
          }
        } catch (err) {
          this.$notify.error({
            title: 'Error',
            message: err,
          });
        }
      },
      async checkMailRecievers() {
        try {
          this.formBuilder.settings.success_and_redirect_page.mail_recievers.forEach((user) => {
            if (!this.formBuilder.form_builder_owners.includes(user)) {
              this.formBuilder.settings.success_and_redirect_page.mail_recievers.splice(
                this.formBuilder.settings.success_and_redirect_page.mail_recievers.indexOf(user),
                1
              );
            }
          });
        } catch (err) {
          this.$notify.error({
            title: 'Error',
            message: err,
          });
        }
      },
      async fetchCompanyGroups() {
        try {
          const groups = await fetchGroups({
            get_all: true,
          });
          if (groups?.data) {
            this.getAllEntityGroupsData = [...groups.data];
          }
        } catch (e) {
          console.log('fetchCompanyGroups', e);
        }
      },
      /*  ***Fetch Groups  end  **** */
      async addGroupPopUP() {
        this.showAddGroupDialog = true;

        await this.$store.dispatch('entityGroups/resetErrors');
      },
      async saveGroup() {
        if (!this.groupName) {
          this.$message.info('Please Enter the group name');
          return;
        }
        this.loadingSaveGroup = true;
        await this.$store.dispatch('entityGroups/addEntityGroup', {
          name: this.groupName,
          description: '',
          entities: [],
        });
        if (this.getSingleEntityGroupData && this.getSingleEntityGroupData.success) {
          await addSingleGroupToLocal(this.getSingleEntityGroupData.data);
          this.fetchCompanyGroups();
          this.formBuilder.groups.push(this.getSingleEntityGroupData.data._id);
          this.loadingSaveGroup = false;
          this.groupName = '';
          this.showAddGroupDialog = false;
          this.templateGroups.push(this.getSingleEntityGroupData.data._id);
        } else if (this.getError && !this.getError.success) {
          this.loadingSaveGroup = false;
          let msg =
            this.getError && this.getError.message ? this.getError.message : 'Something went wrong';
          this.$message.warning(msg);
        }
      },
      getAvailableFields() {
        const selected = this.formBuilder?.customization?.selected_fields || [];
        return this.getMappedFormbuilderFields().filter((f) => !selected.includes(f.key));
      },
      getFieldLabel(key) {
        const field = this.getMappedFormbuilderFields().find((f) => f.key === key);
        return field ? field.label : key;
      },
      removeField(key) {
        const index = this.formBuilder.customization.selected_fields.indexOf(key);
        if (index > -1) {
          this.formBuilder.customization.selected_fields.splice(index, 1);
        }
      },
      popField() {
        this.formBuilder.customization.selected_fields.pop();
      },
      addOptionToList() {
        const field = this.ConcatenateFields;
        if (!Array.isArray(this.formBuilder?.customization?.selected_fields)) {
          this.$set(this.formBuilder.customization, 'selected_fields', []);
        }
        const selected = this.formBuilder.customization.selected_fields;
        if (field && !selected.includes(field)) {
          selected.push(field);
          this.ConcatenateFields = '';
        } else if (!field) {
          this.$message.error('Please select a field!');
        } else {
          this.$message.warning('Field already added!');
        }
      },
      async openFormBuilderSettings(user, index) {
        try {
          if (user) {
            let userIdentifier = null;
            if (user.user_type === 'APPLICATION') {
              userIdentifier = user.application_user_type;
            } else if (user.user_type === 'COMPANY') {
              userIdentifier = user.company_user_type;
            } else if (user.user_type === 'LINKED_FIELD') {
              userIdentifier = user.approval_linked_field;
            } else if (user === 'ENTITY') {
              userIdentifier = user;
            } else if (user === 'USER') {
              userIdentifier = user;
            }

            if (userIdentifier) {
              if (user.selected_entity_filter) {
                this.selectedUserAndFilter = `${userIdentifier}#${user.selected_entity_filter}#${index}`;
              } else if (userIdentifier === 'USER' && Array.isArray(index)) {
                this.selectedUserAndFilter = `${userIdentifier}#${index.join('#')}`;
              } else {
                this.selectedUserAndFilter = `${userIdentifier}#${index}`;
              }
            }
          }
          const existingCustomization =
            this.formBuilder?.field_level_permissions?.[this.selectedUserAndFilter] || {};
          this.selectedFormBuilderCustomization = JSON.parse(JSON.stringify(existingCustomization));
          this.fieldLevelPermissionsModal = true;
        } catch (err) {
          return err;
        }
      },
      saveCustomization() {
        this.fieldLevelPermissionsModal = false;
      },
      handleUpdate(newCustomization) {
        try {
          if (!this.formBuilder.field_level_permissions) {
            this.$set(this.formBuilder, 'field_level_permissions', {});
          }
          this.$set(
            this.formBuilder.field_level_permissions,
            this.selectedUserAndFilter,
            newCustomization
          );
          this.fieldLevelPermissionsModal = false;
        } catch (err) {
          return err;
        }
      },
    },
    created() {
      bus.$on('date_range', (data) => {
        if (data === 'TOMARROW') {
          const end = new Date();
          const start = new Date();
          var newDate = moment(end).add(1, 'days');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'WEEK') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(7, 'days');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'BIWEEKLY') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(15, 'days');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'MONTHLY') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(1, 'months');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'QUARTERLY') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(3, 'months');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'HALFYEARLY') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(6, 'months');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        if (data === 'YEARLY') {
          const end = new Date();
          const start = new Date();
          newDate = moment(end).add(1, 'years');
          this.formBuilder.settings.formbuilder_date_range = [start, newDate];
        }
        const start = new Date();
        this.formBuilder.settings.formbuilder_date_range = [start, newDate];
      });
    },
    watch: {
      'formBuilder.customization.isFormLabel'(newVal) {
        if (!newVal) {
          this.formBuilder.customization.separator = '';
          this.formBuilder.customization.selected_fields = [];
        }
      },
      'formBuilder.customization.default_font_type': {
        immediate: true,
        handler(newVal) {
          const availableFonts = fonts?.fontTypes || [];
          if (!availableFonts.length) {
            return;
          }
          const isValidSelection = availableFonts.some((font) => font.value === newVal);
          if (!isValidSelection) {
            this.$set(this.formBuilder.customization, 'default_font_type', availableFonts[0].value);
          }
        },
      },
      async 'formBuilder.steps'(newVal) {
        if (newVal && newVal.length) {
          const allFields = await this.getAllFormBuilderFieldsOriginal(this.types);
          this.allFormBuilderOriginalFields = allFields;
        }
      },
      entitydataformsetting: {
        deep: true,
        handler(newVal) {
          if (this.fromEntityData && newVal) {
            this.formBuilder = newVal;
            console.log('Watcher - Updated form builder:', newVal);
          }
        },
      },
      'formBuilder.customization.settingEntity': {
        handler(newId) {
          if (newId) this.loadEntityName(newId);
          else this.settingEntityName = '';
        },
        immediate: true,
      },
    },
  };
</script>
<style lang="scss" scoped>
  .settings-formBuilder {
    margin: 0 8px 8px;
  }

  .fixed-col {
    position: fixed;
    top: 132px;
    right: 30px;
    width: 523px;
  }

  .icons-component {
    margin: 0px;
  }

  .logo-image-upload {
    margin: 20px;
  }

  .workflow-view {
    .pageTopBar {
      padding: 0.5em 1em;
      border: 1px solid #d8d8fc;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      min-height: 65px;
      display: flex;
      align-items: center;

      & > div {
        width: 100%;
      }
    }

    .up-down-arrow {
      button {
        padding: 2px;
      }
    }

    .el-button.is-circle {
      padding: 4px;
    }

    .flip-list-move {
      transition: transform 1s;
    }

    .text-right {
      text-align: right;
      margin: 2em 0em;

      .el-button {
        padding: 0.75em 2em;
        font-size: 1.125em;
        text-align: center;
        border-radius: 30px !important;
      }
    }

    .workflow-details {
      position: relative;
      z-index: 20;
      max-height: 85vh;
      height: fit-content;
      overflow-y: scroll;
      scrollbar-width: thin;

      @media (max-width: 750px) {
        width: 88vw !important;
        position: relative;
        right: 6.5rem;
      }

      .label {
        font-size: 14px;
        color: #606266;
        line-height: 30px;
        padding: 0 12px 0 0;
      }

      .error {
        font-size: 14px;
        color: #df0e0e;
        margin-top: -10px !important;
      }
    }

    .inner-navbar {
      display: block;
      margin-bottom: 1em;
      height: 50px;

      h3 {
        font-weight: 400;
        font-size: 1.25em;
        line-height: 50px;
      }
    }

    // Work flow step
    .workflow-steps {
      position: relative;
      margin: 1rem auto;
      max-height: calc(100vh - 100px);
      overflow-y: auto;

      #field-group {
        & > div:last-child {
          padding-bottom: 35px;
          position: relative;

          &:after {
            content: 'END';
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 70px;
            display: block;
            margin: 0 auto;
            padding: 0.5em 1.5em;
            border-radius: 5px;
            text-align: center;
            font-weight: 600;
            letter-spacing: 1px;
            color: #ff3a79;
          }
        }
      }

      .el-button {
        span {
          font-size: 1.2em;
        }
      }

      .sub-heading {
        font-weight: 500;
        color: var(--brand-500);
        margin-bottom: 10px !important;
      }

      .each-step {
        cursor: pointer;
        position: relative;
        z-index: 10;
        display: block;
        max-width: 30em;
        background: #fdfdfd;
        border: 1px solid var(--brand-500);
        box-sizing: border-box;
        border-radius: 8px;
        color: #303133;
        padding: 0;
        padding: 0;
        margin: 0 auto 3.5em;

        .inner-wrap {
          display: flex;
        }

        .delete-icon {
          padding: 4px;
        }

        &::after {
          content: '';
          position: absolute;
          bottom: -3em;
          left: calc(50% - 1px);
          width: 1px;
          height: 3em;
          background-color: var(--brand-500);
        }

        .arrow-down {
          position: absolute;
          left: calc(50% - 8px);
          bottom: -3em;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid var(--brand-500);
          z-index: 10;
        }

        .icon-template {
          border-radius: 9px 0 0 9px;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            max-width: 2.25em;
          }
        }

        .content {
          padding: 0.85em 0 0.85em 1em;

          .main-title {
            font-weight: 500;
            font-size: 0.8em;
            color: #2f80ed;
            display: block;
            letter-spacing: 0.5px;
            text-transform: uppercase;
          }

          .sub-title {
            color: #000577;
            font-size: 1.15em;
          }
        }

        .action-action {
          min-width: 110px;
          display: flex;
          align-items: center;
          justify-items: flex-end;
          justify-content: flex-end;
          padding: 0.5em 0.25em 0.5em 0.75em;

          .template-box,
          .documents-box {
            display: flex;
            align-items: center;
            margin-right: 0.5em;

            .el-button {
              padding: 4px;
              margin-left: 0.5em;
            }

            .el-tag {
              padding: 0.4em 0.65em;
              line-height: 1;
              height: auto;
              border-radius: 1em;
            }
          }
        }
      }
    }

    .uploader {
      max-height: 70vh;
      overflow-y: auto;
      scrollbar-width: thin;
    }
  }
</style>
<style lang="scss" scoped>
  .block {
    padding: 30px 0;
    text-align: center;
    border-right: solid 1px var(--el-border-color);
    flex: 1;
  }

  .block:last-child {
    border-right: none;
  }

  .block .demonstration {
    display: block;
    color: var(--el-text-color-secondary);
    font-size: 14px;
    margin-bottom: 20px;
  }

  .workflow-details {
    margin-top: 1em;

    .el-input__inner {
      line-height: 55px;
      border-radius: 10px;
      border-color: #cacaca;
    }

    .el-form-item__label {
      line-height: 30px;
    }

    .el-input-group--prepend .el-input-group__prepend {
      background-color: #eeeeff !important;
      border: 1px solid #cacaca !important;
      border-right: none !important;
      box-shadow: none !important;
      padding: 0;
      min-width: 80px;
      border-radius: 10px 0 0 10px;

      .el-button {
        display: block;
        margin: 0 auto;
        padding: 0;
      }

      .icon-dropdown-selection {
        margin-right: 0;

        i {
          color: #2f80ed;
        }
      }
    }
  }

  .select-steps-form {
    position: relative;
    background-color: #fafafa;
    padding: 1em 2em;
    border-radius: 0;
    box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.03);
    border-right: 1px solid #f9f9f9;
    z-index: 10;
    height: calc(100vh - 75px);
    overflow-y: auto;

    .each-widget {
      background: #ffffff;
      border: 1px solid #dbe5ee;
      border-radius: 12px;
      padding: 8px 0px 8px 8px;
      margin-bottom: 1em;
      max-height: 300px;
      overflow: auto;

      .scrollable {
        padding: 0 5px;

        .list-item {
          border-radius: 6px;
          border: 1px solid #00000014;
          background: #f8f8f8;
          box-sizing: border-box;
          padding: 7px;
          color: #4f4f4f;
          width: 100%;
          text-align: left;
          transition: all 0.3s ease-in-out;
          font-weight: 400 !important;

          &.is-disabled {
            border: 1px solid var(--brand-500);
            background: var(--brand-100);
            cursor: not-allowed;

            &:hover {
              color: #4f4f4f;
            }
          }

          &:hover {
            border: 1px solid var(--brand-500);
            background: var(--brand-100);
          }

          & > span {
            gap: 10px;
            display: flex;
            align-items: center;
          }

          svg {
            width: 1.25rem !important;
            height: 1.25rem !important;
          }
        }
      }
    }

    .divider {
      display: block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      line-height: 40px;
      text-align: center;
      background-color: #f2f7fc;
      margin: 40px auto 0px;
    }

    .sub-heading {
      color: #4c4b4e;
      font-style: normal;
      font-weight: normal;
      font-size: clamp(13px, 0.8vw, 17px);
    }
  }

  .el-step__title {
    font-weight: 400 !important;
  }

  .workflow-view {
    .workflow-index {
      .el-step__title {
        line-height: 30px;
        font-weight: 400;
        font-size: 12px !important;
        letter-spacing: 0.5px;
      }

      .el-step__title.is-process {
        font-weight: 400 !important;
        color: #000577;
      }

      .el-step__head.is-wait,
      .el-step__title.is-wait {
        cursor: not-allowed;
      }

      .el-step.is-horizontal {
        .el-step__line {
          top: 18px !important;
          z-index: 0;
        }
      }

      .el-step__head {
        .el-step__icon {
          height: 40px;
          width: 40px;
          cursor: pointer;
        }

        &.is-process {
          color: #000577;
          font-weight: 400;

          .el-step__icon {
            border: 1px solid #000577;
          }
        }

        &.is-wait {
          .el-step__icon {
            cursor: not-allowed;
          }
        }
      }
    }

    .el-form-item {
      margin-bottom: 5px;
    }

    .template-editor {
      margin-top: 0px !important;
      border-color: #c0c4cc !important;
      border-radius: 10px !important;
      background-color: #ffffff !important;
      margin-bottom: 1.5em;

      .menubar {
        border-radius: 9px 9px 0 0;
        display: none !important;
      }
    }
  }

  .settings-selection-dialog {
    height: 300px;
  }

  .document-selection-box {
    height: 300px;
  }

  .document-selection-dialog {
    .vue-data-table-default {
      margin-bottom: 0px;
    }

    .submit-block {
      padding-bottom: 1em;
      border-bottom: 1px solid #efefef;
      margin-bottom: 1em;
      text-align: center;

      #submitButton {
        padding: 0.5em 1em;
        font-size: 1.25em;
        min-width: 200px;
      }
    }

    .el-dialog {
      background-color: #f8f9fa;

      .el-dialog__body {
        max-height: calc(100vh - 115px);
      }
    }

    .el-input__inner:focus {
      border-color: #495df7;
      color: var(--brand-500);
    }

    .el-input__inner:hover {
      border-color: #7080f7;
    }

    .table-scrollable {
      border-left: 1px solid #e8f1fd;
      border-right: 1px solid #e8f1fd;
      margin-top: 1em;
      border-radius: 3px;
    }

    .dialog-sub-title {
      font-weight: 500;
      font-size: 1.25em;
    }

    .selected-docx {
      .scrollable-min {
        max-height: 22vh;
        overflow: auto;
        border: 1px solid #e8f1fd;
        margin-top: 1em;
        border-radius: 3px;

        .card-title {
          font-weight: 400;
          padding: 0.65em 1em;
          text-align: center;
        }

        .el-card__body {
          padding: 0;

          .each-document {
            padding: 0.65em 1em;
          }

          h4 {
            font-weight: 400;
          }

          .el-button {
            padding: 4px;
          }
        }
      }
    }

    .vue-data-table-default tbody tr td:last-child .cell .el-button {
      background-color: #409eff !important;
      color: #ffffff !important;

      &.is-disabled {
        opacity: 0.75;
      }
    }
  }

  .workflow-view {
    // Topbar Steps
    .steps-radio-group ::v-deep {
      .el-radio-button {
        .el-radio-button__inner {
          border-color: #dcdfe6 !important;
        }

        &:focus,
        &.is-active {
          box-shadow: none;

          .el-radio-button__inner {
            color: #fff !important;
            background-color: #1b487e !important;
            border-color: #1b487e !important;
            -webkit-box-shadow: -1px 0 0 0 #1b487e;
          }
        }
      }
    }
  }

  .ul1 {
    columns: 6;
  }

  .ul2 {
    columns: 3;
  }

  .ul3 {
    columns: 4;
  }

  .ul4 {
    columns: 2;
  }

  .bgcolor {
    background-color: #e1e4e8;
  }

  .ht {
    height: 500px;
  }

  .el-card {
    height: 800px !important;
  }

  .el-checkbox {
    margin-right: 20px !important;
  }

  @media screen and (min-device-width: 1440px) and (max-device-width: 1920px) {
    /* STYLES HERE */
    .el-card {
      height: 670px !important;
    }
  }

  .logo-edit {
    border: 1px solid var(--brand-100);
    border-radius: 6px !important;
    text-align: center;

    .edit-box {
      text-align: right;
    }
  }

  @media (max-width: 998px) {
    .form-heading {
      font-size: 15px;
      font-weight: 500;
    }
  }

  @media (max-width: 750px) {
    .form-heading {
      font-size: 12px;
      font-weight: 500;
      position: relative;
      right: 4rem;
      top: 2.5rem;
    }
  }

  .inner-box {
    width: 85%;
    height: 100%;
    background: #fff;
    border: 2px dashed #d2d2d2;
    padding: 15px;
    margin-left: 70px;
  }

  .try-with-ai {
    display: flex;
    align-items: center;
    width: 75%;
    margin-inline: auto;
    padding: 8px 18px;
    margin-bottom: 20px;
    border-radius: 35px;
    transition: all 0.3s ease;
    border-color: var(--brand-500) !important;
  }

  .custom-icon-style {
    margin-left: 222px;
    color: #2f80ed;
    position: relative;
    top: 10px;
  }
</style>
<style scoped lang="scss">
  .permissions-wrapper {
    font-size: 16px;
    font-weight: 500;
  }

  .permissions-title {
    display: block;
    margin-bottom: 8px;
  }

  .permissions-section {
    margin-bottom: 16px;
  }

  .permissions-subtitle {
    display: inline-block;
    margin-bottom: 6px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #555;
  }

  .checkbox-group-per {
    display: flex;
    gap: 16px;
    margin-left: 20px;
    margin-top: 4px;
  }

  .level-pill {
    display: inline-block;
    padding: 4px 12px;
    background-color: #d4edda;
    color: #155724;
    border-radius: 999px;
    font-weight: bold;
    font-size: 13px;
    text-align: center;
    white-space: nowrap;
  }

  .tooltip-content {
    margin-top: 10px;
    background-color: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }

  .alignment-buttons {
    display: flex;
    flex-direction: row;
    width: 50vw;
    justify-content: space-between;
  }

  .btn-outline-primary {
    @media (max-width: 767px) {
      position: relative;
      bottom: 10px;
    }
  }

  .btn-outline-primary {
    border: none !important;
    color: white !important;
    background: var(--brand-500) !important;

    &:active:focus {
      color: white !important;
      background: var(--brand-500) !important;
      box-shadow: 0 0 0 0.2rem var(--primary-color-brand) !important;
    }
  }
</style>
<style scoped>
  ::v-deep(.detailedTemplatesView .dialog-content) {
    flex-grow: unset !important;
    scrollbar-width: unset !important;
  }

  ::v-deep(.detailedTemplatesView .scrollable-content) {
    overflow: hidden;
  }

  ::v-deep(.detailedTemplatesView .form-builder .form-fields-holder) {
    height: 65vh !important;
  }
</style>

<style>
  .el-checkbox__input + .el-checkbox__label {
    padding-top: 4px !important;
    padding-right: 5px !important;
  }

  #FormBuilderSettingsTabs .el-tabs__item.is-left i {
    padding: 0 10px !important;
  }

  .el-tabs--left .el-tabs__header.is-left {
    margin-right: 20px !important;
    background-color: white !important;
  }

  .el-tabs--left .el-tabs__item.is-left {
    margin: 5px;
    text-align: start;
  }

  .el-tabs--left .el-tabs__item.is-left:hover {
    color: var(--brand-500) !important;
    border-radius: 6px;
    margin: 5px;
    background: var(--brand-100) !important;
  }

  .is-active {
    background-color: var(--brand-100) !important;
    border-radius: 6px;
    margin: 5px;
  }

  .is-active:focus {
    background-color: none !important;
  }

  .el-tabs__active-bar {
    height: 0px !important;
  }

  .el-form-item__label {
    margin: 0px !important;
  }

  .el-form--label-top .el-form-item__label {
    display: flex;
    padding: 0 0 0px 0px !important;
  }

  .el-color-picker__trigger {
    height: 32px;
  }

  .el-form-item__label {
    line-height: 1.2 !important;
  }
</style>
